/* eslint-disable tree-shaking/no-side-effects-in-initialization -- plugin doesn't handle JSX node */
import { ThemeType } from "@hex/common";
import React from "react";

import { createCustomIcon } from "./createCustomIcon";

/* eslint-disable no-restricted-imports -- needs to be imported here */
export * from "./CellTypeIcons";
export * from "./StatusIcons";
export * from "./XLIcons";
/* eslint-enable no-restricted-imports -- see above */

/** See https://www.notion.so/hexhq/How-to-Adding-a-new-Custom-Icon-914117a2642148e09b257605075dcfc0 for guidance */

export const AskForApprovalIcon = createCustomIcon({
  name: "ask for approval",
  category: "Agent / Actions",
  path: (
    <path
      d="M4.5039 3.19916C4.50397 2.79781 4.65983 2.41274 4.93736 2.12894C5.21492 1.84515 5.59146 1.68574 5.98396 1.6857C6.21401 1.6857 6.43828 1.74139 6.64063 1.84386C6.71899 1.67336 6.83086 1.52175 6.96757 1.39589C7.10685 1.26771 7.26974 1.16837 7.44549 1.10134C7.6213 1.03432 7.80873 1 7.99657 1C8.1843 1.00004 8.37103 1.03436 8.54673 1.10134C8.72256 1.16837 8.88531 1.26766 9.02464 1.39589C9.1613 1.52166 9.27228 1.67349 9.35066 1.84386C9.55321 1.74114 9.77791 1.6857 10.0083 1.6857C10.4008 1.68572 10.7773 1.84515 11.0549 2.12894C11.3234 2.40356 11.4758 2.77308 11.4855 3.16033C11.6545 3.0934 11.8353 3.05711 12.0199 3.0571C12.4124 3.0571 12.789 3.21665 13.0665 3.50034C13.344 3.78409 13.4999 4.16928 13.5 4.57056V10.3999C13.5 11.6197 13.0263 12.7897 12.183 13.6523C11.3395 14.5148 10.1953 14.9999 9.00242 15H7.66036C7.63923 15 7.61872 14.9961 7.59831 14.9934C6.92327 14.9624 6.26269 14.7783 5.66627 14.4497C5.09258 14.1337 4.59399 13.6945 4.20382 13.1636L4.04266 12.9296L3.91022 12.7222C3.69014 12.3767 2.94508 11.0482 1.69014 8.76715C1.50121 8.42367 1.45065 8.0182 1.54935 7.63726C1.64809 7.25637 1.88855 6.92982 2.21899 6.7271C2.54887 6.5247 2.93562 6.44057 3.31745 6.48843C3.69925 6.53638 4.05478 6.71345 4.327 6.99134L4.5039 7.17224V3.19916ZM5.45232 8.34285C5.45232 8.53896 5.33681 8.71576 5.15965 8.79083C4.98245 8.86588 4.77846 8.82438 4.64283 8.6857L3.65737 7.67799C3.53475 7.55275 3.3746 7.47236 3.20261 7.45068C3.0735 7.43447 2.94269 7.4518 2.82287 7.49993L2.70709 7.55865C2.58837 7.63144 2.50181 7.7486 2.46628 7.8854C2.4308 8.02229 2.44932 8.16828 2.51722 8.29171C3.7824 10.5914 4.50638 11.8811 4.70489 12.1928V12.1937C4.7479 12.2614 4.7912 12.329 4.83455 12.3964C5.15789 12.8985 5.59885 13.3104 6.1164 13.5955C6.63359 13.8803 7.21186 14.0301 7.79929 14.0302H9.00242C9.94374 14.0301 10.8468 13.6472 11.5124 12.9666C12.1779 12.2859 12.5516 11.3625 12.5516 10.3999V4.57056C12.5515 4.4265 12.4956 4.28791 12.396 4.18604C12.2963 4.08423 12.1609 4.02692 12.0199 4.02692C11.879 4.02695 11.7436 4.08419 11.6439 4.18604C11.546 4.28613 11.4903 4.42167 11.4883 4.56298V7.65715C11.4883 7.92492 11.276 8.14206 11.0141 8.14206C10.7523 8.14204 10.5399 7.9249 10.5399 7.65715V3.19916C10.5398 3.05503 10.484 2.91656 10.3843 2.81464C10.2846 2.71273 10.1492 2.65555 10.0083 2.65553C9.8673 2.65553 9.73194 2.71276 9.63223 2.81464C9.53386 2.91522 9.47813 3.0514 9.47663 3.19348V7.65715C9.47658 7.92486 9.2642 8.14196 9.00242 8.14206C8.74054 8.14206 8.52825 7.92492 8.52821 7.65715V2.41118C8.52821 2.36093 8.51719 2.30938 8.49486 2.25964C8.47234 2.20959 8.4376 2.16025 8.3902 2.11663C8.34271 2.07293 8.28341 2.03563 8.21515 2.00961C8.14707 1.98371 8.07268 1.96987 7.99657 1.96983C7.92026 1.96983 7.84531 1.98361 7.77706 2.00961C7.70879 2.03563 7.64951 2.07292 7.60201 2.11663C7.55468 2.16022 7.51986 2.20963 7.49735 2.25964C7.47506 2.30935 7.46494 2.36097 7.46494 2.41118V3.64524C7.46494 3.64809 7.46406 3.65093 7.46401 3.65377V7.65715C7.46396 7.92492 7.25167 8.14206 6.9898 8.14206C6.72806 8.14191 6.51564 7.92482 6.51559 7.65715V3.19916C6.51553 3.05503 6.45966 2.91656 6.35999 2.81464C6.26028 2.71278 6.12491 2.65553 5.98396 2.65553C5.84299 2.65557 5.70761 2.71272 5.60792 2.81464C5.50825 2.91656 5.45238 3.05503 5.45232 3.19916V8.34285Z"
      fill="currentColor"
    />
  ),
});

export const DashIcon = createCustomIcon({
  name: "Dash",
  category: "General / Misc",
  path: <rect fill="currentColor" height="1" rx="0.5" width="8" x="4" y="7" />,
});

export const DynamicIcon = createCustomIcon({
  name: "Dynamic",
  category: "Project / Misc",
  tags: ["interlinked", "refs"],
  transform: "translate(0.000000, 3.000000)",
  path: (
    <>
      <path
        d="M14.5318738,1.45018858 C13.5875216,0.50677053 12.3384959,-0.00657995787 11.0062697,0.00024651139 C11.0057613,0.00024651139 11.0050835,0 11.0045752,0 C10.9949164,0 10.9944081,0.00024651139 10.9938997,0.00024651139 C9.66319855,-0.00538532575 8.41264784,0.50677053 7.46829565,1.45018858 C6.52157115,2.39616656 6,3.65667411 6,4.99978193 C6,5.30833834 6.19346257,5.6 6.5,5.6 C6.80653743,5.6 7,5.30833834 7,4.99978193 C7,3.95703875 7.51472531,2.97812306 8.24980512,2.24376563 C8.98471548,1.50923754 9.96448299,0.99607478 10.9954248,1 C11.0122005,1.00017066 11.0242315,1 11.036432,1 C12.059918,1 13.0224014,1.51691732 13.7500254,2.24376563 C14.4851052,2.97829372 15,3.95703875 15,4.99978193 C15,6.04252511 14.4849357,7.02161146 13.7498559,7.75596889 C13.0224014,8.48281721 12.0600874,9 11.036432,9 C11.0257566,9 11.0150811,9.00017066 11.0044057,9 C10.6944793,8.99675743 10.4025418,9.19127293 10.4,9.5 C10.3974582,9.80855641 10.6888874,9.99744007 10.9954248,10.0000758 C11.0091504,10.0000758 11.0230454,10.0000758 11.0367709,10.0000758 C12.3547633,10.0000758 13.5944691,9.48596687 14.5315349,8.54988727 C15.4784288,7.60407995 16,6.34340174 16,5.00012326 C16.0001694,3.65650344 15.4787677,2.3959959 14.5318738,1.45018858 Z"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
      <path
        d="M9.5,4.4 C9.19363204,4.4 9,4.69157614 9,5.00014193 C9,6.04308748 8.485613,7.02186226 7.75053324,7.75624201 C7.02290933,8.48311242 6.06025647,9 5.03660114,9 C5.0259257,9 5.01541972,9.00017067 5.00474429,9 C3.95719632,9.01518936 2.98522364,8.49062177 2.24997443,7.75624201 C1.51489467,7.02186226 1,6.04308748 1,5.00014193 C1,3.95736706 1.51489467,2.97842161 2.24997443,2.24404185 C2.98522364,1.50949143 3.96431328,0.995733327 4.99559392,1 C5.29636999,1.00068267 5.59745823,0.808736457 5.6,0.5 C5.60254177,0.191263543 5.31111225,0.0026732044 5.00457484,0.000113200611 C3.66540118,-0.00876147919 2.41502,0.504433947 1.46829556,1.45027001 C0.521571117,2.39627675 0,3.65682261 0,4.99997127 C0,6.34311992 0.521401665,7.60383645 1.46812611,8.54967252 C2.40519182,9.48595124 3.64506702,10 4.96339817,10 C4.97559867,10 4.98779916,10 5,9.99982933 C5.01220015,10 5.02440064,10 5.03660114,10 C6.35476284,10 7.59480749,9.48578057 8.53170375,8.54967252 C9.47859764,7.60383645 10,6.34311992 10,4.99997127 C10.0003382,4.69140548 9.80636796,4.4 9.5,4.4 Z"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
    </>
  ),
});

export const SidebarDockIcon = createCustomIcon({
  name: "Sidebar dock",
  category: "General / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M13 2a2 2 0 0 1 2 2v8l-.01.204a2 2 0 0 1-1.786 1.785L13 14H3l-.204-.01a2 2 0 0 1-1.785-1.786L1 12V4a2 2 0 0 1 2-2h10ZM3 3a1 1 0 0 0-.995.897L2 4v8a1 1 0 0 0 1 1h3V3H3Zm10 10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H7v10h6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path d="M2 3h4v10H2z" fill="currentColor" opacity=".2" />
    </>
  ),
});

export const AgentPanelToggleIcon = createCustomIcon({
  name: "Agent panel toggle",
  category: "Magic",
  path: (
    <>
      <path
        d="M13 13C13.5523 13 14 12.5523 14 12V4C14 3.44772 13.5523 3 13 3H9.5V13H13Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path
        d="M13.5 4C13.5 3.72386 13.2761 3.5 13 3.5H10V12.5H13C13.2761 12.5 13.5 12.2761 13.5 12V4ZM2.5 12C2.5 12.2761 2.72386 12.5 3 12.5H9V3.5H3C2.72386 3.5 2.5 3.72386 2.5 4V12ZM14.5 12C14.5 12.8284 13.8284 13.5 13 13.5H3C2.17157 13.5 1.5 12.8284 1.5 12V4C1.5 3.17157 2.17157 2.5 3 2.5H13C13.8284 2.5 14.5 3.17157 14.5 4V12Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CommentBubbleIcon = createCustomIcon({
  name: "Comment bubble",
  category: "Cells / Actions",
  path: (
    <>
      <path
        d="M13.571 1A1.427 1.427 0 0 1 15 2.428v8.143A1.43 1.43 0 0 1 13.572 12H13v2.287a.5.5 0 0 1-.793.405L8.981 12H2.43A1.429 1.429 0 0 1 1 10.573V2.429A1.43 1.43 0 0 1 2.429 1H13.57Z"
        fill="currentColor"
        fillOpacity="0.15"
      />
      <path
        clipRule="evenodd"
        d="M2 3.5A1.5 1.5 0 0 1 3.5 2h9A1.5 1.5 0 0 1 14 3.5V11a1.5 1.5 0 0 1-1.5 1.5h-1.793l-2.146 2.146a1.207 1.207 0 0 1-2.061-.853V12.5h-3A1.5 1.5 0 0 1 2 11V3.5ZM3.5 3a.5.5 0 0 0-.5.5V11a.5.5 0 0 0 .5.5H7a.5.5 0 0 1 .5.5v1.793a.207.207 0 0 0 .354.146l2.292-2.293a.5.5 0 0 1 .354-.146h2a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const CommentBubbleSmallIcon = createCustomIcon({
  name: "Comment bubble (small)",
  category: "Cells / Actions",
  path: (
    <path
      d="M8 14v-2.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-1.75L8 14Z"
      fill="currentColor"
      fillOpacity="0.2"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  ),
});

export const SplitScreenIcon = createCustomIcon({
  name: "Split screen",
  category: "Project / View",
  tags: ["navigation"],
  transform: "translate(0.000000, 0.000000)",
  path: (
    <path
      clipRule="evenodd"
      d="M8.5 2.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11ZM2 3a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 0 1H3v9h2a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 13V3Zm12 0a.5.5 0 0 0-.5-.5H11a.5.5 0 0 0 0 1h2v9h-2a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 .5-.5V3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CellAndAboveIcon = createCustomIcon({
  name: "Run: Cell and above",
  category: "Cells / Run states",
  transform: "translate(2.000000, 2.000000)",
  path: (
    <>
      <path
        d="M1.43392 2.8582L5.39538 5.49918L5.38738 5.51518L5.75465 5.76003C5.85654 5.82795 5.9 5.91513 5.9 6C5.9 6.08487 5.85654 6.17205 5.75465 6.23997L5.38738 6.48482L5.39538 6.50082L1.43392 9.14179L1.42592 9.12579L0.95465 9.43997C0.883707 9.48727 0.835883 9.5 0.8 9.5C0.636142 9.5 0.5 9.36386 0.5 9.2V2.8C0.5 2.63614 0.636142 2.5 0.8 2.5C0.835883 2.5 0.883707 2.51273 0.95465 2.56003L1.42592 2.8742L1.43392 2.8582Z"
        fill="none"
        stroke="currentColor"
      />
      <path
        d="M12.1292 4.04598L12.4647 4.41675L13.2062 3.74584L12.8708 3.37507L12.1292 4.04598ZM10.5 1.5L10.8708 1.16454L10.5 0.754747L10.1292 1.16454L10.5 1.5ZM8.12923 3.37507L7.79378 3.74584L8.53531 4.41675L8.87077 4.04598L8.12923 3.37507ZM12.8708 3.37507L10.8708 1.16454L10.1292 1.83546L12.1292 4.04598L12.8708 3.37507ZM10.1292 1.16454L8.12923 3.37507L8.87077 4.04598L10.8708 1.83546L10.1292 1.16454ZM10 1.5L10 10L11 10L11 1.5L10 1.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const CellAndBelowIcon = createCustomIcon({
  name: "Run: Cell and below",
  category: "Cells / Run states",
  transform: "translate(2.000000, 3.000000)",
  path: (
    <>
      <path
        d="M1.43392 1.8582L5.39538 4.49918L5.38738 4.51518L5.75465 4.76003C5.85654 4.82795 5.9 4.91513 5.9 5C5.9 5.08487 5.85654 5.17205 5.75465 5.23997L5.38738 5.48482L5.39538 5.50082L1.43392 8.14179L1.42592 8.12579L0.95465 8.43997C0.883707 8.48727 0.835883 8.5 0.8 8.5C0.636142 8.5 0.5 8.36386 0.5 8.2V1.8C0.5 1.63614 0.636142 1.5 0.8 1.5C0.835883 1.5 0.883707 1.51273 0.95465 1.56003L1.42592 1.8742L1.43392 1.8582Z"
        fill="none"
        stroke="currentColor"
      />
      <path
        d="M8.85355 6.64645L8.5 6.29289L7.79289 7L8.14645 7.35355L8.85355 6.64645ZM10.5 9L10.1464 9.35355L10.5 9.70711L10.8536 9.35355L10.5 9ZM12.8536 7.35355L13.2071 7L12.5 6.29289L12.1464 6.64645L12.8536 7.35355ZM8.14645 7.35355L10.1464 9.35355L10.8536 8.64645L8.85355 6.64645L8.14645 7.35355ZM10.8536 9.35355L12.8536 7.35355L12.1464 6.64645L10.1464 8.64645L10.8536 9.35355ZM11 9L11 0.5L10 0.5L10 9L11 9Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AutoIcon = createCustomIcon({
  name: "Run: Auto",
  category: "Cells / Run states",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M14 8c0-.35-.19-.64-.46-.82l-6-4A.969.969 0 0 0 7 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1 .21 0 .39-.08.54-.18l6-4c.27-.18.46-.47.46-.82Z"
        fill="currentColor"
        fillOpacity="0.4"
        strokeWidth="0"
      />
      <path
        clipRule="evenodd"
        d="M7 4.022v7.956L12.967 8 7 4.022Zm6.54 4.798-6.002 4.002a1.13 1.13 0 0 1-.27.134A.85.85 0 0 1 7 13c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1a.85.85 0 0 1 .268.044c.099.033.189.08.27.134L13.54 7.18c.27.18.46.47.46.82s-.19.64-.46.82ZM5 5.329 3.928 4.64 3 4.022v7.956l.938-.598L5 10.67v1.202l-.611.408-.69.446-.161.095a1.13 1.13 0 0 1-.27.134A.85.85 0 0 1 3 13c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1a.85.85 0 0 1 .268.044c.099.033.189.08.27.134l.002.002.147.09.702.449.611.408v1.202Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const StaleIcon = createCustomIcon({
  name: "Run: Stale",
  category: "Cells / Run states",
  path: (
    <>
      <path
        d="M3 12V7L6 4L10 8L13 4V9L10 13L6 9L3 12Z"
        fill="currentColor"
        fillOpacity="0.2"
      />
      <path d="M3 7L6 4L10 8L13 4" fill="none" stroke="currentColor" />
      <path d="M3 12L6 9L10 13L13 9" fill="none" stroke="currentColor" />
    </>
  ),
});

export const AppIcon = createCustomIcon({
  name: "App builder",
  category: "Project / View",
  path: (
    <path
      clipRule="evenodd"
      d="M8 2H2L2 14H8V2ZM9 2V8H14V2H9ZM9 9V14H14V9H9ZM2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1H2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AppToggleIcon = createCustomIcon({
  name: "App toggle",
  category: "Cells / Actions",
  path: (
    <>
      <rect
        fill="currentColor"
        height="10"
        opacity="0"
        width="10"
        x="3"
        y="3"
      />
      <path
        clipRule="evenodd"
        d="M8 3H3L3 13H8V3ZM9 3V8H13V3H9ZM9 9V13H13V9H9ZM3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const AppPreviewIcon = createCustomIcon({
  name: "App preview",
  category: "Project / Actions",
  path: (
    <>
      <path
        d="M13 2a1 1 0 0 1 1 1v5.763l-1-.667V4H3v9h6.5v.5c0 .171.023.339.064.5H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10Z"
        fill="currentColor"
      />
      <path
        d="M11.127 6.167a.5.5 0 0 1 .746.666l-.555.675A2 2 0 0 0 9.5 9.5v.188a.682.682 0 0 1-.717.063l-2.15-1.032-1.75 2.101a.5.5 0 0 1-.767-.64l2-2.4a.498.498 0 0 1 .6-.13l2.311 1.123 2.1-2.606Z"
        fill="currentColor"
      />
      <path
        d="M11.127 6.167a.496.496 0 0 1 .87.335L12 6.5v1.063A2 2 0 0 0 9.5 9.5V12H4v-1.5l.002-.003c0-.112.037-.224.114-.317l2-2.4a.5.5 0 0 1 .6-.13L9 9l2.127-2.833Z"
        fill="currentColor"
        opacity="0.3"
      />
      <path
        clipRule="evenodd"
        d="M11.028 14.382a1 1 0 0 1-.528-.882v-4a1 1 0 0 1 1.555-.832l3 2a1 1 0 0 1 0 1.664l-3 2a1 1 0 0 1-1.027.05ZM14.5 11.5l-3-2v4l3-2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const NotebookIcon = createCustomIcon({
  name: "Notebook",
  category: "Project / View",
  path: (
    <path
      clipRule="evenodd"
      d="M2 2H14V5H2L2 2ZM1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V5C15 5.55229 14.5523 6 14 6H2C1.44772 6 1 5.55228 1 5V2ZM2 8H14V14H2L2 8ZM1 8C1 7.44771 1.44772 7 2 7H14C14.5523 7 15 7.44772 15 8V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const WorkbenchIcon = createCustomIcon({
  name: "Workbench",
  category: "Project / View",
  path: (
    <path
      clipRule="evenodd"
      d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12ZM7 14h7V6H7v8Zm-5 0h4V2H2v12Zm5-9h3V2H7v3Zm4 0h3V2h-3v3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PreviewIcon = createCustomIcon({
  name: "Preview",
  category: "Project / View",
  path: (
    <path
      clipRule="evenodd"
      d="M14 10a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h12ZM2 14h12v-3H2v3ZM13 1a1 1 0 0 1 1 1v6a1 1 0 0 1-.898.995L13 9H3l-.103-.005A1 1 0 0 1 2 8V2a1 1 0 0 1 1-1h10ZM3 8h10V2H3v6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ConversationViewIcon = createCustomIcon({
  name: "Conversation view",
  category: "Project / View",
  tags: ["navigation", "duotone"],
  path: (
    <>
      <path
        d="M10.4999 8.50003C10.4999 9.0523 10.0522 9.5 9.49991 9.5H5.4999H6.49989V12.5C6.49989 13.0523 6.94761 13.5 7.49989 13.5H10.4999L12.4999 15V13.5H13.4999C14.0521 13.5 14.4999 13.0523 14.4999 12.5L14.4999 7.50001C14.4999 6.94772 14.0522 6.5 13.4999 6.5H10.5L10.4999 8.50003Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path
        d="M14 7.27583C14 7.00921 13.7761 6.79308 13.5 6.79307H11V8.24134C11 9.04116 10.3284 9.68958 9.5 9.68961H7V12.1034C7 12.37 7.22386 12.5861 7.5 12.5861H10.5L10.5801 12.5927C10.6593 12.6052 10.7349 12.6354 10.7998 12.6823L12 13.5507V13.0689C12 12.8023 12.2239 12.5861 12.5 12.5861H13.5C13.7761 12.5861 14 12.37 14 12.1034V7.27583ZM10 2.44827C9.99975 2.18157 9.7757 1.96551 9.5 1.96551H2.5C2.22386 1.96551 2 2.18165 2 2.44827V8.24134C2 8.50796 2.22386 8.72409 2.5 8.72409H3.5C3.77611 8.72414 4 8.94026 4 9.20685V9.97247L5.14648 8.86553L5.22266 8.80518C5.2771 8.77015 5.33817 8.74586 5.40234 8.73352L5.5 8.72409H9.5C9.77611 8.72407 9.99999 8.50794 10 8.24134V2.44827ZM11 5.82756H13.5C14.3284 5.82757 15 6.47598 15 7.27583V12.1034C15 12.9032 14.3284 13.5516 13.5 13.5517H13V14.5172C13 14.7 12.893 14.8672 12.7236 14.949C12.5544 15.0307 12.3517 15.0132 12.2002 14.9037L10.333 13.5517H7.5C6.67157 13.5517 6 12.9032 6 12.1034V9.68961H5.70703L3.85352 11.4792C3.71052 11.6173 3.49543 11.6586 3.30859 11.5839C3.12176 11.5091 3 11.3331 3 11.1379V9.68961H2.5C1.67157 9.68961 1 9.0412 1 8.24134V2.44827C1 1.64841 1.67157 1 2.5 1H9.5C10.3286 1 10.9998 1.6489 11 2.44827V5.82756Z"
        fill="currentColor"
      />
    </>
  ),
});

export const NotebookViewIcon = createCustomIcon({
  name: "Notebook view",
  category: "Project / View",
  tags: ["navigation", "duotone"],
  transform: "translate(0, -28)",
  path: (
    <>
      <path
        d="M1.53906 40.3852C1.53906 40.98 2.02122 41.4621 2.61599 41.4621H13.3852C13.98 41.4621 14.4621 40.98 14.4621 40.3852V33.3852H8.0006H1.53906V40.3852Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path
        d="M13.9231 33.9231H2.07692V40.3846C2.07692 40.682 2.318 40.9231 2.61538 40.9231H13.3846C13.682 40.9231 13.9231 40.682 13.9231 40.3846V33.9231ZM13.9231 29.6154C13.9231 29.318 13.682 29.0769 13.3846 29.0769H2.61538C2.318 29.0769 2.07692 29.318 2.07692 29.6154V32.8462H13.9231V29.6154ZM15 40.3846C15 41.2768 14.2768 42 13.3846 42H2.61538C1.72323 42 1 41.2768 1 40.3846V29.6154C1 28.7232 1.72323 28 2.61538 28H13.3846C14.2768 28 15 28.7232 15 29.6154V40.3846Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AppViewIcon = createCustomIcon({
  name: "App view",
  category: "Project / View",
  tags: ["navigation", "duotone"],
  transform: "translate(0, -55)",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M8.0006 61.9996V65.2304V68.4612H13.3852C13.98 68.4612 14.4621 67.979 14.4621 67.3842V61.9996H8.0006Z"
        fill="currentColor"
        fillOpacity="0.3"
        fillRule="evenodd"
      />
      <path
        d="M7.46154 62.5385H2.07692V67.3846C2.07692 67.682 2.318 67.9231 2.61538 67.9231H7.46154V62.5385ZM13.9231 56.6154C13.9231 56.318 13.682 56.0769 13.3846 56.0769H2.61538C2.318 56.0769 2.07692 56.318 2.07692 56.6154V61.4615H13.9231V56.6154ZM8.53846 67.9231H13.3846C13.682 67.9231 13.9231 67.682 13.9231 67.3846V62.5385H8.53846V67.9231ZM15 67.3846C15 68.2768 14.2768 69 13.3846 69H2.61538C1.72323 69 1 68.2768 1 67.3846V56.6154C1 55.7232 1.72323 55 2.61538 55H13.3846C14.2768 55 15 55.7232 15 56.6154V67.3846Z"
        fill="currentColor"
      />
    </>
  ),
});

export const InfoIcon = createCustomIcon({
  name: "Info",
  category: "General / Education",
  tags: ["docs"],
  path: (
    <path
      clipRule="evenodd"
      d="M3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.5 7L8.5 11H7.5L7.5 7H8.5ZM8.5 5V6H7.5V5H8.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const OutputsArrowIcon = createCustomIcon({
  name: "Outputs arrow",
  category: "Cells / Misc",
  tags: ["return", "replace"],
  path: (
    <path
      d="M9 6C9.19526 5.80474 9.51177 5.80474 9.70703 6L12.3535 8.64648C12.5488 8.84175 12.5488 9.15825 12.3535 9.35352L9.70703 12C9.51177 12.1953 9.19526 12.1953 9 12C8.80474 11.8047 8.80474 11.4882 9 11.293L10.793 9.5H6C4.61929 9.5 3.5 8.38071 3.5 7V4C3.5 3.72386 3.72386 3.5 4 3.5C4.27614 3.5 4.5 3.72386 4.5 4V7C4.5 7.82843 5.17157 8.5 6 8.5H10.793L9 6.70703C8.80474 6.51177 8.80474 6.19526 9 6Z"
      fill="currentColor"
    />
  ),
});

export const ConfigureIcon = createCustomIcon({
  name: "Configure",
  category: "General / Editing",
  tags: ["settings", "preferences", "gear"],
  path: (
    <path
      clipRule="evenodd"
      d="M6.67 1.5a.5.5 0 0 0-.5.4l-.07.38-.23 1.1c-.31.15-.6.32-.88.51l-1.13-.37-.38-.12a.5.5 0 0 0-.58.22l-.19.33-.95 1.59-.2.33a.5.5 0 0 0 .11.63l.28.25.86.73a3.38 3.38 0 0 0 0 1.04l-.85.73-.29.25a.5.5 0 0 0-.1.63l.19.33.95 1.59.19.33c.12.2.36.3.58.22l.37-.11L5 12.1c.27.19.57.36.88.5l.23 1.11.08.38c.04.23.25.4.49.4h2.66a.5.5 0 0 0 .5-.4l.07-.37.23-1.12c.31-.14.6-.31.88-.5l1.13.37.38.12a.5.5 0 0 0 .58-.22l.19-.33.95-1.59.2-.33a.5.5 0 0 0-.11-.63l-.28-.25-.86-.72a3.38 3.38 0 0 0 0-1.06l.85-.72.29-.25a.5.5 0 0 0 .1-.63l-.2-.33-.94-1.59-.2-.33a.5.5 0 0 0-.57-.22l-.37.11-1.16.4a5.87 5.87 0 0 0-.88-.5L9.9 2.28l-.08-.38a.5.5 0 0 0-.49-.4H6.67Zm.13 2.35.28-1.35h1.84l.28 1.35c.03.16.15.3.31.36.4.15.76.37 1.1.64.13.1.3.13.47.08l1.35-.46.93 1.55-1.03.88a.5.5 0 0 0-.17.46l.02.13c.03.2.06.35.06.51 0 .16-.03.31-.06.51l-.02.13a.5.5 0 0 0 .17.46l1.03.88-.93 1.55-1.35-.46a.5.5 0 0 0-.47.08c-.34.27-.7.49-1.1.64a.5.5 0 0 0-.31.36l-.28 1.35H7.08l-.28-1.35a.5.5 0 0 0-.31-.36c-.4-.15-.76-.37-1.1-.64a.5.5 0 0 0-.47-.08l-1.35.46-.93-1.55 1.03-.88a.5.5 0 0 0 .17-.46l-.02-.15A2.88 2.88 0 0 1 3.76 8c0-.16.02-.3.06-.5l.02-.14a.5.5 0 0 0-.17-.46l-1.03-.88.93-1.55 1.35.46a.5.5 0 0 0 .47-.08c.34-.27.7-.49 1.1-.64a.5.5 0 0 0 .31-.36ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const WarningIcon = createCustomIcon({
  name: "Warning",
  category: "General / Status",
  path: (
    <path
      clipRule="evenodd"
      d="M7.565 3.286a.5.5 0 0 1 .87 0l4.786 8.468a.5.5 0 0 1-.435.746H3.214a.5.5 0 0 1-.435-.746l4.786-8.468Zm1.74-.492a1.5 1.5 0 0 0-2.61 0l-4.787 8.468A1.5 1.5 0 0 0 3.214 13.5h9.572a1.5 1.5 0 0 0 1.306-2.238L9.306 2.794Zm-.68 5.707a.5.5 0 0 1-.5.5h-.25a.5.5 0 0 1-.5-.5V5.75a.5.5 0 0 1 .5-.5h.25a.5.5 0 0 1 .5.5V8.5Zm.125 2.249a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const RunIcon = createCustomIcon({
  name: "Run",
  category: "Cells / Run states",
  path: (
    <path
      d="M4.5 12C4.5 12.1844 4.60149 12.3538 4.76407 12.4408C4.92665 12.5278 5.12392 12.5183 5.27735 12.416L11.2773 8.41603C11.4164 8.32329 11.5 8.16718 11.5 8C11.5 7.83282 11.4164 7.67671 11.2773 7.58397L5.27735 3.58397C5.12392 3.48169 4.92665 3.47215 4.76407 3.55916C4.60149 3.64617 4.5 3.8156 4.5 4V12Z"
      fill="currentColor"
      fillOpacity="0.3"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  ),
});

export const RunSelectionIcon = createCustomIcon({
  name: "Run selection",
  category: "Cells / Run states",
  path: (
    <path
      clipRule="evenodd"
      d="M9 4H9.5C10.3284 4 11 4.67157 11 5.5V7.5H10V8.5H11V10.5C11 11.3284 10.3284 12 9.5 12H9V13H9.5C10.3178 13 11.0439 12.6073 11.5 12.0002C11.9561 12.6073 12.6822 13 13.5 13H14V12H13.5C12.6716 12 12 11.3284 12 10.5V8.5H13V7.5H12V5.5C12 4.67157 12.6716 4 13.5 4H14V3H13.5C12.6822 3 11.9561 3.39267 11.5 3.99976C11.0439 3.39267 10.3178 3 9.5 3H9V4ZM3.6 4.20001C3.29698 3.97274 2.89157 3.93619 2.55279 4.10558C2.214 4.27497 2 4.62123 2 5.00001V11C2 11.3788 2.214 11.725 2.55279 11.8944C2.89157 12.0638 3.29698 12.0273 3.6 11.8L7.6 8.80001C7.85181 8.61115 8 8.31476 8 8.00001C8 7.68525 7.85181 7.38886 7.6 7.20001L3.6 4.20001ZM7 8.00001L3 11V5.00001L7 8.00001Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GraphIcon = createCustomIcon({
  name: "Graph",
  category: "Project / View",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M12 2H4V5H12V2ZM4 1C3.44772 1 3 1.44772 3 2V5C3 5.55228 3.44772 6 4 6H12C12.5523 6 13 5.55228 13 5V2C13 1.44772 12.5523 1 12 1H4Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6 11H1L1 14H6V11ZM1 10C0.447715 10 0 10.4477 0 11V14C0 14.5523 0.447715 15 1 15H6C6.55228 15 7 14.5523 7 14V11C7 10.4477 6.55228 10 6 10H1Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15 11H10L10 14H15V11ZM10 10C9.44772 10 9 10.4477 9 11V14C9 14.5523 9.44772 15 10 15H15C15.5523 15 16 14.5523 16 14V11C16 10.4477 15.5523 10 15 10H10Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <rect fill="currentColor" height="2" width="1" x="8" y="6" />
      <rect fill="currentColor" height="1" width="10" x="3" y="8" />
      <rect fill="currentColor" height="1" width="1" x="3" y="9" />
      <rect fill="currentColor" height="1" width="1" x="12" y="9" />
    </>
  ),
});

export const ZoomToFitIcon = createCustomIcon({
  name: "Zoom to fit",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M14 5.5a.5.5 0 0 1-1 0V3.707L9.854 6.854a.5.5 0 1 1-.708-.708L12.293 3H10.5a.5.5 0 0 1 0-1H14v3.5ZM3 3.707V5.5a.5.5 0 1 1-1 0V2h3.5a.5.5 0 0 1 0 1H3.707l3.147 3.146a.5.5 0 1 1-.708.708L3 3.707ZM2.5 10a.5.5 0 0 1 .5.5v1.793l3.146-3.147a.5.5 0 0 1 .708.708L3.707 13H5.5a.5.5 0 1 1 0 1H2v-3.5a.5.5 0 0 1 .5-.5Zm7.5 3.497a.5.5 0 0 1 .503-.497l1.8.01-3.157-3.157a.5.5 0 1 1 .708-.707L13 12.293V10.5a.5.5 0 1 1 1 0v3.521L10.497 14a.5.5 0 0 1-.497-.503Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronDownSmallIcon = createCustomIcon({
  name: "Chevron: Single up (down, collapse)",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M4.99995 5.79289L7.99995 8.79289L11 5.79289L11.7071 6.5L7.99995 10.2071L4.29285 6.5L4.99995 5.79289Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronUpSmallIcon = createCustomIcon({
  name: "Chevron: Single up (small)",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="m5 10.414 3-3 3 3 .707-.707L8 6 4.293 9.707l.707.707Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronRightSmallIcon = createCustomIcon({
  name: "Chevron: Single right (small, expand)",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M7.49995 4.29289L11.2071 8L7.49995 11.7071L6.79285 11L9.79285 8L6.79285 5L7.49995 4.29289Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const EditIcon = createCustomIcon({
  name: "Edit",
  category: "General / Editing",
  path: (
    <path
      clipRule="evenodd"
      d="M11.4905 3.27287C10.46 2.24237 8.78926 2.24238 7.75876 3.27287L2.65457 8.37706C2.5556 8.47603 2.5 8.61027 2.5 8.75024V12.9723C2.5 13.1122 2.5556 13.2465 2.65458 13.3454C2.75355 13.4444 2.88778 13.5 3.02775 13.5L7.24976 13.5C7.38973 13.5 7.52397 13.4444 7.62294 13.3454L12.7271 8.24124C13.7576 7.21074 13.7576 5.53997 12.7271 4.50947L11.4905 3.27287ZM8.50512 4.01923C9.12341 3.40093 10.1259 3.40093 10.7442 4.01923L11.9808 5.25583C12.5991 5.87413 12.5991 6.87659 11.9808 7.49489L11.4718 8.00389L7.99611 4.52823L8.50512 4.01923ZM7.24976 5.27459L3.5555 8.96884V12.4445L7.03116 12.4445L10.7254 8.75024L7.24976 5.27459Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const EditInlineIcon = createCustomIcon({
  name: "Edit: Inline",
  category: "General / Editing",
  path: (
    <path
      d="M2.39998 9.60026L2.11679 9.31708L2 9.43467V9.60026H2.39998ZM9.59955 2.40072L9.88273 2.11754C9.84558 2.08029 9.80144 2.05074 9.75284 2.03057C9.70425 2.01041 9.65216 2.00003 9.59955 2.00003C9.54694 2.00003 9.49484 2.01041 9.44625 2.03057C9.39766 2.05074 9.35352 2.08029 9.31636 2.11754L9.59955 2.40072ZM13.5993 6.40047L13.8825 6.68365C13.9197 6.64649 13.9493 6.60236 13.9695 6.55376C13.9896 6.50517 14 6.45308 14 6.40047C14 6.34785 13.9896 6.29576 13.9695 6.24717C13.9493 6.19858 13.9197 6.15444 13.8825 6.11728L13.5993 6.40047ZM6.39974 13.6V14H6.56533L6.68292 13.8832L6.39974 13.6ZM2.39998 13.6H2C2 13.7061 2.04214 13.8078 2.11715 13.8828C2.19216 13.9578 2.2939 14 2.39998 14V13.6ZM2.68316 9.88344L9.88273 2.6839L9.31636 2.11754L2.11679 9.31708L2.68316 9.88344V9.88344ZM9.31636 2.6839L13.3161 6.68365L13.8825 6.11728L9.88273 2.11754L9.31636 2.6839V2.6839ZM13.3161 6.11728L6.11655 13.3168L6.68292 13.8832L13.8825 6.68365L13.3161 6.11728ZM6.39974 13.2H2.39998V14H6.39974V13.2ZM2.79995 13.6V9.60026H2V13.6H2.79995ZM6.91651 5.08375L10.9163 9.08349L11.4826 8.51713L7.48287 4.51739L6.91651 5.08375V5.08375ZM8.39962 14H13.9993V13.2H8.39962V14Z"
      fill="currentColor"
    />
  ),
});

export const SaveIcon = createCustomIcon({
  name: "Save",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M10.28 2.38A1 1 0 0 0 9.5 2H4c-.83 0-1.5.67-1.5 1.5v9c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.75a1 1 0 0 0-.22-.62l-3-3.75ZM9.5 3H4a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5h1.5v-1.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5V13H12a.5.5 0 0 0 .5-.5V6.75L9.5 3Zm0 10v-1.5A.5.5 0 0 0 9 11H7a.5.5 0 0 0-.5.5V13h3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddIcon = createCustomIcon({
  name: "Add",
  category: "General / Create",
  crispEdges: true,
  path: (
    <path
      clipRule="evenodd"
      d="M8.5 8.5V14.5H7.5V8.5H1.5V7.5H7.5V1.5H8.5V7.5H14.5V8.5H8.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddSmallIcon = createCustomIcon({
  name: "Add (small)",
  category: "General / Create",
  crispEdges: true,
  path: (
    <path
      clipRule="evenodd"
      d="M8 3a.5.5 0 0 0-.5.5v4h-4a.5.5 0 0 0 0 1h4v4a.5.5 0 0 0 1 0v-4h4a.5.5 0 0 0 0-1h-4v-4A.5.5 0 0 0 8 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PublishVersionIcon = createCustomIcon({
  name: "Published version",
  category: "Project / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3.56707 4.93736C4.18682 3.86471 5.30002 3 7 3C8.65813 3 9.79553 3.69861 10.5091 4.55491C11.0401 5.19205 11.3383 5.91863 11.4493 6.50475C11.9689 6.51998 12.6762 6.58383 13.3173 6.85096C13.7556 7.03359 14.1841 7.319 14.5012 7.76493C14.8205 8.21389 15 8.788 15 9.5C15 10.8537 14.5899 11.7576 13.9543 12.3138C13.3323 12.858 12.5726 13 12 13H4C3.43151 13 2.70844 12.8605 2.11 12.4865C1.48974 12.0988 1 11.4509 1 10.5C1 9.56909 1.46831 8.86351 1.96767 8.38793C2.29435 8.07681 2.65208 7.84602 2.94817 7.69497C2.87115 6.86517 3.05406 5.82527 3.56707 4.93736ZM4.43293 5.43764C3.95218 6.26971 3.84933 7.26709 3.98809 7.89153L4.08592 8.33174L3.65811 8.47434C3.47362 8.53584 3.03847 8.74908 2.65733 9.11207C2.28169 9.46982 2 9.93091 2 10.5C2 11.0491 2.26026 11.4012 2.64 11.6385C3.04156 11.8895 3.56849 12 4 12H12C12.4274 12 12.9177 11.892 13.2957 11.5612C13.6601 11.2424 14 10.6463 14 9.5C14 8.962 13.867 8.59861 13.6863 8.34445C13.5034 8.08724 13.2444 7.90391 12.9327 7.77404C12.2885 7.50565 11.5124 7.5 11 7.5H10.5V7C10.5 6.62492 10.2963 5.86154 9.74089 5.19509C9.20447 4.55139 8.34187 4 7 4C5.69998 4 4.89651 4.63529 4.43293 5.43764Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const CalendarIcon = createCustomIcon({
  name: "Calendar",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M5 2.5a.5.5 0 0 1 1 0V3h4v-.5a.5.5 0 0 1 1 0V3h1c1.1046 0 2 .8954 2 2v7c0 1.1046-.8954 2-2 2H4c-1.1046 0-2-.8954-2-2V5c0-1.1046.8954-2 2-2h1v-.5ZM10 4v.5a.5.5 0 0 0 1 0V4h1c.5523 0 1 .4477 1 1v1H3V5c0-.5523.4477-1 1-1h1v.5a.5.5 0 0 0 1 0V4h4ZM3 7v5c0 .5523.4477 1 1 1h8c.5523 0 1-.4477 1-1V7H3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const StarInactiveIcon = createCustomIcon({
  name: "Star: inactive",
  category: "Project / Actions",
  tags: ["favorite", "like", "filled", "unfilled"],
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a.5.5 0 0 1 .442.267l1.796 3.403 3.791.656a.5.5 0 0 1 .274.841l-2.682 2.76.548 3.808a.5.5 0 0 1-.716.52L8 12.057l-3.453 1.698a.5.5 0 0 1-.716-.52l.548-3.809-2.682-2.759a.5.5 0 0 1 .274-.841l3.791-.656 1.796-3.403A.5.5 0 0 1 8 1.5Zm0 1.571L6.532 5.854a.5.5 0 0 1-.357.26l-3.1.536 2.193 2.256a.5.5 0 0 1 .136.42l-.448 3.114 2.824-1.39a.5.5 0 0 1 .442 0l2.823 1.389-.448-3.115a.5.5 0 0 1 .136-.42l2.193-2.255-3.1-.537a.5.5 0 0 1-.357-.259L8 3.071Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const StarActiveIcon = createCustomIcon({
  name: "Star: active",
  category: "Project / Actions",
  tags: ["favorite", "like", "filled", "unfilled"],
  path: (
    <>
      <path
        d="m8 2 1.91 3.62 4.034.699-2.853 2.935.583 4.052L8 11.5l-3.674 1.806.583-4.052L2.056 6.32l4.034-.7L8 2Z"
        fill="CurrentColor"
        fillOpacity=".2"
        opacity="1"
      />
      <path
        clipRule="evenodd"
        d="M8 1.5a.5.5 0 0 1 .442.267l1.796 3.403 3.791.656a.5.5 0 0 1 .274.841l-2.682 2.76.548 3.808a.5.5 0 0 1-.716.52L8 12.057l-3.453 1.698a.5.5 0 0 1-.716-.52l.548-3.809-2.682-2.759a.5.5 0 0 1 .274-.841l3.791-.656 1.796-3.403A.5.5 0 0 1 8 1.5Zm0 1.571L6.532 5.854a.5.5 0 0 1-.357.26l-3.1.536 2.193 2.256a.5.5 0 0 1 .136.42l-.448 3.114 2.824-1.39a.5.5 0 0 1 .442 0l2.823 1.389-.448-3.115a.5.5 0 0 1 .136-.42l2.193-2.255-3.1-.537a.5.5 0 0 1-.357-.259L8 3.071Z"
        fill="CurrentColor"
        fillOpacity="1"
        fillRule="evenodd"
      />
    </>
  ),
});

export const StarRemoveIcon = createCustomIcon({
  name: "Star: remove",
  category: "Project / Actions",
  tags: ["unfavorite", "unlike", "remove favorite"],
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a.5.5 0 0 1 .442.267l1.19 2.256-.764.693L8 3.07 6.532 5.854a.5.5 0 0 1-.357.26l-3.1.536 1.71 1.76-.742.67-2.346-2.413a.5.5 0 0 1 .274-.841l3.791-.656 1.796-3.403A.5.5 0 0 1 8 1.5Zm3.478 4.9.942-.852 1.61.278a.5.5 0 0 1 .273.841l-2.682 2.76.548 3.808a.5.5 0 0 1-.716.52L8 12.057l-3.453 1.698a.5.5 0 0 1-.72-.432l1.152-1.043-.023.16 2.824-1.39a.5.5 0 0 1 .442 0l2.823 1.389-.448-3.115a.5.5 0 0 1 .136-.42l2.193-2.255-1.447-.25Zm1.857-3.03a.5.5 0 1 0-.67-.74l-10.5 9.5a.5.5 0 0 0 .67.74l10.5-9.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const HomeIcon = createCustomIcon({
  name: "Home",
  category: "Workspace / Navigation",
  tags: ["navigation"],
  path: (
    <path
      clipRule="evenodd"
      d="M7.6834 2.113a.5.5 0 0 1 .6332 0l5.5 4.5A.5.5 0 0 1 14 7v6.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2c0-.5523-.4477-1-1-1s-1 .4477-1 1v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .1834-.387l5.5-4.5ZM3 7.237V13h3v-1.5c0-1.1046.8954-2 2-2s2 .8954 2 2V13h3V7.237L8 3.146 3 7.237Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const UserIcon = createCustomIcon({
  name: "User",
  category: "Workspace / Users",
  path: (
    <path
      clipRule="evenodd"
      d="M8 8C6.6193 8 5.5 6.8807 5.5 5.5S6.6193 3 8 3s2.5 1.1193 2.5 2.5S9.3807 8 8 8ZM4.5 5.5C4.5 3.567 6.067 2 8 2s3.5 1.567 3.5 3.5S9.933 9 8 9 4.5 7.433 4.5 5.5ZM3.0773 13c.2847-1.1486 1.3224-2 2.559-2h4.7273c1.2366 0 2.2744.8514 2.5591 2H3.0773ZM2 13.6364C2 11.6281 3.628 10 5.6364 10h4.7272C12.3719 10 14 11.6281 14 13.6364a.3636.3636 0 0 1-.3636.3636H2.3636A.3636.3636 0 0 1 2 13.6364Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SharedIcon = createCustomIcon({
  name: "Shared",
  category: "General / Sharing",
  path: (
    <path
      clipRule="evenodd"
      d="M11.17 5.82a2 2 0 1 0-.78-.63L8.51 7.5H6a.5.5 0 0 0-.06 0 2 2 0 1 0 0 1 .5.5 0 0 0 .06 0h2.51l1.88 2.31a2 2 0 1 0 .78-.63L9.39 8l1.78-2.18ZM11 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM4 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7.84 4.01a1 1 0 1 0 .32 1.98 1 1 0 0 0-.32-1.98Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const WorkspaceIcon = createCustomIcon({
  name: "Workspace",
  category: "General / Sharing",
  path: (
    <path
      clipRule="evenodd"
      d="M11.8232 2.1185A.5002.5002 0 0 1 12 2.5v3h1.5a.5.5 0 0 1 .5.5v7.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V10H6v3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .4178-.4932l9-1.5a.5.5 0 0 1 .4054.1117ZM3 4.4235V13h2V9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V13h2V3.0902L3 4.4236ZM13 13h-1V6.5h1V13ZM5.5 6a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LibraryIcon = createCustomIcon({
  name: "Library",
  category: "Workspace / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 14a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h9.8585c.1294 0 .2407-.0002.3412.0133a1.5 1.5 0 0 1 1.287 1.287c.0134.1004.0134.2118.0133.3412v8.717c.0001.1294.0001.2407-.0133.3412a1.5 1.5 0 0 1-1.287 1.2869c-.1005.0135-.2118.0135-.3412.0134H6a.5.5 0 0 1-1 0H2.5Zm9.83-1H6V3h6.33c.1741 0 .2118.0011.2366.0044a.5.5 0 0 1 .429.429c.0033.0248.0044.0625.0044.2366v8.66c0 .1741-.0011.2118-.0044.2365a.5.5 0 0 1-.429.429c-.0248.0034-.0625.0045-.2366.0045ZM3 3h2v10H3V3Zm5.5 2.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SecretsIcon = createCustomIcon({
  name: "Secrets",
  category: "Project / Object",
  path: (
    <path
      clipRule="evenodd"
      d="M12 1H4V2H12V1ZM2 3H14V4H2V3ZM1 6H15V15H1V6ZM0 6C0 5.44771 0.447715 5 1 5H15C15.5523 5 16 5.44772 16 6V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V6ZM5 9H4V12H5H11H12V9H11V11H5V9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ResolveCommentIcon = createCustomIcon({
  name: "Resolve comment",
  category: "Project / Comments",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm8.416-1.723a.5.5 0 1 0-.832-.554l-2.62 3.93L5.89 7.689a.5.5 0 1 0-.78.624l2 2.5a.5.5 0 0 0 .806-.035l3-4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const OpenCommentIcon = createCustomIcon({
  name: "Open comment",
  category: "Project / Comments",
  path: (
    <path
      clipRule="evenodd"
      d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm-.146 2.646a.5.5 0 0 1 0 .708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l1.647 1.646a.5.5 0 0 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GlobeIcon = createCustomIcon({
  name: "Globe",
  category: "General / Sharing",
  path: (
    <path
      d="M8.968 13.414A5.5 5.5 0 1 1 7.25 2.551v.081a1 1 0 0 0 .106.447l.105.211-.112.344a.707.707 0 0 0 .038 1.242l.704.354a.922.922 0 0 0 1.268-.48h.061c.004.198.077.39.208.543l.202.236.03.059-.132.092-.439.263-1.197-.482a1 1 0 0 0-.635-.038l-.662.18-.724.027a1 1 0 0 0-.942.804l-.152.763a1 1 0 0 0 .291.92l.893.85a1 1 0 0 0 .316.203l.428.172-.06.23a1 1 0 0 0 .316 1.01l.115.1-.017.31a1 1 0 0 0 .084.457l.088.2a1 1 0 0 0 .771.586l.157.023a1 1 0 0 0 .986-.45l.747-1.165a1 1 0 0 0 .158-.54v-.422l.971-1.166a.91.91 0 0 0 .181-.813.98.98 0 0 0 1.004-.738l.018-.072.161.01a1 1 0 0 0 .364-.046l.402-.128a5.475 5.475 0 0 1 .021 2.45 5.5 5.5 0 0 1-4.404 4.236Zm4.064-7.634-.386.124-.161-.01a1 1 0 0 0-1.03.753l-.014.056-.099-.008a.91.91 0 0 0-.924 1.222L9.482 9.04a1 1 0 0 0-.232.64v.423l-.747 1.164-.157-.023-.088-.2.016-.31a1 1 0 0 0-.347-.812l-.114-.099.06-.23a1 1 0 0 0-.595-1.18l-.428-.172-.892-.849.152-.763.724-.028a1 1 0 0 0 .223-.034l.662-.18 1.196.483a1 1 0 0 0 .888-.07l.47-.281.16-.113a1 1 0 0 0 .321-1.267l-.03-.058a1 1 0 0 0-.135-.205l-.162-.188a.859.859 0 0 0-.855-.939h-.268a.922.922 0 0 0-.842.547l-.247-.124a.707.707 0 0 0 .044-.104l.153-.469a1 1 0 0 0-.057-.757l-.105-.211v-.126a5.501 5.501 0 0 1 4.782 3.274Zm-3.64-4.13a6.5 6.5 0 1 1-2.784 12.698A6.5 6.5 0 0 1 9.393 1.652Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LockIcon = createCustomIcon({
  name: "Lock",
  category: "General / Sharing",
  path: (
    <path
      clipRule="evenodd"
      d="M5.5 4.5C5.5 3.39543 6.39543 2.5 7.5 2.5H8.5C9.60457 2.5 10.5 3.39543 10.5 4.5V5L5.5 5V4.5ZM4.5 5L4.5 4.5C4.5 2.84315 5.84315 1.5 7.5 1.5H8.5C10.1569 1.5 11.5 2.84315 11.5 4.5V5C12.3284 5 13 5.67157 13 6.5V12.5C13 13.3284 12.3284 14 11.5 14H4.5C3.67157 14 3 13.3284 3 12.5V6.5C3 5.67157 3.67157 5 4.5 5ZM10.5 6H5.5H4.5C4.22386 6 4 6.22386 4 6.5L4 12.5C4 12.7761 4.22386 13 4.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6.5C12 6.22386 11.7761 6 11.5 6H10.5ZM7 9C7 8.44772 7.44772 8 8 8C8.55228 8 9 8.44772 9 9C9 9.37014 8.7989 9.69331 8.5 9.86622V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V9.86622C7.2011 9.69331 7 9.37014 7 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ColumnFilterIcon = createCustomIcon({
  name: "Column filter",
  category: "Data",
  path: (
    <path
      clipRule="evenodd"
      d="M2 4.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm2 3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM6.5 10a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LabelIcon = createCustomIcon({
  name: "Label",
  category: "Data",
  tags: ["string"],
  path: (
    <path
      clipRule="evenodd"
      d="M8.69106 2.4387C8.43304 1.84823 7.56096 1.8587 7.30594 2.4406L2.53854 13.3404C2.48748 13.457 2.48714 13.5881 2.53759 13.7049C2.58805 13.8217 2.68516 13.9147 2.80756 13.9633C2.92997 14.0119 3.06765 14.0122 3.19031 13.9642C3.31297 13.9162 3.41056 13.8237 3.46162 13.7071L5.24877 9.61955H10.7492L12.5384 13.7071C12.5894 13.8237 12.687 13.9162 12.8097 13.9642C12.9324 14.0122 13.07 14.0119 13.1924 13.9633C13.3148 13.9147 13.412 13.8217 13.4624 13.7049C13.5129 13.5881 13.5125 13.457 13.4615 13.3404L8.69106 2.43965V2.4387ZM10.3332 8.66718L7.999 3.33392L5.6658 8.66718H10.3332Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const RemoveIcon = createCustomIcon({
  name: "Remove",
  category: "General / Delete",
  tags: ["cancel", "reject", "close", "reviews"],
  path: (
    <path
      clipRule="evenodd"
      d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM5.146 5.146a.5.5 0 0 1 .708 0L8 7.293l2.146-2.147a.5.5 0 0 1 .708.708L8.707 8l2.147 2.146a.5.5 0 0 1-.708.708L8 8.707l-2.146 2.147a.5.5 0 0 1-.708-.708L7.293 8 5.146 5.854a.5.5 0 0 1 0-.708Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const BalancedEffortIcon = createCustomIcon({
  name: "Balanced effort",
  category: "Magic",
  path: (
    <path
      d="M7.16797 8.24805C7.56379 7.65435 8.43621 7.65435 8.83203 8.24805L10.9639 11.4453C11.379 12.0683 10.9861 12.89 10.2773 12.9902L10.1318 13V12L8 8.80273L5.86816 12V13C5.11961 12.9998 4.65418 12.2175 4.96387 11.5723L5.03613 11.4453L7.16797 8.24805ZM10.1318 12V13H5.86816V12H10.1318ZM14 6V7H2V6H14ZM14 4H2V7C1.44772 7 1 6.55228 1 6V4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4V6C15 6.55228 14.5523 7 14 7V4Z"
      fill="currentColor"
    />
  ),
});

export const EyeOpenIcon = createCustomIcon({
  name: "Eye open",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M2.58 8.43 2.32 8a9.43 9.43 0 0 1 1.42-1.9A5.9 5.9 0 0 1 8 4c1.8 0 3.24 1.01 4.26 2.1A10.46 10.46 0 0 1 13.68 8a9.5 9.5 0 0 1-1.42 1.9A5.9 5.9 0 0 1 8 12c-1.8 0-3.24-1.01-4.26-2.1-.5-.53-.9-1.07-1.16-1.47ZM14.25 8l.45-.22-.45.22Zm.45.22a.5.5 0 0 0 0-.44l-.01-.02a4.72 4.72 0 0 0-.1-.2 11.46 11.46 0 0 0-1.6-2.15C11.89 4.24 10.19 3 8 3 5.8 3 4.12 4.24 3.01 5.4a11.46 11.46 0 0 0-1.7 2.36v.01a.5.5 0 0 0 0 .45L1.74 8l-.45.22.01.02a4.06 4.06 0 0 0 .1.2l.33.54c.29.44.71 1.02 1.27 1.61C4.11 11.76 5.81 13 8 13c2.2 0 3.88-1.24 4.99-2.4a11.46 11.46 0 0 0 1.7-2.36v-.01Zm0 0L14.25 8l.45.22ZM1.75 8l-.45-.22.45.22ZM8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM5.5 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const EyeClosedIcon = createCustomIcon({
  name: "Eye closed",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M13.85 2.85a.5.5 0 1 0-.7-.7l-11 11a.5.5 0 0 0 .7.7l11-11ZM8 13c-.97 0-1.85-.24-2.62-.62l.76-.75c.57.23 1.19.37 1.86.37 1.8 0 3.24-1.01 4.26-2.1A10.46 10.46 0 0 0 13.68 8a9.5 9.5 0 0 0-1.42-1.9l-.29-.3.7-.7a10.02 10.02 0 0 1 1.59 1.92 10.2 10.2 0 0 1 .43.74v.01l-.44.23.45.22-.01.02a4.72 4.72 0 0 1-.1.2l-.33.54c-.29.44-.71 1.02-1.27 1.61C11.89 11.76 10.19 13 8 13Zm6.7-4.78L14.25 8l.45-.22a.5.5 0 0 1 0 .44ZM8 10.5a2.5 2.5 0 0 1-.65-.08l.95-.95A1.5 1.5 0 0 0 9.47 8.3l.95-.95A2.5 2.5 0 0 1 8 10.5ZM5.58 8.65l.95-.95A1.5 1.5 0 0 1 7.7 6.53l.95-.95a2.5 2.5 0 0 0-3.07 3.07ZM8 4c.67 0 1.3.14 1.86.37l.76-.75A5.94 5.94 0 0 0 8 3C5.8 3 4.12 4.24 3.01 5.4a11.46 11.46 0 0 0-1.7 2.36v.01a.5.5 0 0 0 0 .45l.05-.02.39-.2-.45.22.01.02a4.06 4.06 0 0 0 .1.2l.33.54a11.46 11.46 0 0 0 1.58 1.93l.71-.7a9 9 0 0 1-1.45-1.78L2.32 8a9.43 9.43 0 0 1 1.42-1.9A5.9 5.9 0 0 1 8 4ZM1.75 8l-.45-.22.45.22Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ArrowUpIcon = createCustomIcon({
  name: "Arrow: Up",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M11.646 7.354a.5.5 0 1 0 .707-.708L8 2.293 3.646 6.646a.5.5 0 1 0 .708.708L7.5 4.207V13.5a.5.5 0 0 0 1 0V4.207l3.146 3.147Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ArrowDownIcon = createCustomIcon({
  name: "Arrow: Down",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M8.5 11.793V2.5a.5.5 0 0 0-1 0v9.293L4.354 8.646a.5.5 0 1 0-.708.708L8 13.707l4.354-4.353a.5.5 0 1 0-.707-.708L8.5 11.793Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ArrowRightIcon = createCustomIcon({
  name: "Arrow: Right",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M8.646 4.354a.5.5 0 0 1 .708-.708L13.707 8l-4.353 4.354a.5.5 0 0 1-.707-.708L11.793 8.5H2.5a.5.5 0 0 1 0-1h9.293L8.646 4.354Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ArrowLeftIcon = createCustomIcon({
  name: "Arrow: Left",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M7.354 4.354a.5.5 0 1 0-.708-.708L2.293 8l4.353 4.354a.5.5 0 0 0 .708-.708L4.207 8.5H13.5a.5.5 0 0 0 0-1H4.207l3.147-3.146Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ArrowLeftRightIcon = createCustomIcon({
  name: "Arrow: Left and Right",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M5.353 4.646a.5.5 0 0 1 0 .708L3.208 7.5h9.586l-2.146-2.146a.5.5 0 1 1 .707-.708L14.707 8l-3.353 3.354a.5.5 0 1 1-.707-.708L12.793 8.5H3.207l2.147 2.146a.5.5 0 1 1-.708.707L1.293 8l3.353-3.354a.5.5 0 0 1 .707 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LightbulbIcon = createCustomIcon({
  name: "Lightbulb",
  category: "General / Education",
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 1.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1ZM2.6464 2.6465a.5.5 0 0 0 0 .707l1 1a.5.5 0 0 0 .7072-.707l-1-1a.5.5 0 0 0-.7072 0Zm11.2072 0a.5001.5001 0 0 1 0 .707l-1 1a.5001.5001 0 0 1-.7072-.707l1.0001-1a.5.5 0 0 1 .7071 0ZM8 4c-1.3999 0-2.417.5672-3.0745 1.3709C4.2807 6.1589 4 7.1499 4 7.9999c0 1.3572.411 2.1808.8964 2.6661.2373.2373.4783.3793.6662.4628l.0036.0016.1935.9676a.5.5 0 0 0 .4903.402h3.5a.5.5 0 0 0 .4903-.402l.1935-.9676.0036-.0016c.1879-.0835.4289-.2255.6662-.4628C11.5889 10.1807 12 9.3571 12 8c0-.85-.2807-1.841-.9255-2.6291-.6576-.8037-1.6746-1.371-3.0745-1.371Zm-1.5097 6.6519a.5.5 0 0 0-.3993-.3935c-.0024-.0006-.0086-.0021-.018-.0048a.8098.8098 0 0 1-.1043-.0386c-.0934-.0416-.2274-.1183-.3651-.256C5.3388 9.6942 5 9.1428 5 8c0-.65.2192-1.409.6995-1.9959C6.1669 5.4328 6.8998 5 8 5s1.833.4328 2.3005 1.0041C10.7808 6.5911 11 7.3501 11 8c0 1.1429-.3389 1.6943-.6036 1.959-.1377.1377-.2717.2144-.3651.256a.8098.8098 0 0 1-.1042.0386c-.0095.0027-.0157.0042-.0181.0048a.5.5 0 0 0-.3993.3935l-.1696.8481H6.6599l-.1696-.8481ZM6 14.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM13.5 7a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm-12 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddReactionIcon = createCustomIcon({
  name: "Add reaction",
  category: "Project / Comments",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm3.25-2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm3.75.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM5.474 8.842a.5.5 0 0 0-.948.316 3.625 3.625 0 0 0 6.948 0 .5.5 0 0 0-.948-.316c-.848 2.544-4.204 2.544-5.052 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const QuickstartIcon = createCustomIcon({
  name: "Quick start",
  category: "Workspace / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M3 2.45a.5.5 0 0 0 0 .05v11a.5.5 0 0 0 1 0V9h9.5a.5.5 0 0 0 .38-.82L11.65 5.5l2.23-2.68A.5.5 0 0 0 13.5 2h-10a.5.5 0 0 0-.5.45ZM4 3v5h8.43l-1.81-2.18a.5.5 0 0 1 0-.64L12.43 3H4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const KeyboardShortcutsIcon = createCustomIcon({
  name: "Keyboard shortcuts",
  category: "Workspace / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M1.43934 3.93934C1.72064 3.65804 2.10218 3.5 2.5 3.5H13.5C13.8978 3.5 14.2794 3.65804 14.5607 3.93934C14.842 4.22064 15 4.60217 15 5V12C15 12.3978 14.842 12.7794 14.5607 13.0607C14.2794 13.342 13.8978 13.5 13.5 13.5H2.5C2.10218 13.5 1.72064 13.342 1.43934 13.0607C1.15804 12.7794 1 12.3978 1 12V5C1 4.60218 1.15804 4.22064 1.43934 3.93934ZM2.5 4.5C2.36739 4.5 2.24021 4.55268 2.14645 4.64645C2.05268 4.74022 2 4.86739 2 5V12C2 12.1326 2.05268 12.2598 2.14645 12.3536C2.24021 12.4473 2.36739 12.5 2.5 12.5H13.5C13.6326 12.5 13.7598 12.4473 13.8536 12.3536C13.9473 12.2598 14 12.1326 14 12V5C14 4.86739 13.9473 4.74022 13.8536 4.64645C13.7598 4.55268 13.6326 4.5 13.5 4.5H2.5ZM4 5.5H5V6.5H4V5.5ZM6 5.5H7V6.5H6V5.5ZM10 5.5V6.5H9.00011L9.00001 5.5H10ZM12 5.5V6.5H11.0001L11 5.5H12ZM4 7.5H5V8.5H4V7.5ZM6 7.5H7V8.5H6V7.5ZM9 7.5H10V8.5H9V7.5ZM11 7.5H12V8.5H11V7.5ZM4 10.5H12V11.5H4V10.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DocsIcon = createCustomIcon({
  name: "Docs",
  category: "General / Education",
  path: (
    <path
      clipRule="evenodd"
      d="M3.5 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V6a.5.5 0 0 0-.12-.33l-3-3.5A.5.5 0 0 0 10 2H3.5ZM10 3.27V6h2.34L10 3.27ZM12.5 7h-3a.5.5 0 0 1-.5-.5V3H3.5v10h9V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ChangelogIcon = createCustomIcon({
  name: "Changelog",
  category: "Workspace / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M7.15 5.85a.5.5 0 1 0 .7-.7L5 2.29 2.15 5.15a.5.5 0 1 0 .7.7L4.5 4.21v8.29a.5.5 0 0 0 1 0V4.2l1.65 1.65Zm1.7 4.3a.5.5 0 1 0-.7.7L11 13.71l2.85-2.86a.5.5 0 0 0-.7-.7l-1.65 1.64V3.5a.5.5 0 0 0-1 0v8.3l-1.65-1.65Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DiffIcon = createCustomIcon({
  name: "Diff",
  category: "General / Git",
  tags: ["reviews", "compare"],
  path: (
    <path
      clipRule="evenodd"
      d="M4.453 13.406H6.2l-1.948-1.948a4.045 4.045 0 0 1-1.185-2.86V6.087a2.57 2.57 0 1 1 1 0v2.51c0 .808.32 1.583.892 2.154l1.949 1.948v-1.747a.5.5 0 0 1 1 0v2.954a.498.498 0 0 1-.5.5H4.453a.5.5 0 1 1 0-1Zm-.855-8.27a.511.511 0 0 0-.062 0 1.569 1.569 0 1 1 .062 0Zm7.947-2.55H9.797l1.95 1.948a4.045 4.045 0 0 1 1.184 2.86v2.511a2.57 2.57 0 1 1-1 0v-2.51c0-.808-.32-1.582-.892-2.153L9.09 3.292V5.04a.5.5 0 0 1-1 0V2.086a.498.498 0 0 1 .5-.5h2.955a.5.5 0 0 1 0 1Zm.855 8.27a.536.536 0 0 0 .062 0 1.569 1.569 0 1 1-.062 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ReorderedIcon = createCustomIcon({
  name: "Reordered",
  category: "Cells / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M15 4H7L7 6H15V4ZM7 3C6.44772 3 6 3.44772 6 4L6 6C6 6.55228 6.44772 7 7 7H15C15.5523 7 16 6.55228 16 6V4C16 3.44772 15.5523 3 15 3H7ZM3.09374 11.4209C2.35466 11.2961 1.68998 11.0067 1.16345 10.5588C0.430595 9.93542 0 9.03282 0 7.94574C0 6.8655 0.410028 5.96168 1.13785 5.33471C1.85759 4.71469 2.84658 4.39999 3.95649 4.39999C4.23263 4.39999 4.45649 4.62385 4.45649 4.89999C4.45649 5.17614 4.23263 5.39999 3.95649 5.39999C3.02889 5.39999 2.28963 5.66239 1.79051 6.09235C1.29946 6.51536 1 7.13441 1 7.94574C1 8.75024 1.30988 9.37051 1.81138 9.7971C2.14622 10.0819 2.58127 10.2922 3.09374 10.403V9.60124L5.49995 10.9905L3.09374 12.3797V11.4209ZM7 10H15V12H7L7 10ZM6 10C6 9.44772 6.44772 9 7 9H15C15.5523 9 16 9.44772 16 10V12C16 12.5523 15.5523 13 15 13H7C6.44772 13 6 12.5523 6 12L6 10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ArrowTopRightIcon = createCustomIcon({
  name: "Arrow: Top right",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M12 9a.5.5 0 0 0 1 0V3H7a.5.5 0 0 0 0 1h4.293l-8.147 8.146a.5.5 0 1 0 .708.707L12 4.707V9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DownloadIcon = createCustomIcon({
  name: "Download",
  category: "General / Create",
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 2.50006v6.79296L4.85343 6.64645c-.19526-.19527-.51184-.19527-.70711 0-.19526.19526-.19526.51184 0 .7071l3.5 3.50005c.09377.0937.22095.1464.35356.1464.13261 0 .25978-.0527.35355-.1464l3.49997-3.50005c.1953-.19526.1953-.51184 0-.7071-.1952-.19527-.5118-.19527-.7071 0L8.5 9.29277V2.50006c0-.27614-.22386-.5-.5-.5s-.5.22386-.5.5ZM3 9c0-.27614-.22386-.5-.5-.5S2 8.72386 2 9v4.5c0 .2761.22386.5.5.5h11c.2761 0 .5-.2239.5-.5V9c0-.27614-.2239-.5-.5-.5s-.5.22386-.5.5v4H3V9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const UploadIcon = createCustomIcon({
  name: "Upload",
  category: "General / Create",
  path: (
    <path
      clipRule="evenodd"
      d="M11.1463 5.85355c.1953.19527.5119.19527.7071 0 .1953-.19526.1953-.51184 0-.7071l-3.49997-3.5C8.25966 1.55268 8.13249 1.5 7.99988 1.5c-.13261 0-.25979.05268-.35356.14645l-3.5 3.5c-.19526.19526-.19526.51184 0 .7071.19527.19527.51185.19527.70711 0L7.5 3.20698v7.23052c0 .3107.22386.5625.5.5625s.5-.2518.5-.5625V3.20723l2.6463 2.64632ZM2.5 8.5c.27614 0 .5.22386.5.5v4h10V9c0-.27614.2239-.5.5-.5s.5.22386.5.5v4.5c0 .2761-.2239.5-.5.5h-11c-.27614 0-.5-.2239-.5-.5V9c0-.27614.22386-.5.5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ViewLiveVersionIcon = createCustomIcon({
  name: "View live version",
  category: "Project / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M2 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8.5v2H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h2.5v-2H3a1 1 0 0 1-1-1V4Zm6 6h5V4H3v6h5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const NoViewLiveVersionIcon = createCustomIcon({
  name: "View live version: disabled",
  category: "Project / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M12.15 2.15a.5.5 0 0 1 .7.7l-9 9a.5.5 0 0 1-.7-.7l9-9ZM3 3h6.88l-1 1H3v5.88l-.77.76A1 1 0 0 1 2 10V4a1 1 0 0 1 1-1Zm10.77.36-.77.76V10H7.12l-1 1H7.5v2H5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H8.5v-2H13a1 1 0 0 0 1-1V4a1 1 0 0 0-.23-.64Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GitPullIcon = createCustomIcon({
  name: "Git pull",
  category: "General / Git",
  path: (
    <path
      clipRule="evenodd"
      d="M1.998 3.567a1.569 1.569 0 1 1 3.138 0 1.569 1.569 0 0 1-3.138 0ZM3.567.998a2.569 2.569 0 0 0-.5 5.089v3.826a2.57 2.57 0 1 0 1 0V6.087a2.57 2.57 0 0 0-.5-5.089ZM1.998 12.433c0-.865.7-1.567 1.565-1.569h.007a1.569 1.569 0 1 1-1.572 1.57Zm9.548-9.844H9.798l1.95 1.95A4.047 4.047 0 0 1 12.933 7.4v2.513a2.57 2.57 0 1 1-1 0V7.4c0-.808-.32-1.583-.892-2.154l-1.95-1.95v1.749a.5.5 0 1 1-1 0V2.089a.499.499 0 0 1 .5-.5h2.956a.5.5 0 0 1 0 1Zm.883 8.275H12.438a1.569 1.569 0 1 1-.009 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GitBranchIcon = createCustomIcon({
  name: "Git branch",
  category: "General / Git",
  path: (
    <path
      clipRule="evenodd"
      d="M12.43 2.001a1.568 1.568 0 1 0 0 3.136 1.568 1.568 0 0 0 0-3.136ZM9.864 3.57a2.568 2.568 0 1 1 3.068 2.52v.139A2.272 2.272 0 0 1 10.659 8.5H5.34A1.272 1.272 0 0 0 4.07 9.772v.14a2.569 2.569 0 1 1-1 0V6.088a2.569 2.569 0 1 1 1 0V7.89c.373-.252.816-.39 1.272-.39h5.317a1.272 1.272 0 0 0 1.273-1.272v-.14A2.569 2.569 0 0 1 9.863 3.57Zm-7.862 8.862a1.568 1.568 0 1 1 3.136 0 1.568 1.568 0 0 1-3.136 0Zm0-8.862a1.568 1.568 0 1 1 3.136 0 1.568 1.568 0 0 1-3.136 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GitCommitIcon = createCustomIcon({
  name: "Git commit",
  category: "General / Git",
  path: (
    <path
      d="M8 6a2 2 0 0 1 1.935 1.5H13.5a.5.5 0 0 1 0 1H9.935a1.999 1.999 0 0 1-3.87 0H2.5a.5.5 0 0 1 0-1h3.565A1.999 1.999 0 0 1 8 6Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      fill="currentColor"
    />
  ),
});

export const RefreshIcon = createCustomIcon({
  name: "Refresh",
  category: "General / Actions",
  tags: ["restore"],
  path: (
    <path
      clipRule="evenodd"
      d="M5 4v2.5a.5.5 0 1 0 1 0v-4H2a.5.5 0 0 0 0 1h2.03A5.99 5.99 0 0 0 8 14v-1a5 5 0 0 1-3-9Zm9 4a6 6 0 0 1-2.03 4.5H14a.5.5 0 1 1 0 1h-4v-4a.5.5 0 1 1 1 0V12a5 5 0 0 0-3-9V2a6 6 0 0 1 6 6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PausedIcon = createCustomIcon({
  name: "Paused",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M4 4H6.01069V12L4 12V4ZM6.01069 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13L6.01069 13C6.56069 13 7.01069 12.55 7.01069 12V4C7.01069 3.45 6.56069 3 6.01069 3ZM10.002 4H12.0126V12L10.002 12V4ZM12.0126 3H10.002C9.45195 3 9.00195 3.45 9.00195 4V12C9.00195 12.55 9.45195 13 10.002 13L12.0126 13C12.5626 13 13.0126 12.55 13.0126 12V4C13.0126 3.45 12.5626 3 12.0126 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PublishIcon = createCustomIcon({
  name: "Publish",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M3.567 2.937C4.187 1.865 5.3 1 7 1c1.658 0 2.796.699 3.51 1.555.53.637.828 1.364.94 1.95.519.015 1.226.079 1.867.346.439.183.867.468 1.184.914.32.449.499 1.023.499 1.735 0 1.354-.41 2.258-1.046 2.814-.622.544-1.381.686-1.954.686v-1c.427 0 .918-.108 1.296-.439.364-.319.704-.915.704-2.061 0-.538-.133-.901-.314-1.156-.183-.257-.442-.44-.753-.57-.644-.268-1.42-.274-1.933-.274h-.5V5c0-.375-.204-1.138-.76-1.805C9.205 2.551 8.343 2 7 2c-1.3 0-2.103.635-2.567 1.438-.48.832-.584 1.83-.445 2.454l.098.44-.428.142c-.184.062-.62.275-1 .638C2.281 7.47 2 7.931 2 8.5c0 .55.26.901.64 1.139.112.07.233.128.36.177v1.05a3.298 3.298 0 0 1-.89-.38C1.49 10.1 1 9.451 1 8.5c0-.93.468-1.636.968-2.112.326-.311.684-.542.98-.693-.077-.83.106-1.87.62-2.758ZM7.5 6.793l.354.353 3 3-.708.708L8 8.708v5.565H7V8.708l-2.146 2.146-.708-.708 3-3 .354-.353Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GitHubIcon = createCustomIcon({
  name: "GitHub",
  category: "Workspace / Integrations",
  path: (
    <path
      d="M6.48466 12.4078C6.61402 12.3669 6.72191 12.2761 6.78462 12.1553C6.84732 12.0345 6.8597 11.8936 6.81902 11.7636C6.77834 11.6336 6.68794 11.5252 6.56771 11.4622C6.44748 11.3992 6.30727 11.3867 6.17791 11.4276L6.48466 12.4078ZM2.7546 9.36658L2.25971 9.23507L2 10.2296L2.49489 10.3601L2.7546 9.36555V9.36658ZM9.91002 14.4863V15H10.9325V14.4863H9.91002ZM9.97444 9.54124L9.91922 9.03061C9.82314 9.04095 9.73194 9.07844 9.6562 9.13874C9.58046 9.19904 9.52327 9.27967 9.49127 9.37129C9.45928 9.46291 9.45377 9.56177 9.47541 9.6564C9.49704 9.75104 9.54492 9.83757 9.6135 9.90598L9.97342 9.54227L9.97444 9.54124ZM13.4888 5.66371H14V5.66062L13.4888 5.66371ZM12.637 3.60165L12.1605 3.41671C12.1249 3.50934 12.1167 3.61037 12.1371 3.70756C12.1574 3.80475 12.2053 3.89394 12.2751 3.96433L12.637 3.60165ZM12.5859 1.52931L13.0521 1.31972C13.0216 1.25142 12.9766 1.19066 12.9203 1.14167C12.8639 1.09269 12.7976 1.05667 12.726 1.03614L12.5859 1.52931ZM10.364 2.34304L10.2352 2.84032C10.3038 2.85834 10.3755 2.8618 10.4455 2.85048C10.5156 2.83916 10.5826 2.8133 10.6421 2.77456L10.364 2.34304ZM6.38855 2.34304L6.11043 2.77456C6.17001 2.8133 6.23696 2.83916 6.30702 2.85048C6.37708 2.8618 6.44872 2.85834 6.51738 2.84032L6.38855 2.34304ZM4.16667 1.53034L4.02658 1.03717C3.95475 1.05757 3.88823 1.09353 3.83171 1.14252C3.77518 1.19151 3.73002 1.25234 3.69939 1.32074L4.16667 1.53034ZM4.11554 3.60267L4.47751 3.96536C4.54743 3.89488 4.59548 3.80551 4.61581 3.70811C4.63614 3.61071 4.62787 3.50948 4.59202 3.41671L4.11554 3.60267ZM3.2638 5.68117H3.77505V5.67912L3.2638 5.68117ZM6.77914 9.54227L7.13906 9.90701C7.20717 9.83896 7.25482 9.75301 7.27656 9.659C7.2983 9.565 7.29325 9.46674 7.26198 9.37549C7.23071 9.28423 7.1745 9.20368 7.09977 9.14304C7.02504 9.08241 6.93483 9.04416 6.83947 9.03266L6.77812 9.54227H6.77914ZM6.33129 10.8903H6.84254L6.84151 10.8522L6.33129 10.8903ZM5.82004 14.4863V15H6.84254V14.4863H5.82004ZM6.17791 11.4276C5.56135 11.6228 5.16973 11.6012 4.91002 11.5149C4.65337 11.4297 4.45603 11.2581 4.26687 11.0115C4.16799 10.8786 4.07585 10.7407 3.9908 10.5985C3.90389 10.4557 3.8047 10.2882 3.7045 10.1392C3.5092 9.8505 3.22086 9.48884 2.7546 9.36555L2.49489 10.3601C2.57669 10.3807 2.68303 10.4577 2.85787 10.7156C2.94172 10.8409 3.02147 10.9745 3.12168 11.1389C3.21779 11.2951 3.32822 11.4677 3.45603 11.6362C3.71472 11.9752 4.06748 12.3174 4.591 12.491C5.11247 12.6636 5.73211 12.6451 6.48466 12.4078L6.17791 11.4276ZM10.9325 10.8266C10.9325 10.4998 10.9182 10.2019 10.8262 9.92448C10.728 9.62858 10.5583 9.40048 10.3344 9.17753L9.6135 9.90701C9.77198 10.0642 9.82618 10.1587 9.85583 10.2491C9.89162 10.357 9.91002 10.5101 9.91002 10.8266H10.9325ZM10.0286 10.0529C10.9519 9.95324 11.9591 9.71899 12.7352 9.04396C13.5327 8.35045 14 7.26753 14 5.66371H12.9775C12.9775 7.05999 12.5787 7.82132 12.0654 8.26722C11.5297 8.73368 10.7791 8.93814 9.91922 9.03061L10.0286 10.0529ZM14 5.66062C13.997 4.75189 13.6368 3.88115 12.998 3.23794L12.2751 3.96433C12.7229 4.4164 12.9755 5.02567 12.9775 5.66371L14 5.66062ZM13.1135 3.78659C13.2669 3.39205 13.3384 2.9708 13.3282 2.54647L12.3057 2.57216C12.3132 2.85987 12.2638 3.14622 12.1605 3.41465L13.1135 3.78659ZM13.3282 2.54647C13.3179 2.1229 13.224 1.70661 13.0521 1.31972L12.1186 1.73788C12.2362 2.0009 12.2986 2.28448 12.3057 2.57216L13.3282 2.54647ZM12.5859 1.52931C12.726 1.03512 12.726 1.03409 12.7249 1.03409H12.7219L12.7178 1.03203C12.7076 1.0293 12.6974 1.0269 12.6871 1.02484C12.6157 1.01048 12.5432 1.00224 12.4703 1.00018C12.295 0.99792 12.1199 1.01654 11.9489 1.05567C11.5143 1.14916 10.9018 1.38136 10.0879 1.91049L10.6421 2.77354C11.3773 2.29681 11.8753 2.12214 12.1636 2.0605C12.2661 2.03678 12.3713 2.02642 12.4765 2.02967L12.4683 2.02865C12.4649 2.02802 12.4615 2.02734 12.4581 2.02659L12.4519 2.02454H12.4489L12.4468 2.02351C12.4458 2.02351 12.4448 2.02351 12.5859 1.52829V1.52931ZM10.4928 1.84474C9.10497 1.48133 7.64758 1.48133 6.25971 1.84474L6.51738 2.84032C7.73629 2.52113 9.01627 2.52113 10.2352 2.84032L10.4928 1.84474ZM6.66564 1.91049C5.85072 1.38239 5.23722 1.15019 4.80266 1.05772C4.63159 1.01892 4.45654 1.00065 4.28119 1.00327C4.19825 1.00554 4.11572 1.01586 4.03476 1.03409L4.03067 1.03614H4.02761L4.16667 1.53034L4.30675 2.02454L4.30368 2.02556L4.30061 2.02659C4.2952 2.0281 4.28974 2.02947 4.28425 2.0307C4.38671 2.02804 4.48909 2.03942 4.58896 2.06255C4.8773 2.1242 5.37526 2.29783 6.11043 2.77456L6.66564 1.91255V1.91049ZM3.70041 1.31869C3.52854 1.70559 3.4347 2.1229 3.42434 2.54647L4.44683 2.57216C4.4529 2.28427 4.51654 2.00055 4.63395 1.73788L3.70041 1.31869ZM3.42434 2.54647C3.41411 2.9708 3.48569 3.39205 3.63906 3.78659L4.59202 3.41465C4.48836 3.14629 4.43866 2.85994 4.44581 2.57216L3.42331 2.54647H3.42434ZM3.75358 3.23794C3.43519 3.5589 3.18293 3.93981 3.01125 4.35887L3.95603 4.74929C4.07669 4.45647 4.2546 4.18934 4.47751 3.9633L3.75358 3.23794ZM3.01125 4.35887C2.83925 4.77823 2.75134 5.22759 2.75256 5.68117L3.77505 5.67912C3.77505 5.36061 3.8364 5.04519 3.95603 4.75135L3.01125 4.36092V4.35887ZM2.75256 5.68117C2.75256 7.27678 3.22086 8.34942 4.01943 9.03883C4.79346 9.70666 5.79857 9.94297 6.71881 10.0529L6.83947 9.03266C5.97342 8.92787 5.2229 8.72238 4.68507 8.25798C4.17178 7.81515 3.77505 7.0641 3.77505 5.67912H2.75256V5.68117ZM6.4182 9.17856C5.90695 9.69022 5.77505 10.2985 5.82106 10.9293L6.84151 10.8522C6.81084 10.4331 6.89571 10.1505 7.14008 9.90598L6.41922 9.17753L6.4182 9.17856ZM5.82004 10.8903V14.4863H6.84254V10.8903H5.82004ZM10.9325 14.4863V12.9451H9.91002V14.4863H10.9325ZM10.9325 12.9451V10.8266H9.91002V12.9451H10.9325Z"
      fill="currentColor"
    />
  ),
});

export const GitLabIcon = createCustomIcon({
  name: "GitLab",
  category: "Workspace / Integrations",
  path: (
    <path
      clipRule="evenodd"
      d="M3.33797 1.00037C3.56011 0.99184 3.7612 1.131 3.8315 1.34189L5.57468 6.57143H10.4254L12.1685 1.34189C12.2388 1.131 12.4399 0.99184 12.6621 1.00037C12.8842 1.0089 13.074 1.16307 13.1279 1.37874L14.9851 8.80731C15.031 8.99104 14.9692 9.18495 14.8254 9.3082L8.32541 14.8796C8.13817 15.0401 7.86187 15.0401 7.67462 14.8796L1.17462 9.3082C1.03083 9.18495 0.969013 8.99104 1.01495 8.80731L2.87209 1.37874C2.926 1.16307 3.11583 1.0089 3.33797 1.00037ZM3.42579 3.28703L2.06004 8.75005L8.00002 13.8415L13.94 8.75005L12.5742 3.28703L11.2601 7.22955C11.192 7.43372 11.0009 7.57143 10.7857 7.57143H5.2143C4.99909 7.57143 4.80802 7.43372 4.73996 7.22955L3.42579 3.28703Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const BitbucketIcon = createCustomIcon({
  name: "Bitbucket",
  category: "Workspace / Integrations",
  path: (
    <path
      clipRule="evenodd"
      d="M13.6148 2.52005L2.38523 2.50006C2.14545 2.50006 1.96562 2.71986 2.00558 2.93966L3.62407 12.8505C3.66403 13.1102 3.88385 13.2901 4.1436 13.2901H11.9763C12.1562 13.2901 12.316 13.1502 12.356 12.9704L13.9944 2.95964C14.0344 2.71986 13.8546 2.52005 13.6148 2.52005ZM11.454 12.2901L12.8896 3.51876L3.11055 3.50135L4.5458 12.2901H11.454ZM13.6148 3.52005C13.6142 3.52005 13.6136 3.52005 13.613 3.52005H13.6148Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DbtIcon = createCustomIcon({
  name: "dbt",
  category: "Workspace / Integrations",
  path: (
    <path
      clipRule="evenodd"
      d="M9.755 3.72c.763-.45 1.78-1.034 1.915-1.091a.924.924 0 0 1 .438-.129c.348.04.676.198.925.458.258.248.428.577.467.934 0 .15-.04.248-.13.437-.089.189-1.193 2.098-1.522 2.625a2.005 2.005 0 0 0 0 2.07 80.583 80.583 0 0 1 1.523 2.636c.09.189.129.278.129.428a1.47 1.47 0 0 1-.458.925 1.476 1.476 0 0 1-.925.457c-.15 0-.248-.04-.428-.129-.179-.09-2.128-1.164-2.655-1.492a.69.69 0 0 1-.037-.022l-.006-.003a.578.578 0 0 0-.086-.045L6.3 10.238c.03.25.1.494.207.72a2.09 2.09 0 0 0 .648.791l-.045.023a1.133 1.133 0 0 0-.098.05 70.76 70.76 0 0 1-2.682 1.55c-.188.089-.278.128-.437.128a1.466 1.466 0 0 1-.925-.458 1.535 1.535 0 0 1-.467-.934c.01-.15.05-.299.129-.428a80.815 80.815 0 0 1 1.523-2.636 1.98 1.98 0 0 0 .287-1.035c0-.368-.099-.726-.287-1.034-.33-.548-1.443-2.466-1.523-2.655a.92.92 0 0 1-.129-.428 1.51 1.51 0 0 1 .458-.934 1.52 1.52 0 0 1 .934-.458c.15.01.299.05.437.129.16.07 1.562.885 2.308 1.323l.17.099c.06.04.11.07.15.09l.08.05 2.655 1.571a2.156 2.156 0 0 0-.202-.718 2.209 2.209 0 0 0-.645-.794l.046-.022a1.917 1.917 0 0 0 .143-.077c.15-.094.415-.252.72-.431Zm-2.198-.383.403.238.438-.219.058-.028.002-.001a2.667 2.667 0 0 0 .04-.02l.007-.004a71.761 71.761 0 0 1 2.258-1.32c.147-.083.316-.177.435-.236.285-.163.583-.23.85-.245l.086-.005.086.01a2.51 2.51 0 0 1 1.52.744c.409.4.688.935.754 1.531l.006.055v.055c0 .39-.13.664-.226.866a35.91 35.91 0 0 1-.71 1.258 68.69 68.69 0 0 1-.864 1.463 1.007 1.007 0 0 0 0 1.02c.176.283.54.906.866 1.47.313.543.641 1.12.708 1.262l.01.022c.088.184.216.452.216.835v.054l-.006.055a2.467 2.467 0 0 1-.752 1.53 2.471 2.471 0 0 1-1.54.74l-.042.003h-.043c-.393 0-.667-.13-.875-.234-.202-.101-2.123-1.16-2.711-1.523l-.002-.001-.032-.018-.03-.012-.431-.255-.434.217-.058.028-.002.001a4.474 4.474 0 0 0-.035.017l-.004.002-.008.005c-.28.175-.908.542-1.475.869-.543.313-1.12.641-1.262.708l-.017.009c-.192.091-.457.217-.849.217h-.055l-.054-.006a2.467 2.467 0 0 1-1.53-.752 2.534 2.534 0 0 1-.747-1.524l-.01-.087.006-.087c.017-.27.09-.568.25-.847.105-.2.4-.718.682-1.207.325-.564.69-1.188.866-1.47a.981.981 0 0 0 .14-.51.98.98 0 0 0-.141-.513l-.003-.004-.002-.003a120.472 120.472 0 0 1-1.311-2.263 11.01 11.01 0 0 1-.236-.435 1.93 1.93 0 0 1-.245-.837l-.006-.086.01-.086a2.52 2.52 0 0 1 .745-1.534c.411-.42.951-.679 1.532-.743l.086-.01.087.006c.276.018.562.092.833.238.1.05.238.127.353.192a230.812 230.812 0 0 1 2 1.157l.192.112.023.015.046.029.013.008.036.018.105.066Zm.582 5.37c-.08.068-.209.068-.278 0l-.567-.567a.191.191 0 0 1 0-.279l.567-.566c.08-.08.198-.08.278 0l.567.566c.08.08.08.199 0 .279l-.567.566Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GoogleSheetsIcon = createCustomIcon({
  name: "GoogleSheets",
  category: "Workspace / Integrations",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M8 1H3.875C3.39175 1 3 1.39175 3 1.875V14.125C3 14.6082 3.39175 15 3.875 15H12.125C12.6082 15 13 14.6082 13 14.125V8V5.28111L8.73438 1L8 1Z"
        fill="#26A668"
        fillRule="evenodd"
      />
      <path
        d="M11 12.997H5V8.32999H11V12.997ZM5.66699 11.663V12.33H7.66699V11.663H5.66699ZM8.33301 11.663V12.33H10.333V11.663H8.33301ZM5.66699 10.33V10.997H7.66699V10.33H5.66699ZM8.33301 10.33V10.997H10.333V10.33H8.33301ZM5.66699 8.99698V9.66299H7.66699V8.99698H5.66699ZM8.33301 8.99698V9.66299H10.333V8.99698H8.33301Z"
        fill="white"
      />
      <path
        d="M8.73201 4.49768L9.00659 5.06966L13 9V5.27778L8.73201 1.02832V4.49768Z"
        fill="#2B9363"
      />
      <path
        d="M12.9999 5.26799L8.73193 1V4.45161C8.73193 4.90248 9.09744 5.26799 9.54831 5.26799H12.9999Z"
        fill="#92D3B4"
      />
    </>
  ),
});

export const FilledDatabaseIcon = createCustomIcon({
  name: "Filled database",
  category: "Data",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 11.17V3.5S3 2 8 2s5 1.5 5 1.5v7.67c0 .53-.21 1.04-.67 1.31A8.5 8.5 0 0 1 8 13.5a8.5 8.5 0 0 1-4.33-1.02c-.46-.27-.67-.78-.67-1.3Z"
        fill="currentColor"
        fillOpacity=".25"
      />
      <path
        clipRule="evenodd"
        d="m3.52 3.76-.02.03v.19l.03.08c.04.08.14.23.38.4.5.36 1.63.79 4.09.79s3.59-.43 4.09-.78c.24-.18.34-.33.38-.41a.38.38 0 0 0 .03-.08v-.19s0-.02-.02-.03a.97.97 0 0 0-.36-.33c-.51-.3-1.65-.68-4.12-.68s-3.6.37-4.12.68a.97.97 0 0 0-.36.33ZM2.5 3.75h.07-.07v-.03a.72.72 0 0 1 .02-.15c.02-.08.06-.19.12-.3.13-.22.35-.47.73-.7.74-.44 2.1-.82 4.63-.82s3.9.38 4.63.82c.38.23.6.48.73.7a1.17 1.17 0 0 1 .14.45v.02l-.07.01h.07v7.67c0 .65-.26 1.36-.92 1.74A8.99 8.99 0 0 1 8 14.25c-2.27 0-3.76-.6-4.58-1.09a1.97 1.97 0 0 1-.92-1.74V3.75Zm1 5.55v2.12c0 .41.16.73.42.88a8 8 0 0 0 4.08.95 8 8 0 0 0 4.08-.95c.26-.15.42-.47.42-.88V9.3l-.28.15a9.4 9.4 0 0 1-4.22.8 9.4 9.4 0 0 1-4.5-.95Zm9-1.24A8.44 8.44 0 0 1 8 9.25a8.4 8.4 0 0 1-3.78-.7 3.01 3.01 0 0 1-.72-.49V5.4c.78.48 2.13.86 4.5.86s3.72-.38 4.5-.86v2.67Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const NumberIcon = createCustomIcon({
  name: "Number",
  category: "Data",
  path: (
    <path
      clipRule="evenodd"
      d="M7.09806 2.50971C7.36884 2.56387 7.54445 2.82728 7.49029 3.09806L7.0099 5.5H9.9901L10.5097 2.90195C10.5639 2.63117 10.8273 2.45556 11.0981 2.50971C11.3688 2.56387 11.5444 2.82728 11.4903 3.09806L11.0099 5.5H13C13.2761 5.5 13.5 5.72386 13.5 6C13.5 6.27615 13.2761 6.5 13 6.5H10.8099L10.2099 9.5H13C13.2761 9.5 13.5 9.72386 13.5 10C13.5 10.2761 13.2761 10.5 13 10.5H10.0099L9.49029 13.0981C9.43613 13.3688 9.17272 13.5445 8.90194 13.4903C8.63116 13.4361 8.45555 13.1727 8.50971 12.9019L8.9901 10.5H6.0099L5.49029 13.0981C5.43613 13.3688 5.17272 13.5445 4.90194 13.4903C4.63116 13.4361 4.45555 13.1727 4.50971 12.9019L4.9901 10.5H3C2.72386 10.5 2.5 10.2761 2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H5.1901L5.7901 6.5H3C2.72386 6.5 2.5 6.27615 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H5.9901L6.50971 2.90195C6.56387 2.63117 6.82728 2.45556 7.09806 2.50971ZM6.8099 6.5L6.2099 9.5H9.1901L9.7901 6.5H6.8099Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const UnorderedListIcon = createCustomIcon({
  name: "Unordered list",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M2.25 3a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25h1.5A.25.25 0 0 0 4 4.75v-1.5A.25.25 0 0 0 3.75 3h-1.5Zm4.25.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm0 4a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM6 12a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 6 12ZM2 7.25A.25.25 0 0 1 2.25 7h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 2 8.75v-1.5ZM2.25 11a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h1.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25h-1.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const OrderedListIcon = createCustomIcon({
  name: "Ordered list",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M6.59838e-07 2H2V5H3V6H6.59838e-07V5H1V3H6.59838e-07V2ZM16 4H5V3H16V4ZM16 8H5V7H16V8ZM3.30721e-07 11.3333C3.30721e-07 10.4497 0.716345 9.73333 1.6 9.73333H1.91242C2.62353 9.73333 3.2 10.3098 3.2 11.0209C3.2 11.3624 3.06435 11.6899 2.82288 11.9314L1.82091 13H3V14H0.533334C0.31762 14 0.123148 13.8701 0.0405979 13.6708C-0.041952 13.4715 0.00367779 13.2421 0.15621 13.0895L2.06863 11.1771C2.11006 11.1357 2.13333 11.0795 2.13333 11.0209C2.13333 10.8989 2.03443 10.8 1.91242 10.8H1.6C1.30545 10.8 1.06667 11.0388 1.06667 11.3333H3.30721e-07ZM16 12H5V11H16V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SelectedListIcon = createCustomIcon({
  name: "Selected list",
  category: "General / Formatting",
  path: (
    <path
      d="M3.55957 9.21582L3.80469 9.45703L3.94922 9.59961L3.83887 9.77051L1.67188 13.1123L1.45508 12.8516L0.138672 11.2725L0.00976562 11.1162L0.134766 10.957L0.352539 10.6807L0.543945 10.4385L1.59277 11.6963L3.3418 9L3.55957 9.21582ZM16 12H5V11H16V12ZM16 8H5V7H16V8ZM3.55957 1.21582L3.80469 1.45703L3.94922 1.59961L3.83887 1.77051L1.67188 5.1123L1.45508 4.85156L0.138672 3.27246L0.00976562 3.11621L0.134766 2.95703L0.352539 2.68066L0.543945 2.43848L1.59277 3.69629L3.3418 1L3.55957 1.21582ZM16 4H5V3H16V4Z"
      fill="currentColor"
    />
  ),
});

export const LinkIcon = createCustomIcon({
  name: "Link",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="m6.59 12.24 1.76-1.77.71.71-1.77 1.77a3 3 0 0 1-4.24-4.24l5.66-5.66a3 3 0 0 1 4.24 4.24l-1.77 1.77-.7-.7 1.76-1.77a2 2 0 0 0-2.83-2.83L7.65 5.53l-.71-.71-2.12 2.12.7.7-1.76 1.77a2 2 0 1 0 2.83 2.83Zm3.53-6.36a.5.5 0 0 0-.7 0L5.87 9.4a.5.5 0 1 0 .7.71l3.54-3.53a.5.5 0 0 0 0-.71Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LinkRemoveIcon = createCustomIcon({
  name: "Link: remove",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="m6.59 12.24 1.76-1.77.71.71-1.77 1.77a3 3 0 1 1-4.24-4.24l5.66-5.66a3 3 0 1 1 4.24 4.24l-1.77 1.77-.7-.7 1.76-1.77a2 2 0 1 0-2.83-2.83L7.65 5.53l-.71-.71-2.12 2.12.7.7-1.76 1.77a2 2 0 0 0 2.83 2.83Zm3.53-6.36a.5.5 0 0 0-.7 0L5.87 9.4a.5.5 0 1 0 .7.71l3.54-3.53a.5.5 0 0 0 0-.71ZM10 12.5a.5.5 0 0 1 1 0V14a.5.5 0 1 1-1 0v-1.5Zm-4.5-11A.5.5 0 0 0 5 2v1.5a.5.5 0 0 0 1 0V2a.5.5 0 0 0-.5-.5ZM14 10a.5.5 0 1 1 0 1h-1.5a.5.5 0 0 1 0-1H14ZM4 5.5a.5.5 0 0 0-.5-.5H2a.5.5 0 1 0 0 1h1.5a.5.5 0 0 0 .5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const StrikethroughIcon = createCustomIcon({
  name: "Strikethrough",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M4.18182 3.99495C4.18182 2.34089 5.54012 1 7.21567 1H8.54545C10.3529 1 11.8182 2.44646 11.8182 4.23077H10.7273C10.7273 3.04123 9.75044 2.07692 8.54545 2.07692H7.21567C6.14261 2.07692 5.27273 2.93565 5.27273 3.99495C5.27273 4.9026 5.82066 5.72291 6.66576 6.08045L6.23603 7.0703C4.98982 6.54306 4.18182 5.3334 4.18182 3.99495ZM10.0636 9H2V8H14V9H11.8074C12 9 12.0697 9.14071 12.1783 9.3C12.6206 9.94812 12.9091 10.4398 12.9091 11.2166C12.9091 13.3061 11.1932 15 9.07657 15H7.45455C5.04458 15 3.09091 13.0714 3.09091 10.6923H4.18182C4.18182 12.4766 5.64707 14 7.45455 14H9.07657C10.5907 14 11.8182 12.7114 11.8182 11.2166C11.8182 10.6953 11.6201 10.1219 11.2736 9.61411C10.95 9.13985 10.5198 9.21802 10.0636 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const UnderlineIcon = createCustomIcon({
  name: "Underline",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M3 7.93333V1H4.06667V7.93333C4.06667 9.9952 5.93814 11.9333 8 11.9333C10.0619 11.9333 11.9333 9.9952 11.9333 7.93333V1H13V7.93333C13 10.5843 10.651 13 8 13C5.34903 13 3 10.5843 3 7.93333ZM14 14V15H2V14H14Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ItalicIcon = createCustomIcon({
  name: "Italic",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M8.43709 2H4V1H14V2H9.51847L7.56291 14H12V15H2V14H6.48153L8.43709 2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const BoldIcon = createCustomIcon({
  name: "Bold",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M3.16988 1.16988C3.27865 1.06111 3.42617 1 3.58 1H8.5C9.42826 1 10.3185 1.36875 10.9749 2.02513C11.6313 2.6815 12 3.57174 12 4.5C12 5.42826 11.6313 6.3185 10.9749 6.97487C10.8899 7.05989 10.8009 7.14007 10.7085 7.21526C11.1798 7.38868 11.6129 7.66317 11.9749 8.02513C12.6313 8.6815 13 9.57174 13 10.5C13 11.4283 12.6313 12.3185 11.9749 12.9749C11.3185 13.6313 10.4283 14 9.5 14H3.59C3.43352 14 3.28345 13.9378 3.17281 13.8272C3.06216 13.7165 3 13.5665 3 13.41V1.58C3 1.42617 3.06111 1.27865 3.16988 1.16988ZM4 8V13H9.5C10.163 13 10.7989 12.7366 11.2678 12.2678C11.7366 11.7989 12 11.163 12 10.5C12 9.83696 11.7366 9.20107 11.2678 8.73223C10.7989 8.26339 10.163 8 9.5 8H4ZM4 2V7H8.5C9.16304 7 9.79893 6.73661 10.2678 6.26777C10.7366 5.79893 11 5.16304 11 4.5C11 3.83696 10.7366 3.20107 10.2678 2.73223C9.79893 2.26339 9.16304 2 8.5 2H4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const OutlineIcon = createCustomIcon({
  name: "Outline",
  category: "Project / Sidebar",
  path: (
    <>
      <path
        d="M2 9a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2Z"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M1 1.5c0 .28.22.5.5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5ZM2 8V5h12v3H2Zm0 1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2Zm-1 2.5c0 .28.22.5.5.5h13a.5.5 0 0 0 0-1h-13a.5.5 0 0 0-.5.5Zm.5 3.5a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const DataSourcesIcon = createCustomIcon({
  name: "Data sources",
  category: "Project / Sidebar",
  path: (
    <>
      <path
        d="M14 2.5h-3.89L7 7.5h3L8 14l6.5-8.5H12l2-3Z"
        fill="currentColor"
        opacity="0.2"
      />
      <path
        clipRule="evenodd"
        d="M2 3v-.01c0-.17.09-.7.79-1.16C3.47 1.38 4.7 1 7 1c1 0 1.77.07 2.38.2-.22.11-.4.29-.54.5l-.24.38C8.17 2.03 7.64 2 7 2c-2.21 0-3.22.37-3.66.67-.24.15-.31.29-.34.35l.04.12c.04.11.14.3.35.49.44.38 1.42.87 3.61.87h.1l-.62 1C4.75 5.42 3.67 5.05 3 4.58v3.79l.04.05c.07.09.2.23.47.4.52.3 1.55.67 3.49.67.3 0 .57 0 .82-.02l-.31 1.01-.51.01c-2.05 0-3.27-.38-4-.82v3.02c0 .1.03.15.05.16.31.3 1.28 1.03 3.45 1.13 0 .37.13.73.38 1-2.68-.02-4-.9-4.52-1.4-.27-.26-.36-.6-.36-.9V8.53a.5.5 0 0 1 0-.04V3Zm8.11-1a.5.5 0 0 0-.42.24l-3.11 5A.5.5 0 0 0 7 8h2.32l-1.8 5.85a.5.5 0 0 0 .88.45l6.5-8.5a.5.5 0 0 0-.4-.8h-1.57l1.49-2.22A.5.5 0 0 0 14 2h-3.89ZM7.9 7l2.49-4h2.68l-1.49 2.22A.5.5 0 0 0 12 6h1.49l-4.2 5.48 1.19-3.83A.5.5 0 0 0 10 7H7.9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ResourcesIcon = createCustomIcon({
  name: "Resources",
  category: "Workspace / Curation",
  path: (
    <>
      <path
        d="M10 6c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h8ZM2 14h2V9H2v5Zm3 0h5V9H5v5Zm9-13c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1h-2V9h2V4H6v1H5V2c0-.55.45-1 1-1h8ZM2 8h8V7H2v1Zm11 0h-1V7h1v1Zm0-2h-1V5h1v1ZM6 3h8V2H6v1Z"
        fill="currentColor"
      />
      <path
        d="M6 2.00009 14 2v.99994L6 3v-.99985Z"
        fill="currentColor"
        opacity="0.3"
      />
      <path
        d="M2 7.00009 10 7v.99994L2 8v-.99985Z"
        fill="currentColor"
        opacity="0.3"
      />
    </>
  ),
});

export const DataRetentionIcon = createCustomIcon({
  name: "Data retention",
  category: "Project / Sidebar",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M6.011 8.848c-.812-.136-1.389-.346-1.787-.545a3.011 3.011 0 0 1-.724-.49V5.14c.361.221.847.422 1.5.575.002-.344.038-.68.103-1.005-.583-.147-.956-.33-1.191-.495-.245-.171-.343-.324-.382-.406a.38.38 0 0 1-.03-.083V3.54a.264.264 0 0 1 .015-.032c.03-.054.12-.18.367-.33.35-.21.999-.451 2.17-.582a5.28 5.28 0 0 1 1.094-1.08c-1.994.075-3.126.414-3.778.805-.378.227-.6.475-.727.702a1.173 1.173 0 0 0-.137.405.722.722 0 0 0-.003.04v.018l-.001.007v.005l.067.002H2.5V11.172c0 .652.265 1.359.919 1.741C4.241 13.394 5.731 14 8 14c2.27 0 3.759-.606 4.581-1.087.654-.382.919-1.09.919-1.741V9.873a5.253 5.253 0 0 1-1 .622v.677c0 .408-.162.725-.424.878-.678.397-1.994.95-4.076.95s-3.398-.553-4.076-.95c-.262-.153-.424-.47-.424-.878V9.048c.085.05.177.1.276.15.71.354 1.78.687 3.358.778a5.28 5.28 0 0 1-1.123-1.128Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.25 9a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm0 1a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.605 5.734V3.775h1v1.793l1.353 1.354-.707.707-1.47-1.47a.6.6 0 0 1-.176-.425Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const EnvironmentIcon = createCustomIcon({
  name: "Environment",
  category: "Project / Sidebar",
  path: (
    <>
      <path d="M8 14.5v-7l5.5-3V11L8 14.5Z" fill="currentColor" opacity="0.2" />
      <path
        clipRule="evenodd"
        d="M8.22.55a.5.5 0 0 0-.44 0l-6 3A.5.5 0 0 0 1.5 4v7c0 .17.08.32.22.42l6 4a.5.5 0 0 0 .56 0l6-4a.5.5 0 0 0 .22-.42V4a.5.5 0 0 0-.28-.45l-6-3ZM2.5 5.07v5.66l5 3.34a.5.5 0 0 1 0-.07V7.8l-5-2.73Zm6 9 5-3.34V5.07l-5 2.73V14a.5.5 0 0 1 0 .07Zm4.64-9.94L8 1.56 2.86 4.13 8 6.93l5.14-2.8Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const FilesIcon = createCustomIcon({
  name: "Files",
  category: "Project / Sidebar",
  path: (
    <>
      <path d="M2 7h12v7H2z" fill="currentColor" opacity="0.2" />
      <path
        clipRule="evenodd"
        d="M2 3c0-.28.23-.5.5-.5h3.47a.5.5 0 0 1 .41.22L7.24 4h6.26c.28 0 .5.22.5.5V6H2V3ZM1 6.55v5.95c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5H7.77l-.55-.83a1.5 1.5 0 0 0-1.25-.67H2.5C1.67 1.5 1 2.17 1 3v3.45a.5.5 0 0 0 0 .1ZM2 7h12v5.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V7Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const VariablesIcon = createCustomIcon({
  name: "Variables",
  category: "Project / Sidebar",
  path: (
    <path
      clipRule="evenodd"
      d="M1 1.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1H2v12h2.5a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5v-13Zm14 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1H14v12h-2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-13ZM8.43 4.74a.5.5 0 0 0-.86 0l-3 5a.5.5 0 0 0 .43.76h6a.5.5 0 0 0 .43-.76l-3-5Zm1.69 4.76H5.88L8 5.97l2.12 3.53Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ScheduledRunsIcon = createCustomIcon({
  name: "Scheduled runs",
  category: "Project / Object",
  path: (
    <path
      clipRule="evenodd"
      d="M5 2.5C5 2.22386 5.22386 2 5.5 2C5.77614 2 6 2.22386 6 2.5V3H10V2.5C10 2.22386 10.2239 2 10.5 2C10.7761 2 11 2.22386 11 2.5V3H12C13.1046 3 14 3.89543 14 5V9.73217L13 9.10782V7H3V12C3 12.5523 3.44772 13 4 13H8.5V14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H5V2.5ZM10 4V4.5C10 4.77614 10.2239 5 10.5 5C10.7761 5 11 4.77614 11 4.5V4H12C12.5523 4 13 4.44772 13 5V6H3V5C3 4.44772 3.44772 4 4 4H5V4.5C5 4.77614 5.22386 5 5.5 5C5.77614 5 6 4.77614 6 4.5V4H10ZM9.5 14C9.5 14.1818 9.59864 14.3492 9.75762 14.4373C9.91659 14.5254 10.1109 14.5203 10.265 14.424L14.265 11.924C14.4112 11.8326 14.5 11.6724 14.5 11.5C14.5 11.3276 14.4112 11.1673 14.265 11.076L10.265 8.57597C10.1109 8.47964 9.91659 8.47454 9.75762 8.56265C9.59864 8.65076 9.5 8.81821 9.5 8.99997V14ZM13.0566 11.5L10.5 13.0979V9.9021L13.0566 11.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ScheduledRunsSidebarIcon = createCustomIcon({
  name: "Scheduled runs",
  category: "Project / Sidebar",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M14 6H2V3H14V6ZM10 14L14 11.5L10 9V14Z"
        fill="currentColor"
        fillOpacity="0.2"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H13C14.1046 2 15 2.89543 15 4V9.75904L14 9.13318V6H2V12C2 12.5523 2.44772 13 3 13H8V14H3C1.89543 14 1 13.1046 1 12V4C1 2.89543 1.89543 2 3 2H5V1.5ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H13C13.5523 3 14 3.44772 14 4V5H2V4C2 3.44772 2.44772 3 3 3H5V3.5C5 3.77614 5.22386 4 5.5 4C5.77614 4 6 3.77614 6 3.5V3H10ZM9 14C9 14.3635 9.19728 14.6984 9.51523 14.8746C9.83319 15.0509 10.2217 15.0407 10.53 14.848L14.53 12.348C14.8224 12.1653 15 11.8448 15 11.5C15 11.1552 14.8224 10.8347 14.53 10.652L10.53 8.152C10.2217 7.95933 9.83319 7.94913 9.51523 8.12536C9.19728 8.30158 9 8.63647 9 9L9 14ZM10 9L14 11.5L10 14V9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const SearchIcon = createCustomIcon({
  name: "Search",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M7 11c-2.20914 0-4-1.79086-4-4s1.79086-4 4-4 4 1.79086 4 4-1.79086 4-4 4ZM2 7c0-2.76142 2.23858-5 5-5s5 2.23858 5 5c0 1.20062-.4232 2.3024-1.1285 3.1643l3.4821 3.4821c.1953.1953.1953.5119 0 .7071-.1953.1953-.5119.1953-.7071 0l-3.4821-3.4821C9.30246 11.5768 8.20065 12 7 12c-2.76142 0-5-2.23858-5-5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ProjectSearchIcon = createCustomIcon({
  name: "Project search",
  category: "Project / Sidebar",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M6 3.5c0-.28.22-.5.5-.5A3.5 3.5 0 0 1 10 6.5a.5.5 0 0 1-1 0A2.5 2.5 0 0 0 6.5 4a.5.5 0 0 1-.5-.5Z"
        fill="currentColor"
        fillOpacity=".4"
      />
      <path
        clipRule="evenodd"
        d="M6.5 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9ZM1 6.5a5.5 5.5 0 1 1 9.73 3.52l4.12 4.13a.5.5 0 1 1-.7.7l-4.13-4.12A5.5 5.5 0 0 1 1 6.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const CommandPaletteIcon = createCustomIcon({
  name: "Command palette",
  category: "Project / Sidebar",
  path: (
    <path
      clipRule="evenodd"
      d="M1.5 4a2.5 2.5 0 0 1 5 0v1.5h3V4A2.5 2.5 0 1 1 12 6.5h-1.5v3H12A2.5 2.5 0 1 1 9.5 12v-1.5h-3V12A2.5 2.5 0 1 1 4 9.5h1.5v-3H4A2.5 2.5 0 0 1 1.5 4Zm9 6.5V12a1.5 1.5 0 1 0 1.5-1.5h-1.5Zm-1-1v-3h-3v3h3Zm2.5-4h-1.5V4A1.5 1.5 0 1 1 12 5.5Zm-6.5 5H4A1.5 1.5 0 1 0 5.5 12v-1.5Zm0-6.5v1.5H4A1.5 1.5 0 1 1 5.5 4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const HelpIcon = createCustomIcon({
  name: "Help",
  category: "General / Education",
  path: (
    <path
      clipRule="evenodd"
      d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM9 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM6.288 4.675C6.603 4.276 7.096 4 7.75 4h.75c.942 0 2.125.734 2.125 2.125 0 .74-.21 1.374-.758 1.787-.35.263-.781.39-1.242.443v.77a.25.25 0 0 1-.25.25h-.75a.25.25 0 0 1-.25-.25v-1.5a.5.5 0 0 1 .5-.5h.475c.4-.03.633-.112.766-.212.124-.093.26-.278.26-.788 0-.548-.461-.875-.876-.875h-.75c-.268 0-.4.099-.48.2a.726.726 0 0 0-.145.425.625.625 0 1 1-1.25 0c0-.369.117-.824.413-1.2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DoubleChevronLeftIcon = createCustomIcon({
  name: "Chevron: Double left",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M8.53033 4.35355L4.88388 8L8.53033 11.6464L7.82322 12.3536L3.46967 8L7.82322 3.64645L8.53033 4.35355ZM12.5303 4.35355L8.88388 8L12.5303 11.6464L11.8232 12.3536L7.46967 8L11.8232 3.64645L12.5303 4.35355Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DoubleChevronRightIcon = createCustomIcon({
  name: "Chevron: Double right",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M3.46967 11.6464L7.11611 8L3.46967 4.35355L4.17677 3.64645L8.53033 8L4.17677 12.3536L3.46967 11.6464ZM7.46967 11.6464L11.1161 8L7.46967 4.35355L8.17677 3.64645L12.5303 8L8.17677 12.3536L7.46967 11.6464Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DoubleChevronUpIcon = createCustomIcon({
  name: "Chevron: Double up",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M11.646 12.53 8 8.884 4.354 12.53l-.708-.707L8 7.47l4.354 4.353-.708.707Zm0-4L8 4.884 4.354 8.53l-.708-.707L8 3.47l4.354 4.353-.708.707Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DoubleChevronDownIcon = createCustomIcon({
  name: "Chevron: Double down",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M4.354 3.47 8 7.116l3.646-3.646.707.707L8 8.53 3.646 4.177l.708-.707Zm0 4L8 11.116l3.646-3.646.707.707L8 12.53 3.646 8.177l.708-.707Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronLeftIcon = createCustomIcon({
  name: "Chevron: Single left",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="m6.884 8 3.646-3.646-.707-.708L5.47 8l4.353 4.354.707-.708L6.884 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronRightIcon = createCustomIcon({
  name: "Chevron: Single right",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M9.116 8 5.47 11.646l.707.708L10.53 8 6.177 3.646l-.707.708L9.116 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronUpIcon = createCustomIcon({
  name: "Chevron: Single up",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="m8 6.884 3.646 3.646.707-.707L8 5.47 3.646 9.823l.708.707L8 6.884Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SingleChevronDownIcon = createCustomIcon({
  name: "Chevron: Single down",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M8 9.116 4.354 5.47l-.708.707L8 10.53l4.354-4.353-.707-.707L8 9.116Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SparklesIcon = createCustomIcon({
  name: "Sparkles",
  tags: ["whats new"],
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M6.57 11.48c.28 0 .5-.23.51-.5.07-1.7.48-2.17 1.17-2.84.7-.67 1.2-1.02 2.77-1.08.28-.01.5-.23.5-.51s-.22-.5-.5-.5C9.44 5.98 8.96 5.65 8.3 5c-.68-.66-1.06-1.34-1.12-3.04a.51.51 0 0 0-.51-.5.5.5 0 0 0-.5.5c-.06 1.7-.42 2.4-1.1 3.07-.68.67-1.36 1.02-3.04 1.07-.28.01-.5.23-.5.51s.22.5.5.5c1.68.06 2.34.39 3 1.04.66.65 1 1.1 1.05 2.83 0 .27.23.5.5.5ZM7.6 5.72a4 4 0 0 0 1.32.84 4.08 4.08 0 0 0-2.3 2.28 3.88 3.88 0 0 0-.89-1.4c-.36-.36-.8-.63-1.3-.83a3.98 3.98 0 0 0 2.25-2.29 4 4 0 0 0 .92 1.4Zm3.39 8.33c.03.27.25.5.52.5.28 0 .5-.23.53-.5a2.07 2.07 0 0 1 2.01-2.03c.27-.02.5-.24.5-.51 0-.28-.23-.5-.5-.53a2.02 2.02 0 0 1-1.36-.6 1.96 1.96 0 0 1-.6-1.37.54.54 0 0 0-.53-.5c-.27 0-.5.22-.52.5a2.09 2.09 0 0 1-2 1.98.53.53 0 0 0-.5.51c0 .28.23.5.51.52.67.06 1.02.28 1.34.6.32.3.53.73.6 1.43Zm1-2.95c.16.15.33.28.52.39a2.61 2.61 0 0 0-.99.98 2.46 2.46 0 0 0-.94-.96 2.56 2.56 0 0 0 .97-.98c.12.2.27.4.44.57Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddCellAboveIcon = createCustomIcon({
  name: "Add cell above",
  category: "Project / Add cells",
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 1.5V4H5V5H7.5V7.5H8.5V5H11V4H8.5V1.5H7.5ZM1 10H15V15H1V10ZM0 10C0 9.44772 0.447715 9 1 9H15C15.5523 9 16 9.44772 16 10V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddCellBelowIcon = createCustomIcon({
  name: "Add cell below",
  category: "Project / Add cells",
  path: (
    <path
      clipRule="evenodd"
      d="M1 2H15V7H1V2ZM0 2C0 1.44772 0.447715 1 1 1H15C15.5523 1 16 1.44772 16 2V7C16 7.55228 15.5523 8 15 8H1C0.447715 8 0 7.55228 0 7V2ZM7.5 9.5V12H5V13H7.5V15.5H8.5V13H11V12H8.5V9.5H7.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddCellBelowAndRunIcon = createCustomIcon({
  name: "Add cell below and run",
  category: "Project / Add cells",
  path: (
    <path
      clipRule="evenodd"
      d="M1 2h14v2.041h1V2a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7.998V7H1V2Zm4.003 10V9.5h1V12h2.5v1h-2.5v2.5h-1V13h-2.5v-1h2.5ZM10.8 4.245a.5.5 0 0 0-.748.434v5.643a.5.5 0 0 0 .748.434l4.937-2.821a.5.5 0 0 0 0-.868l-4.937-2.822Zm3.681 3.256-3.43 1.96V5.54l3.43 1.96Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AttachFileIcon = createCustomIcon({
  name: "Attach file",
  category: "Project / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M12.2045 4.4248C12.2045 3.35196 11.3515 2.5 10.3222 2.5C9.82668 2.50004 9.34885 2.69985 8.99513 3.05957L3.99872 8.1416C3.42112 8.729 3.09442 9.5281 3.09438 10.3633C3.09438 12.1056 4.48078 13.5 6.16834 13.5C6.97995 13.4999 7.76075 13.172 8.33797 12.585L13.1902 7.65039L13.9082 8.34961L9.05496 13.2842C8.29111 14.061 7.25328 14.4999 6.16834 14.5C3.90611 14.5 2.09 12.6378 2.09 10.3633C2.09004 9.26966 2.51724 8.21887 3.28074 7.44238L8.27814 2.36035C8.81848 1.8109 9.5534 1.50004 10.3222 1.5C11.9261 1.5 13.2088 2.81977 13.2088 4.4248C13.2087 5.19673 12.907 5.93921 12.3673 6.48828L7.51406 11.4229C7.19721 11.7451 6.76532 11.9287 6.31253 11.9287C5.36709 11.9286 4.61883 11.1521 4.61861 10.2168C4.61861 9.76615 4.79458 9.33162 5.11099 9.00977L9.81904 4.22168L10.537 4.9209L5.82897 9.70898C5.6984 9.84177 5.62299 10.0245 5.62299 10.2168C5.62321 10.6199 5.94175 10.9286 6.31253 10.9287C6.49199 10.9287 6.66685 10.8561 6.79706 10.7236L11.6493 5.78906C12.0033 5.42905 12.2043 4.9384 12.2045 4.4248Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DuplicateIcon = createCustomIcon({
  name: "Duplicate",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M14 2H6v1H5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1v-1h1V2ZM2 14V6h8v8H2ZM1 6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TrashIcon = createCustomIcon({
  name: "Trash",
  category: "General / Delete",
  path: (
    <path
      clipRule="evenodd"
      d="M6 2.5a.5.5 0 0 0-.5.5v.5h5V3a.5.5 0 0 0-.5-.5H6ZM4.5 3v.5h-2a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-2V3c0-.8284-.6716-1.5-1.5-1.5H6c-.8284 0-1.5.6716-1.5 1.5ZM3 5.5v7c0 .8284.6716 1.5 1.5 1.5h7c.8284 0 1.5-.6716 1.5-1.5v-7h-1v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7H3Zm3 1a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5ZM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MoreMenuIcon = createCustomIcon({
  name: "More menu",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M3.5 8.5C3.77614 8.5 4 8.27614 4 8C4 7.72386 3.77614 7.5 3.5 7.5C3.22386 7.5 3 7.72386 3 8C3 8.27614 3.22386 8.5 3.5 8.5ZM3.5 9.5C4.32843 9.5 5 8.82843 5 8C5 7.17157 4.32843 6.5 3.5 6.5C2.67157 6.5 2 7.17157 2 8C2 8.82843 2.67157 9.5 3.5 9.5ZM8 8.5C8.27614 8.5 8.5 8.27614 8.5 8C8.5 7.72386 8.27614 7.5 8 7.5C7.72386 7.5 7.5 7.72386 7.5 8C7.5 8.27614 7.72386 8.5 8 8.5ZM8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5ZM13 8C13 8.27614 12.7761 8.5 12.5 8.5C12.2239 8.5 12 8.27614 12 8C12 7.72386 12.2239 7.5 12.5 7.5C12.7761 7.5 13 7.72386 13 8ZM14 8C14 8.82843 13.3284 9.5 12.5 9.5C11.6716 9.5 11 8.82843 11 8C11 7.17157 11.6716 6.5 12.5 6.5C13.3284 6.5 14 7.17157 14 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ChangesIcon = createCustomIcon({
  name: "Changes",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M7.85 6.35a.5.5 0 0 1-.7 0L5.5 4.71v5.79a.5.5 0 0 1-1 0V4.7L2.85 6.36a.5.5 0 1 1-.7-.7L5 2.79l2.85 2.86c.2.2.2.5 0 .7Zm.3 1.8c.2-.2.5-.2.7 0l1.65 1.64V3.5a.5.5 0 0 1 1 0v6.3l1.65-1.65a.5.5 0 0 1 .7.7L11 11.71 8.15 8.85a.5.5 0 0 1 0-.7ZM2.5 13a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddUserIcon = createCustomIcon({
  name: "Add user",
  category: "Workspace / Users",
  path: (
    <path
      clipRule="evenodd"
      d="M7 8C5.6193 8 4.5 6.8807 4.5 5.5S5.6193 3 7 3s2.5 1.1193 2.5 2.5S8.3807 8 7 8ZM3.5 5.5C3.5 3.567 5.067 2 7 2s3.5 1.567 3.5 3.5S8.933 9 7 9 3.5 7.433 3.5 5.5ZM3.0773 13c.2847-1.1486 1.3224-2 2.559-2h2.7273c1.2367 0 2.2744.8514 2.5591 2H3.0773ZM2 13.6364C2 11.6281 3.628 10 5.6364 10h2.7272C10.372 10 12 11.6281 12 13.6364a.3636.3636 0 0 1-.3636.3636H2.3636A.3636.3636 0 0 1 2 13.6364ZM12 7a.5.5 0 0 1 1 0v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0V9h-1a.5.5 0 0 1 0-1h1V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const EmailIcon = createCustomIcon({
  name: "Email",
  category: "General / Education",
  path: (
    <path
      clipRule="evenodd"
      d="M3 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3Zm0 1h10v1.7L8 8.43 3 5.7V4Zm0 2.84V12h10V6.84l-4.76 2.6a.5.5 0 0 1-.48 0L3 6.84Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ChatIcon = createCustomIcon({
  name: "Chat",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-1.58l-3.115 2.396A.5.5 0 0 1 7.5 14v-2H3a1 1 0 0 1-1-1V3Zm11 0H3v8h5a.5.5 0 0 1 .5.5v1.485l2.445-1.881A.5.5 0 0 1 11.25 11H13V3ZM5 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM5.5 7a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DocumentationIcon = createCustomIcon({
  name: "Documentation",
  category: "Workspace / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 8c0-1.339.478-2.566 1.273-3.52l1.782 1.782A2.98 2.98 0 0 0 5 8c0 .648.205 1.248.555 1.738L3.773 11.52A5.478 5.478 0 0 1 2.5 8Zm3.762-2.445L4.48 3.773A5.478 5.478 0 0 1 8 2.5c1.339 0 2.566.478 3.52 1.273L9.738 5.555A2.986 2.986 0 0 0 8 5a2.98 2.98 0 0 0-1.738.555Zm4.183.707c.35.49.555 1.09.555 1.738a2.98 2.98 0 0 1-.555 1.738l1.782 1.782A5.477 5.477 0 0 0 13.5 8a5.477 5.477 0 0 0-1.273-3.52l-1.782 1.782Zm1.075 5.965-1.782-1.782A2.98 2.98 0 0 1 8 11a2.987 2.987 0 0 1-1.738-.555L4.48 12.227A5.477 5.477 0 0 0 8 13.5a5.477 5.477 0 0 0 3.52-1.273ZM8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CopyIcon = createCustomIcon({
  name: "Copy",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M6 1.5a.5.5 0 0 0-.5.5v.5h-2a1 1 0 0 0-1 1V13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V3.5a1 1 0 0 0-1-1h-2V2a.5.5 0 0 0-.5-.5H6Zm4.5 2C10.5 4.33 9.83 5 9 5H7a1.5 1.5 0 0 1-1.5-1.5h-2V13h9V3.5h-2Zm-4 0v-1h3v1A.5.5 0 0 1 9 4H7a.5.5 0 0 1-.5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PasteIcon = createCustomIcon({
  name: "Paste",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M12.072 4.012a.5.5 0 0 1 .275.166l2.536 3.015c.076.09.117.205.117.323V14l-.005.102a1 1 0 0 1-.893.893L14 15H6l-.103-.005a1 1 0 0 1-.892-.893L5 14V5a1 1 0 0 1 .897-.995L6 4h5.964l.108.012ZM6 14h8V7.698L11.73 5H6v9ZM9.103 1.005A1 1 0 0 1 10 2v1H9V2H2v9h2v1H2l-.103-.005a1 1 0 0 1-.892-.893L1 11V2a1 1 0 0 1 .897-.995L2 1h7l.103.005ZM11.5 10a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Zm0-2a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GroupsIcon = createCustomIcon({
  name: "Groups",
  category: "Workspace / Users",
  path: (
    <path
      clipRule="evenodd"
      d="M5.5 7c-1.1046 0-2-.8954-2-2s.8954-2 2-2 2 .8954 2 2-.8954 2-2 2Zm-3-2c0-1.6568 1.3432-3 3-3 1.6569 0 3 1.3432 3 3 0 1.6569-1.3431 3-3 3-1.6568 0-3-1.3431-3-3Zm8 6.5h2c.8284 0 1.5.6716 1.5 1.5h-3v1h3c.5523 0 1-.4477 1-1 0-1.3807-1.1193-2.5-2.5-2.5h-2v1ZM6.3326 10h-1.665c-1.2844 0-2.3599.9732-2.4877 2.2512L2.1051 13h6.79l-.0749-.7488C8.6924 10.9732 7.617 10 6.3326 10Zm-1.665-1c-1.7982 0-3.3038 1.3625-3.4827 3.1517l-.0749.7488C1.0512 13.4892 1.5135 14 2.105 14h6.7901c.5916 0 1.054-.5108.995-1.0995l-.0748-.7488C9.6363 10.3625 8.1308 9 6.3326 9h-1.665ZM11.5 8.5c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1Zm-2-1c0-1.1046.8954-2 2-2s2 .8954 2 2-.8954 2-2 2-2-.8954-2-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AiCreditStack1Icon = createCustomIcon({
  name: "AI credit stack (1)",
  category: "Workspace / Billing",
  tags: ["credits", "model picker"],
  path: (
    <path
      clipRule="evenodd"
      d="M13.5 11.8184C13.4999 12.9272 12.7943 13.8598 11.8037 14.4902C10.8071 15.1243 9.46095 15.5 8 15.5C6.53905 15.5 5.19285 15.1243 4.19629 14.4902C3.20567 13.8598 2.50008 12.9272 2.5 11.8184L2.5 9.5C2.5 8.32556 3.1807 7.31316 4.17773 6.61523C5.17633 5.91626 6.52935 5.5 8 5.5C9.47066 5.5 10.8237 5.91626 11.8223 6.61523C12.8193 7.31316 13.5 8.32556 13.5 9.5V11.8184ZM12.5 11.8096C12.2972 12.019 12.0696 12.2117 11.8223 12.3848C10.8237 13.0837 9.47065 13.5 8 13.5C6.52934 13.5 5.17633 13.0837 4.17773 12.3848C3.93045 12.2117 3.70281 12.019 3.5 11.8096V11.8184C3.50008 12.4666 3.91367 13.1254 4.73242 13.6465C5.54547 14.1639 6.69969 14.5 8 14.5C9.30031 14.5 10.4545 14.1639 11.2676 13.6465C12.0863 13.1254 12.4999 12.4666 12.5 11.8184V11.8096ZM12.5 9.5C12.5 8.74146 12.0616 8.00339 11.249 7.43457C10.438 6.86685 9.29071 6.5 8 6.5C6.70929 6.5 5.56201 6.86685 4.75098 7.43457C3.93841 8.00339 3.5 8.74146 3.5 9.5C3.5 10.2585 3.93841 10.9966 4.75098 11.5654C5.56201 12.1332 6.70929 12.5 8 12.5C9.29071 12.5 10.438 12.1332 11.249 11.5654C12.0616 10.9966 12.5 10.2585 12.5 9.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AiCreditStack2Icon = createCustomIcon({
  name: "AI credit stack (2)",
  category: "Workspace / Billing",
  tags: ["credits", "model picker"],
  path: (
    <path
      clipRule="evenodd"
      d="M13.5 11.8184C13.4999 12.9272 12.7943 13.8598 11.8037 14.4902C10.8071 15.1243 9.46095 15.5 8 15.5C6.53905 15.5 5.19285 15.1243 4.19629 14.4902C3.20567 13.8598 2.50008 12.9272 2.5 11.8184L2.5 7.5C2.5 6.32556 3.1807 5.31316 4.17773 4.61523C5.17633 3.91626 6.52935 3.5 8 3.5C9.47066 3.5 10.8237 3.91626 11.8223 4.61523C12.8193 5.31316 13.5 6.32556 13.5 7.5V11.8184ZM12.5 7.5C12.5 6.74146 12.0616 6.00339 11.249 5.43457C10.438 4.86685 9.29071 4.5 8 4.5C6.7093 4.5 5.56201 4.86685 4.75098 5.43457C3.93841 6.00339 3.5 6.74146 3.5 7.5C3.5 8.25854 3.93841 8.99661 4.75098 9.56543C5.56201 10.1332 6.70929 10.5 8 10.5C9.29071 10.5 10.438 10.1332 11.249 9.56543C12.0616 8.99661 12.5 8.25854 12.5 7.5ZM12.5 9.80957C12.2972 10.019 12.0696 10.2117 11.8223 10.3848C10.8237 11.0837 9.47065 11.5 8 11.5C6.52935 11.5 5.17633 11.0837 4.17773 10.3848C3.93045 10.2117 3.70281 10.019 3.5 9.80957V9.81836C3.50008 10.4666 3.91367 11.1254 4.73242 11.6465C5.54547 12.1639 6.69969 12.5 8 12.5C9.30031 12.5 10.4545 12.1639 11.2676 11.6465C12.035 11.1581 12.4465 10.5487 12.4951 9.94043L12.5 9.81836V9.80957ZM12.4941 11.9551C12.2867 12.1514 12.0545 12.3306 11.8037 12.4902C10.8071 13.1243 9.46095 13.5 8 13.5C6.53905 13.5 5.19285 13.1243 4.19629 12.4902C3.94571 12.3308 3.71413 12.1512 3.50684 11.9551C3.56091 12.5585 3.97121 13.162 4.73242 13.6465C5.54547 14.1639 6.69969 14.5 8 14.5C9.30031 14.5 10.4545 14.1639 11.2676 13.6465C12.0288 13.162 12.4401 12.5585 12.4941 11.9551Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AiCreditStack3Icon = createCustomIcon({
  name: "AI credit stack (3)",
  category: "Workspace / Billing",
  tags: ["credits", "model picker"],
  path: (
    <path
      clipRule="evenodd"
      d="M9 0C10.4707 6.42844e-08 11.8237 0.41626 12.8223 1.11523C13.8193 1.81316 14.5 2.82556 14.5 4V6.31836C14.4999 7.42716 13.7943 8.35984 12.8037 8.99023C12.706 9.05241 12.6042 9.11087 12.5 9.16797V11.8184C12.4999 12.9272 11.7943 13.8598 10.8037 14.4902C9.80715 15.1243 8.46095 15.5 7 15.5C5.53905 15.5 4.19285 15.1243 3.19629 14.4902C2.20567 13.8598 1.50008 12.9272 1.5 11.8184V7.5C1.5 6.32556 2.1807 5.31316 3.17773 4.61523C3.28136 4.5427 3.389 4.47352 3.5 4.40723V4C3.5 2.82556 4.1807 1.81316 5.17773 1.11523C6.17633 0.41626 7.52935 2.56942e-08 9 0ZM11.4941 11.9551C11.2867 12.1514 11.0545 12.3306 10.8037 12.4902C9.80715 13.1243 8.46095 13.5 7 13.5C5.53905 13.5 4.19285 13.1243 3.19629 12.4902C2.94571 12.3308 2.71413 12.1512 2.50684 11.9551C2.56091 12.5585 2.97121 13.162 3.73242 13.6465C4.54547 14.1639 5.69969 14.5 7 14.5C8.30031 14.5 9.45453 14.1639 10.2676 13.6465C11.0288 13.162 11.4401 12.5585 11.4941 11.9551ZM11.5 9.80957C11.2972 10.019 11.0696 10.2117 10.8223 10.3848C9.82367 11.0837 8.47065 11.5 7 11.5C5.52935 11.5 4.17633 11.0837 3.17773 10.3848C2.93045 10.2117 2.70281 10.019 2.5 9.80957V9.81836C2.50008 10.4666 2.91367 11.1254 3.73242 11.6465C4.54547 12.1639 5.69969 12.5 7 12.5C8.30031 12.5 9.45453 12.1639 10.2676 11.6465C11.035 11.1581 11.4465 10.5487 11.4951 9.94043L11.5 9.81836V9.80957ZM3.5 5.62598C2.84872 6.16425 2.5 6.8238 2.5 7.5C2.5 8.25854 2.93841 8.99661 3.75098 9.56543C4.56201 10.1332 5.70929 10.5 7 10.5C7.9327 10.5 8.78892 10.305 9.49902 9.98438C9.33442 9.99413 9.168 10 9 10C7.53905 10 6.19285 9.6243 5.19629 8.99023C4.20567 8.35984 3.50008 7.42716 3.5 6.31836V5.62598ZM13.5 6.30957C13.2972 6.51904 13.0696 6.71166 12.8223 6.88477C11.8237 7.58374 10.4707 8 9 8C7.52934 8 6.17633 7.58374 5.17773 6.88477C4.93045 6.71166 4.70281 6.51904 4.5 6.30957V6.31836C4.50008 6.96663 4.91367 7.62539 5.73242 8.14648C6.54547 8.66388 7.69969 9 9 9C10.3003 9 11.4545 8.66388 12.2676 8.14648C13.0863 7.62539 13.4999 6.96663 13.5 6.31836V6.30957ZM9 1C7.70929 1 6.56201 1.36685 5.75098 1.93457C4.93841 2.50339 4.5 3.24146 4.5 4C4.5 4.75854 4.93841 5.49661 5.75098 6.06543C6.56201 6.63315 7.70929 7 9 7C10.2907 7 11.438 6.63315 12.249 6.06543C13.0616 5.49661 13.5 4.75854 13.5 4C13.5 3.24146 13.0616 2.50339 12.249 1.93457C11.438 1.36685 10.2907 1 9 1Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CreditCardIcon = createCustomIcon({
  name: "Credit card",
  category: "Workspace / Billing",
  path: (
    <path
      clipRule="evenodd"
      d="M2 5.17v5.69A2 2 0 0 0 4.14 13h7.72c.12 0 .27 0 .4-.02A2 2 0 0 0 14 10.86V5.14c0-.12 0-.27-.02-.4A2 2 0 0 0 11.86 3H4.14c-.12 0-.27 0-.4.02A2 2 0 0 0 2 5.14v.03ZM4.17 12h-.3a1 1 0 0 1-.86-.87l-.01-.3V4.87A1 1 0 0 1 3.88 4l.3-.01h7.96a1 1 0 0 1 .86.87l.01.3V6H3v1h10v4.13a1 1 0 0 1-.87.86l-.3.01H4.17ZM4 9.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM9.5 9a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const KeyIcon = createCustomIcon({
  name: "Key",
  category: "General / Sharing",
  path: (
    <path
      clipRule="evenodd"
      d="M10.5 7.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-3-2a3 3 0 1 1 1.26 2.45L6.71 10l1.14 1.15a.5.5 0 0 1-.7.7L6 10.71 4.7 12l1.15 1.15a.5.5 0 0 1-.7.7L4 12.71l-.65.64a.5.5 0 0 1-.7-.7l1-1 2-2 2.4-2.41A2.99 2.99 0 0 1 7.5 5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DisableIcon = createCustomIcon({
  name: "Disable",
  category: "General / Prevent",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM4.48 3.773a5.5 5.5 0 0 1 7.746 7.746L4.482 3.774Zm-.707.707a5.5 5.5 0 0 0 7.746 7.746L3.774 4.48Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DatabaseConnectionIcon = createCustomIcon({
  name: "Database connection",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M8.8378 1.7075a1.5031 1.5031 0 0 1 .0675-.0994C8.3683 1.5394 7.7388 1.5 7.0003 1.5c-2.2898 0-3.532.3787-4.2148.834-.7186.479-.7853 1.0203-.7853 1.166v4.4844a.5045.5045 0 0 0 0 .0311v3.4689c0 .2551.0662.5544.277.8024.4644.5465 1.7035 1.602 4.3058 1.7051a1.4964 1.4964 0 0 1-.0059-.9662l.0115-.0345c-2.2897-.0992-3.2617-1.0135-3.5495-1.352-.0146-.0172-.0389-.0618-.0389-.1548V9.1831c.7274.4341 1.9486.8169 4 .8169.2045 0 .4008-.0038.5891-.011L7.919 9h-.9188c-1.9418 0-2.9692-.3646-3.4928-.6787-.2608-.1565-.4013-.3031-.472-.3939a.8234.8234 0 0 1-.0352-.0486V5.19c.6254.3917 1.6135.7079 3.1793.7894l.6104-.9808c-2.0525-.0265-2.9974-.4397-3.4201-.7684-.2144-.1667-.3026-.3174-.3397-.4039a.4411.4411 0 0 1-.0293-.0916l-.0006-.0033v-.2006c.0156-.0482.0839-.1942.34-.3649.4421-.2948 1.4499-.666 3.66-.666.4957 0 .9309.0187 1.3128.051l.5248-.8435ZM2.9963 3.5478a.037.037 0 0 1 .002-.0106.0361.0361 0 0 1-.002.0106ZM10.1112 2a.5.5 0 0 0-.4245.2358l-3.1112 5A.5.5 0 0 0 7 8h2.3063l-1.7806 5.3419a.5.5 0 0 0 .8707.4629l6.1513-8A.5.5 0 0 0 14.1514 5h-1.7171l1.4817-2.2226A.5.5 0 0 0 13.5 2h-3.3888ZM7.9 7l2.489-4h2.1767L11.084 5.2226A.5.5 0 0 0 11.5 6h1.6362L9.413 10.8421l1.0613-3.184A.4997.4997 0 0 0 10 7H7.9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const FolderIcon = createCustomIcon({
  name: "Folder",
  category: "Data",
  path: (
    <path
      clipRule="evenodd"
      d="M3 4c0-.28.22-.5.5-.5h2.46a.5.5 0 0 1 .42.22L7.23 5h5.27c.28 0 .5.22.5.5V6H3V4ZM2 7V4c0-.83.67-1.5 1.5-1.5h2.46c.5 0 .97.25 1.25.67l.56.83h4.73c.83 0 1.5.67 1.5 1.5V12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 2 12V7Zm1 0h10v5a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 3 12V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TreeIcon = createCustomIcon({
  name: "Tree",
  category: "Data",
  path: (
    <path
      clipRule="evenodd"
      d="M2 1C1.44772 1 1 1.44772 1 2V4C1 4.55228 1.44772 5 2 5H2.5V12.5C2.5 13.0523 2.94772 13.5 3.5 13.5H8V14C8 14.5523 8.44772 15 9 15H14C14.5523 15 15 14.5523 15 14V12C15 11.4477 14.5523 11 14 11H9C8.44772 11 8 11.4477 8 12V12.5H3.5V8.5H8V9C8 9.55228 8.44772 10 9 10H14C14.5523 10 15 9.55228 15 9V7C15 6.44772 14.5523 6 14 6H9C8.44772 6 8 6.44772 8 7V7.5H3.5V5H7C7.55228 5 8 4.55228 8 4V2C8 1.44772 7.55228 1 7 1H2ZM7 2H2L2 4H7V2ZM14 7H9V9H14V7ZM9 12H14V14H9V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const FilledFolderIcon = createCustomIcon({
  name: "Folder: filled",
  category: "Data",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 4a.5.5 0 0 1 .5-.5h2.465a.5.5 0 0 1 .416.223L7.232 5H12.5a.5.5 0 0 1 .5.5V6H3V4ZM2 7V4a1.5 1.5 0 0 1 1.5-1.5h2.465c.501 0 .97.25 1.248.668L7.768 4H12.5A1.5 1.5 0 0 1 14 5.5V12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 12V7Zm1 0h10v5a.5.5 0 0 1-.5.5h-9A.5.5 0 0 1 3 12V7Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M2.5 12V4a1 1 0 0 1 1-1h2.465a1 1 0 0 1 .832.445L7.5 4.5h5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1Z"
        fill="currentColor"
        fillOpacity="0.25"
      />
    </>
  ),
});

export const StopwatchIcon = createCustomIcon({
  name: "Stopwatch",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M9.5 1h-3V0h3v1Zm-8 7.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 3a5.5 5.5 0 1 0 0 11A5.5 5.5 0 0 0 8 3Zm-.5 2h1v3h2v1h-3V5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ResetIcon = createCustomIcon({
  name: "Reset",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M8 4C10.7614 4 13 6.23858 13 9C13 11.7614 10.7614 14 8 14C5.23858 14 3 11.7614 3 9C3 7.87439 3.37194 6.83566 3.99963 6H2.80269C2.29218 6.88252 2 7.90714 2 9C2 12.3137 4.68629 15 8 15C11.3137 15 14 12.3137 14 9C14 5.68629 11.3137 3 8 3C7.95045 3 7.90104 3.0006 7.85178 3.00179L9 1.85358L8.29289 1.14647L5.93934 3.50002L8.29289 5.85358L9 5.14647L7.85558 4.00205C7.90355 4.00068 7.9517 4 8 4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const StopIcon = createCustomIcon({
  name: "Stop",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M12 4.242H4v8h8v-8Zm-8-1h8c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ForwardIcon = createCustomIcon({
  name: "Forward",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M8.93782 3.6204L13.2608 6.50237L13.2508 6.52237L13.9672 7L13.2508 7.47763L13.2608 7.49763L8.93783 10.3796L8.92783 10.3596L8 10.9781V3.02185L8.92782 3.6404L8.93782 3.6204ZM8.55 11.84L14.55 7.84L14.54 7.82C14.81 7.64 15 7.35 15 7C15 6.65 14.81 6.36 14.54 6.18L14.55 6.16L8.55 2.16L8.54 2.18L8.53769 2.17846C8.45659 2.12462 8.36676 2.07669 8.26819 2.04409C8.18501 2.01658 8.09561 2 8 2C7.45 2 7 2.45 7 3V11C7 11.55 7.45 12 8 12C8.09561 12 8.18499 11.9834 8.26816 11.9559C8.36674 11.9233 8.45658 11.8754 8.53769 11.8215L8.54 11.82L8.55 11.84ZM4.93783 3.62041L6 4.32852V3.12667L5.38853 2.71902L4.7 2.26L4.55231 2.16154L4.55 2.16L4.54 2.18L4.53769 2.17846C4.45658 2.12461 4.36674 2.07668 4.26817 2.04408C4.18499 2.01658 4.09561 2 4 2C3.45 2 3 2.45 3 3V11C3 11.55 3.45 12 4 12C4.0956 12 4.18498 11.9834 4.26814 11.9559C4.36673 11.9233 4.45658 11.8754 4.53769 11.8215L4.54 11.82L4.55 11.84L4.55231 11.8385L4.69999 11.74L5.38853 11.281L6 10.8733V9.67148L4.93784 10.3796L4.92784 10.3596L4 10.9781V3.02185L4.92783 3.64041L4.93783 3.62041Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const UndoIcon = createCustomIcon({
  name: "History: Undo",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M5.354 4.354a.5.5 0 1 0-.708-.708l-2.5 2.5a.5.5 0 0 0 0 .708l2.5 2.5a.5.5 0 1 0 .708-.708L3.707 7H11a2 2 0 1 1 0 4H9a.5.5 0 0 0 0 1h2a3 3 0 1 0 0-6H3.707l1.647-1.646Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ThumbsUpIcon = createCustomIcon({
  name: "Thumbs up",
  category: "Magic",
  path: (
    <path
      d="M6.441 2.499a1.807 1.807 0 0 1 3.331.237c.168.503.152 1.05-.045 1.543L9.24 5.5h2.284A2.477 2.477 0 0 1 14 7.977c0 .583-.129 1.158-.377 1.686l-1.13 2.402A2.5 2.5 0 0 1 10.23 13.5H6.606a2.5 2.5 0 0 1-1.387-.42l-.87-.58H2.5A.5.5 0 0 1 2 12V6.5a.5.5 0 0 1 .5-.5h1.293l1.045-1.045a.5.5 0 0 0 .053-.063l1.065-1.491a2.5 2.5 0 0 0 .202-.335l.283-.567Zm1.617.001a.807.807 0 0 0-.722.446l-.284.567a3.5 3.5 0 0 1-.282.47l-1.065 1.49a1.5 1.5 0 0 1-.16.19l-1.191 1.19A.5.5 0 0 1 4 7H3v4.5h1.5a.5.5 0 0 1 .277.084l.997.664a1.5 1.5 0 0 0 .832.252h3.625a1.5 1.5 0 0 0 1.357-.861l1.13-2.402A2.96 2.96 0 0 0 13 7.977c0-.816-.661-1.477-1.477-1.477H8.5a.5.5 0 0 1-.464-.686l.763-1.907c.109-.273.118-.576.025-.855a.807.807 0 0 0-.766-.552Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ThumbsUpEnabledIcon = createCustomIcon({
  name: "Thumbs up: enabled",
  category: "Magic",
  path: (
    <>
      <path
        d="M7.33593 2.94624C7.47265 2.67279 7.75214 2.50006 8.05786 2.50006C8.40519 2.50006 8.71376 2.72248 8.82365 3.05216C8.91667 3.33122 8.90779 3.63431 8.79857 3.90734L8.03576 5.81437C7.97414 5.96842 7.99295 6.14299 8.08597 6.28038C8.17898 6.41777 8.33409 6.50007 8.5 6.50007H11.5232C12.3388 6.50007 13 7.16122 13 7.9768C13 8.41242 12.9038 8.84267 12.7183 9.23683L11.588 11.6387C11.3406 12.1645 10.8118 12.5 10.2308 12.5H6.60554C6.30941 12.5 6.0199 12.4124 5.7735 12.2481L4.77735 11.584C4.69521 11.5293 4.59871 11.5001 4.5 11.5001H3V7.00006H4C4.13261 7.00006 4.25979 6.94738 4.35355 6.85361L5.54503 5.66214C5.60345 5.60371 5.65695 5.54057 5.70497 5.47333L6.77005 3.98222C6.8763 3.83347 6.97073 3.67663 7.05248 3.51313L7.33593 2.94624Z"
        fill="currentColor"
        opacity=".3"
      />
      <path
        clipRule="evenodd"
        d="M6.4415 2.49903C6.74762 1.88679 7.37336 1.50006 8.05786 1.50006C8.8358 1.50006 9.52639 1.99809 9.77234 2.73593C9.94012 3.2393 9.92414 3.78601 9.72705 4.27873L9.23852 5.50007H11.5232C12.8911 5.50007 14 6.60894 14 7.9768C14 8.55963 13.8713 9.13527 13.6231 9.66262L12.4928 12.0645C12.0805 12.9408 11.1992 13.5 10.2308 13.5H6.60554C6.11199 13.5 5.62947 13.354 5.21881 13.0802L4.34861 12.5001H2.5C2.22386 12.5001 2 12.2762 2 12.0001V6.50006C2 6.22392 2.22386 6.00006 2.5 6.00006H3.79289L4.83792 4.95503C4.8574 4.93556 4.87523 4.91451 4.89124 4.8921L5.95632 3.40098C6.03221 3.29473 6.09966 3.1827 6.15805 3.06592L6.4415 2.49903ZM8.05786 2.50006C7.75214 2.50006 7.47265 2.67279 7.33593 2.94624L7.05248 3.51313C6.97073 3.67663 6.8763 3.83347 6.77005 3.98222L5.70497 5.47333C5.65695 5.54057 5.60345 5.60371 5.54503 5.66214L4.35355 6.85361C4.25979 6.94738 4.13261 7.00006 4 7.00006H3V11.5001H4.5C4.59871 11.5001 4.69521 11.5293 4.77735 11.584L5.7735 12.2481C6.0199 12.4124 6.30941 12.5 6.60554 12.5H10.2308C10.8118 12.5 11.3406 12.1645 11.588 11.6387L12.7183 9.23683C12.9038 8.84267 13 8.41242 13 7.9768C13 7.16122 12.3388 6.50007 11.5232 6.50007H8.5C8.33409 6.50007 8.17898 6.41777 8.08597 6.28038C7.99295 6.14299 7.97414 5.96842 8.03576 5.81437L8.79857 3.90734C8.90779 3.63431 8.91667 3.33122 8.82365 3.05216C8.71376 2.72248 8.40519 2.50006 8.05786 2.50006Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ThumbsDownIcon = createCustomIcon({
  name: "Thumbs down",
  category: "Magic",
  path: (
    <path
      d="M9.558 13.501a1.807 1.807 0 0 1-3.33-.237 2.244 2.244 0 0 1 .045-1.543l.488-1.22H4.477A2.477 2.477 0 0 1 2 8.022c0-.582.129-1.158.377-1.685l1.13-2.402A2.5 2.5 0 0 1 5.77 2.5h3.625a2.5 2.5 0 0 1 1.387.42l.87.58H13.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5h-1.293l-1.045 1.045a.508.508 0 0 0-.053.063l-1.065 1.491a2.498 2.498 0 0 0-.202.335l-.284.567Zm-1.616 0a.807.807 0 0 0 .722-.447l.283-.567c.082-.164.177-.32.283-.47l1.065-1.49a1.5 1.5 0 0 1 .16-.189l1.191-1.191A.5.5 0 0 1 12 9h1V4.5h-1.5a.5.5 0 0 1-.277-.084l-.997-.664a1.5 1.5 0 0 0-.832-.252H5.77a1.5 1.5 0 0 0-1.357.861l-1.13 2.402A2.96 2.96 0 0 0 3 8.023C3 8.84 3.661 9.5 4.477 9.5H7.5a.5.5 0 0 1 .464.686l-.763 1.907a1.245 1.245 0 0 0-.025.855c.11.33.419.552.766.552Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ThumbsDownEnabledIcon = createCustomIcon({
  name: "Thumbs down: enabled",
  category: "Magic",
  path: (
    <>
      <path
        d="M8.664 13.054a.807.807 0 0 1-1.488-.106 1.244 1.244 0 0 1 .025-.855l.763-1.907A.5.5 0 0 0 7.5 9.5H4.477A1.477 1.477 0 0 1 3 8.023c0-.435.096-.866.282-1.26l1.13-2.402a1.5 1.5 0 0 1 1.357-.86h3.625a1.5 1.5 0 0 1 .832.251l.997.664a.5.5 0 0 0 .277.084H13V9h-1a.5.5 0 0 0-.354.147l-1.191 1.191a1.5 1.5 0 0 0-.16.189l-1.065 1.49c-.106.15-.2.306-.283.47l-.283.567Z"
        fill="currentColor"
        opacity=".3"
      />
      <path
        clipRule="evenodd"
        d="M9.558 13.501a1.807 1.807 0 0 1-3.33-.237 2.244 2.244 0 0 1 .045-1.543l.488-1.22H4.477A2.477 2.477 0 0 1 2 8.022c0-.582.129-1.158.377-1.685l1.13-2.402A2.5 2.5 0 0 1 5.77 2.5h3.625a2.5 2.5 0 0 1 1.387.42l.87.58H13.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 0 1-.5.5h-1.293l-1.045 1.045a.508.508 0 0 0-.053.063l-1.065 1.491a2.498 2.498 0 0 0-.202.335l-.284.567Zm-1.616 0a.807.807 0 0 0 .722-.447l.283-.567c.082-.164.177-.32.283-.47l1.065-1.49a1.5 1.5 0 0 1 .16-.189l1.191-1.191A.5.5 0 0 1 12 9h1V4.5h-1.5a.5.5 0 0 1-.277-.084l-.997-.664a1.5 1.5 0 0 0-.832-.252H5.77a1.5 1.5 0 0 0-1.357.861l-1.13 2.402A2.96 2.96 0 0 0 3 8.023C3 8.84 3.661 9.5 4.477 9.5H7.5a.5.5 0 0 1 .464.686l-.763 1.907c-.109.273-.118.576-.025.855.11.33.419.552.766.552Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const MentionIcon = createCustomIcon({
  name: "Mention",
  category: "Magic",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M6.92701 3.10568C7.9939 2.89347 9.09977 3.00238 10.1048 3.41867C11.1098 3.83495 11.9687 4.5399 12.5731 5.44437C13.1774 6.34884 13.5 7.41221 13.5 8.5C13.5 9.14263 13.3816 9.66199 13.1691 10.0038C12.9753 10.3156 12.6951 10.5 12.25 10.5C11.8049 10.5 11.5247 10.3156 11.3309 10.0038C11.1184 9.66199 11 9.14263 11 8.5V6C11 5.72386 10.7761 5.5 10.5 5.5C10.2239 5.5 10 5.72386 10 6V6.2639C9.46925 5.78885 8.76836 5.5 8 5.5C6.34315 5.5 5 6.84315 5 8.5C5 10.1569 6.34315 11.5 8 11.5C8.96492 11.5 9.82344 11.0444 10.3722 10.3367C10.406 10.4036 10.4425 10.4687 10.4816 10.5317C10.8503 11.1248 11.4451 11.5 12.25 11.5C13.0549 11.5 13.6497 11.1248 14.0184 10.5317C14.3684 9.96864 14.5 9.238 14.5 8.5C14.5 7.21442 14.1188 5.95772 13.4046 4.8888C12.6903 3.81988 11.6752 2.98676 10.4874 2.49479C9.29973 2.00282 7.99279 1.87409 6.73192 2.1249C5.47104 2.3757 4.31285 2.99477 3.40381 3.90381C2.49477 4.81285 1.8757 5.97104 1.6249 7.23192C1.37409 8.49279 1.50282 9.79973 1.99479 10.9874C2.48676 12.1752 3.31988 13.1903 4.3888 13.9046C5.45772 14.6188 6.71442 15 8 15C9.31327 15 10.7346 14.6091 11.7768 13.9164C12.0068 13.7635 12.0693 13.4532 11.9164 13.2232C11.7635 12.9932 11.4532 12.9307 11.2232 13.0836C10.3641 13.6546 9.14049 14 8 14C6.91221 14 5.84884 13.6774 4.94437 13.0731C4.0399 12.4687 3.33495 11.6098 2.91867 10.6048C2.50238 9.59977 2.39347 8.4939 2.60568 7.42701C2.8179 6.36011 3.34173 5.3801 4.11092 4.61092C4.8801 3.84173 5.86011 3.3179 6.92701 3.10568ZM6 8.5C6 7.39543 6.89543 6.5 8 6.5C9.10457 6.5 10 7.39543 10 8.5C10 9.60457 9.10457 10.5 8 10.5C6.89543 10.5 6 9.60457 6 8.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const RedoIcon = createCustomIcon({
  name: "History: Redo",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M10.646 4.354a.5.5 0 0 1 .708-.708l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L12.293 7H5a2 2 0 1 0 0 4h2a.5.5 0 0 1 0 1H5a3 3 0 1 1 0-6h7.293l-1.647-1.646Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ClockIcon = createCustomIcon({
  name: "Clock",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6.5-3.5a.5.5 0 0 0-1 0v3.71l2.15 2.11a.5.5 0 1 0 .7-.71L8.5 7.79V4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LogOutIcon = createCustomIcon({
  name: "Log out",
  category: "Workspace / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M7 12.9999c.27614 0 .5.2239.5.5 0 .2762-.22386.5-.5.5H2.5c-.13261 0-.25979-.0526-.35355-.1464C2.05268 13.7597 2 13.6325 2 13.4999V2.49994c0-.27614.22386-.5.5-.5H7c.27614 0 .5.22386.5.5s-.22386.5-.5.5H3v9.99996h4Zm3.1464-1.1463c-.19522-.1953-.19522-.5119 0-.7072L12.7929 8.5H5.5c-.27614 0-.5-.22386-.5-.5 0-.27615.22386-.5.5-.5h7.2929l-2.6465-2.64645c-.19522-.19526-.19522-.51184 0-.70711.1953-.19526.5119-.19526.7072 0l3.5 3.5c.0937.09377.1464.22095.1464.35356 0 .1326-.0527.25978-.1464.35355l-3.5 3.50005c-.1953.1952-.5119.1952-.7072 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LogInIcon = createCustomIcon({
  name: "Log in",
  category: "Workspace / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M9 13c-.27614 0-.5.2239-.5.5s.22386.5.5.5h4.5c.1326 0 .2598-.0527.3536-.1464.0937-.0938.1464-.221.1464-.3536v-11c0-.27614-.2239-.5-.5-.5H9c-.27614 0-.5.22386-.5.5s.22386.5.5.5h4v10H9Zm-2.85355-1.1465c-.19527-.1953-.19527-.5119 0-.7071L8.79283 8.5H2c-.27614 0-.5-.22386-.5-.5s.22386-.5.5-.5h6.79296L6.14645 4.85349c-.19527-.19526-.19527-.51184 0-.7071.19526-.19527.51184-.19527.7071 0l3.50005 3.49999c.0195.01951.0372.04046.053.06261.0571.07958.0914.17661.0933.28154l.0001.00941V8c0 .14047-.0579.26742-.1512.35825L6.85355 11.8535c-.19526.1953-.51184.1953-.7071 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CutIcon = createCustomIcon({
  name: "Cut",
  category: "Cells / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM4 2.5a2.5 2.5 0 1 0 1.45 4.54l2.3 1.15-1.8 1.24a2.5 2.5 0 1 0 .46.9l7.87-5.42a.5.5 0 1 0-.56-.82L8.7 7.54 6.15 6.27A2.5 2.5 0 0 0 4 2.5ZM2.5 11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm7.28-1.55a.5.5 0 0 1-.12-.08l.94-.63 3.62 1.81a.5.5 0 1 1-.44.9l-4-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const HistoryIcon = createCustomIcon({
  name: "History",
  category: "Project / Sidebar",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M4 12.47A5.98 5.98 0 0 1 8 2a6 6 0 1 1-1 11.92v1A7 7 0 1 0 3.1 13l-2.1.01a.5.5 0 1 0 0 1h4v-4a.5.5 0 0 0-1 0v3-.53ZM8 4c.28 0 .5.22.5.5v3.29l1.85 1.82a.5.5 0 0 1-.7.71L7.5 8.21V4.5c0-.28.22-.5.5-.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.24 12.24A6 6 0 0 0 8 2v6l4.24 4.24Z"
        fill="currentColor"
        fillRule="evenodd"
        opacity="0.2"
      />
    </>
  ),
});

export const RecentsIcon = createCustomIcon({
  name: "Recents",
  category: "Workspace / Navigation",
  path: (
    <>
      <path
        d="M5.03566 12.0269C3.80097 11.1164 3.00003 9.65176 3.00003 8C3.00003 5.23858 5.23861 3 8.00003 3C10.7615 3 13 5.23858 13 8C13 10.7496 10.7807 12.9807 8.03562 12.9999V13.9999C11.3329 13.9807 14 11.3018 14 8C14 4.68629 11.3137 2 8.00003 2C4.68632 2 2.00003 4.68629 2.00003 8C2.00003 9.80177 2.79422 11.4181 4.05163 12.5179L2.00012 12.5179C1.72398 12.5179 1.50012 12.7417 1.50012 13.0179C1.50012 13.294 1.72398 13.5179 2.00012 13.5179H6.03566V9.51781C6.03566 9.24167 5.8118 9.01781 5.53566 9.01782C5.25951 9.01781 5.03566 9.24167 5.03566 9.51781V12.0269Z"
        fill="currentColor"
      />
      <path
        d="M8.00003 4C8.27617 4 8.50003 4.22386 8.50003 4.5V7.79023L10.3504 9.60739C10.5474 9.80088 10.5503 10.1175 10.3568 10.3145C10.1633 10.5115 9.84671 10.5144 9.64969 10.3209L7.50003 8.20975V4.5C7.50003 4.22386 7.72389 4 8.00003 4Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SnapshotIcon = createCustomIcon({
  name: "Snapshot",
  category: "Project / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M3 2h5v1H3V2Zm-.5 3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-11ZM1 5.5A1.5 1.5 0 0 1 2.5 4h11A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5v-7Zm7 3a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM10.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PictureIcon = createCustomIcon({
  name: "Picture",
  category: "Project / Actions",
  path: (
    <path
      d="m13 10.773-1.857-1.856-1.925 1.924a.6.6 0 0 1-.893-.05L5.643 7.44 3 10.746v1.968c0 .158.128.286.286.286h9.428a.286.286 0 0 0 .286-.286v-1.94ZM11 5v1h-1V5h1Zm2-1.714A.286.286 0 0 0 12.714 3H3.286A.286.286 0 0 0 3 3.286v5.859l2.174-2.72a.6.6 0 0 1 .937 0l2.716 3.393 1.892-1.89a.6.6 0 0 1 .848 0L13 9.359V3.286Zm1 9.428c0 .71-.576 1.286-1.286 1.286H3.286C2.576 14 2 13.424 2 12.714V3.286C2 2.576 2.576 2 3.286 2h9.428C13.424 2 14 2.576 14 3.286v9.428Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ApplicationIcon = createCustomIcon({
  name: "Application",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M0 2.5C0 1.67157 0.671573 1 1.5 1H14.5C15.3284 1 16 1.67157 16 2.5V13.5C16 14.3284 15.3284 15 14.5 15H1.5C0.671573 15 0 14.3284 0 13.5V2.5ZM1.5 2C1.22386 2 1 2.22386 1 2.5V4H15V2.5C15 2.22386 14.7761 2 14.5 2H1.5ZM1 13.5V5H15V13.5C15 13.7761 14.7761 14 14.5 14H1.5C1.22386 14 1 13.7761 1 13.5ZM3 12H10V11H3V12ZM12 8H3V7H12V8ZM3 10H8V9H3V10Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SavedViewIcon = createCustomIcon({
  name: "Saved view",
  category: "Project / Object",
  path: (
    <path
      clipRule="evenodd"
      d="M3 2C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2H3ZM3 3L13 3V13H3V3ZM5.5 5C5.22386 5 5 5.22386 5 5.5C5 5.77614 5.22386 6 5.5 6H8.5C8.77614 6 9 5.77614 9 5.5C9 5.22386 8.77614 5 8.5 5H5.5ZM5 7.5C5 7.22386 5.22386 7 5.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H5.5C5.22386 8 5 7.77614 5 7.5ZM5.5 9C5.22386 9 5 9.22386 5 9.5C5 9.77614 5.22386 10 5.5 10H10.5C10.7761 10 11 9.77614 11 9.5C11 9.22386 10.7761 9 10.5 9H5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AddSavedViewIcon = createCustomIcon({
  name: "Add Saved view",
  category: "Project / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M5 5.5C5 5.22386 5.22386 5 5.5 5H8.5C8.77614 5 9 5.22386 9 5.5C9 5.77614 8.77614 6 8.5 6H5.5C5.22386 6 5 5.77614 5 5.5ZM5 7.5C5 7.22386 5.22386 7 5.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H5.5C5.22386 8 5 7.77614 5 7.5ZM5.5 9C5.22386 9 5 9.22386 5 9.5C5 9.77614 5.22386 10 5.5 10H10.5C10.7761 10 11 9.77614 11 9.5C11 9.22386 10.7761 9 10.5 9H5.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M16 3H11V2H16V3Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M2 3.5C2 2.67157 2.67157 2 3.5 2H9.5V3H3.5C3.22386 3 3 3.22386 3 3.5V12.5C3 12.7761 3.22386 13 3.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6.5H14V12.5C14 13.3284 13.3284 14 12.5 14H3.5C2.67157 14 2 13.3284 2 12.5V3.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13 5V0H14V5H13Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ProfileIcon = createCustomIcon({
  name: "User profile",
  category: "Workspace / Users",
  path: (
    <path
      clipRule="evenodd"
      d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 2.5a5.5 5.5 0 0 0-3.85 9.428A2.236 2.236 0 0 1 6.235 10.5h3.53c.95 0 1.761.592 2.085 1.428A5.5 5.5 0 0 0 8 2.5Zm2.976 10.126c-.133-.563-.63-1.126-1.211-1.126h-3.53c-.58 0-1.078.563-1.212 1.126.858.553 1.88.874 2.977.874a5.474 5.474 0 0 0 2.976-.874ZM6 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm2-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PreferencesIcon = createCustomIcon({
  name: "Preferences",
  category: "General / Editing",
  tags: ["settings", "configure"],
  path: (
    <path
      clipRule="evenodd"
      d="M3.5 2.5a.5.5 0 0 1 1 0v2.56a2 2 0 0 1 0 3.88v4.56a.5.5 0 0 1-1 0V8.94a2 2 0 0 1 0-3.88V2.5Zm0 3.63a1 1 0 1 0 1 1.74 1 1 0 0 0-1-1.74ZM8 2a.5.5 0 0 0-.5.5v6.06a2 2 0 0 0 0 3.88v1.06a.5.5 0 0 0 1 0v-1.06a2 2 0 0 0 0-3.88V2.5A.5.5 0 0 0 8 2Zm.5 7.63a1 1 0 0 0-1 0 1 1 0 1 0 1 0ZM12 2a.5.5 0 0 0-.5.5v.56a2 2 0 0 0 0 3.88v6.56a.5.5 0 0 0 1 0V6.94a2 2 0 0 0 0-3.88V2.5A.5.5 0 0 0 12 2Zm.5 2.13a1 1 0 0 0-1 0 1 1 0 1 0 1 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const NotificationsIcon = createCustomIcon({
  name: "Notifications",
  category: "Workspace / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M6.5 2.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1H8a4.3 4.3 0 0 1 4.29 3.95l.11 1.37c.06.66.28 1.3.65 1.85l.22.33h.23a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1h.23l.22-.33c.37-.55.6-1.19.65-1.85l.11-1.37A4.3 4.3 0 0 1 8 3H7a.5.5 0 0 1-.5-.5Zm5.57 8a4.92 4.92 0 0 1-.66-2.1l-.12-1.37a3.3 3.3 0 0 0-6.58 0L4.59 8.4a4.92 4.92 0 0 1-.66 2.09h8.14ZM7.3 13.2a1 1 0 0 1-.29-.7H6a2 2 0 0 0 4 0H9a1 1 0 0 1-1.7.7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TaskIcon = createCustomIcon({
  name: "Task",
  category: "Workspace / Navigation",
  tags: ["scheduled", "calendar", "check"],
  transform: "scale(0.8)",
  path: (
    <path
      d="M16.25 2.5H14.375V1.875C14.375 1.70924 14.3092 1.55027 14.1919 1.43306C14.0747 1.31585 13.9158 1.25 13.75 1.25C13.5842 1.25 13.4253 1.31585 13.3081 1.43306C13.1908 1.55027 13.125 1.70924 13.125 1.875V2.5H6.875V1.875C6.875 1.70924 6.80915 1.55027 6.69194 1.43306C6.57473 1.31585 6.41576 1.25 6.25 1.25C6.08424 1.25 5.92527 1.31585 5.80806 1.43306C5.69085 1.55027 5.625 1.70924 5.625 1.875V2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM5.625 3.75V4.375C5.625 4.54076 5.69085 4.69973 5.80806 4.81694C5.92527 4.93415 6.08424 5 6.25 5C6.41576 5 6.57473 4.93415 6.69194 4.81694C6.80915 4.69973 6.875 4.54076 6.875 4.375V3.75H13.125V4.375C13.125 4.54076 13.1908 4.69973 13.3081 4.81694C13.4253 4.93415 13.5842 5 13.75 5C13.9158 5 14.0747 4.93415 14.1919 4.81694C14.3092 4.69973 14.375 4.54076 14.375 4.375V3.75H16.25V6.25H3.75V3.75H5.625ZM16.25 16.25H3.75V7.5H16.25V16.25ZM13.2547 9.55781C13.3128 9.61586 13.3589 9.68479 13.3904 9.76066C13.4218 9.83654 13.438 9.91787 13.438 10C13.438 10.0821 13.4218 10.1635 13.3904 10.2393C13.3589 10.3152 13.3128 10.3841 13.2547 10.4422L9.50469 14.1922C9.44664 14.2503 9.37771 14.2964 9.30184 14.3279C9.22596 14.3593 9.14463 14.3755 9.0625 14.3755C8.98037 14.3755 8.89904 14.3593 8.82316 14.3279C8.74729 14.2964 8.67836 14.2503 8.62031 14.1922L6.74531 12.3172C6.62804 12.1999 6.56215 12.0409 6.56215 11.875C6.56215 11.7091 6.62804 11.5501 6.74531 11.4328C6.86259 11.3155 7.02165 11.2497 7.1875 11.2497C7.35335 11.2497 7.51241 11.3155 7.62969 11.4328L9.0625 12.8664L12.3703 9.55781C12.4284 9.4997 12.4973 9.4536 12.5732 9.42215C12.649 9.3907 12.7304 9.37451 12.8125 9.37451C12.8946 9.37451 12.976 9.3907 13.0518 9.42215C13.1277 9.4536 13.1966 9.4997 13.2547 9.55781Z"
      fill="currentColor"
    />
  ),
});

export const TickIcon = createCustomIcon({
  name: "Tick",
  category: "General / Status",
  tags: ["check"],
  path: (
    <path
      clipRule="evenodd"
      d="m14.715 3.536-8.558 9.989-4.846-4.847.707-.707L6.1 12.054l7.856-9.168.76.65Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TickSmallIcon = createCustomIcon({
  name: "Tick (small)",
  category: "General / Status",
  tags: ["check"],
  path: (
    <path
      clipRule="evenodd"
      d="m13.266 4.857-6.329 7.91L2.734 8.68l.697-.717 3.414 3.32 5.64-7.05.781.624Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CrossIcon = createCustomIcon({
  name: "Cross",
  category: "General / Delete",
  tags: ["close", "exit"],
  path: (
    <path
      clipRule="evenodd"
      d="M7.293 8 1.646 2.354l.708-.708L8 7.293l5.646-5.647.708.708L8.707 8l5.647 5.646-.707.707L8 8.707l-5.646 5.646-.708-.707L7.293 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CrossSmallIcon = createCustomIcon({
  name: "Cross (small)",
  category: "General / Delete",
  tags: ["close", "exit"],
  path: (
    <path
      d="M11.146 4.146a.5.5 0 0 1 .707.707L8.707 8l3.146 3.146a.5.5 0 0 1-.707.707L8 8.707l-3.147 3.146a.5.5 0 0 1-.707-.707L7.293 8 4.146 4.853a.5.5 0 1 1 .707-.707L8 7.293l3.146-3.147Z"
      fill="currentColor"
    />
  ),
});

export const BankIcon = createCustomIcon({
  name: "Bank",
  category: "Workspace / Billing",
  path: (
    <path
      clipRule="evenodd"
      d="M8.17087 2.0301C8.06049 1.98997 7.93951 1.98997 7.82913 2.0301L2.32914 4.0301C2.06963 4.12447 1.93575 4.41136 2.03012 4.67087C2.12449 4.93039 2.41137 5.06427 2.67089 4.9699L8 3.03203L13.3291 4.9699C13.5887 5.06427 13.8755 4.93039 13.9699 4.67087C14.0643 4.41135 13.9304 4.12447 13.6709 4.0301L8.17087 2.0301ZM2.5 6C2.22386 6 2 6.22386 2 6.5C2 6.77614 2.22386 7 2.5 7L3 7L3 13H2.5C2.22386 13 2 13.2239 2 13.5C2 13.7761 2.22386 14 2.5 14H4H12H13.5C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13H13V7H13.5C13.7761 7 14 6.77614 14 6.5C14 6.22386 13.7761 6 13.5 6H12L4 6L2.5 6ZM12 13H4L4 7L12 7V13ZM6 8.5C6 8.22386 6.22386 8 6.5 8C6.77614 8 7 8.22386 7 8.5V11.5C7 11.7761 6.77614 12 6.5 12C6.22386 12 6 11.7761 6 11.5V8.5ZM9.5 8C9.22386 8 9 8.22386 9 8.5V11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5V8.5C10 8.22386 9.77614 8 9.5 8Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const LineChartIcon = createCustomIcon({
  name: "Line chart",
  category: "Cells / Types: Chart",
  path: (
    <path
      clipRule="evenodd"
      d="M1 1H2V14H15V15H1V1ZM13.9779 2.14704C14.0591 1.88311 13.911 1.60332 13.647 1.52211C13.3831 1.4409 13.1033 1.58903 13.0221 1.85296L11.3891 7.16019L9.96954 4.32104C9.75974 3.90145 9.14539 3.95229 9.00743 4.40067L7.36152 9.74988L5.95467 7.28789C5.73878 6.91008 5.18199 6.94872 5.02038 7.35276L3.03576 12.3143C2.9332 12.5707 3.05791 12.8617 3.3143 12.9642C3.5707 13.0668 3.86168 12.9421 3.96424 12.6857L5.57965 8.64717L7.04297 11.208C7.26883 11.6032 7.85759 11.538 7.99147 11.1029L9.61089 5.83981L11.0305 8.67896C11.2403 9.09857 11.8546 9.0477 11.9926 8.59933L13.9779 2.14704Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const BarChartIcon = createCustomIcon({
  name: "Bar chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M1 1H2V14H15V15H1V1Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13 2H14V13H13V2ZM11 5V13H10V5H11ZM8 8V13H7V8H8ZM4 13V10H5V13H4Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ScatterChartIcon = createCustomIcon({
  name: "Scatter chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M1 1H2V14H15V15H1V1Z" fill="currentColor" />
      <path
        d="M3.75 12.5C4.16421 12.5 4.5 12.1642 4.5 11.75C4.5 11.3358 4.16421 11 3.75 11C3.33579 11 3 11.3358 3 11.75C3 12.1642 3.33579 12.5 3.75 12.5Z"
        fill="currentColor"
      />
      <path
        d="M5.5 7.75C5.5 8.16421 5.16421 8.5 4.75 8.5C4.33579 8.5 4 8.16421 4 7.75C4 7.33579 4.33579 7 4.75 7C5.16421 7 5.5 7.33579 5.5 7.75Z"
        fill="currentColor"
      />
      <path
        d="M7.75 9.5C8.16421 9.5 8.5 9.16421 8.5 8.75C8.5 8.33579 8.16421 8 7.75 8C7.33579 8 7 8.33579 7 8.75C7 9.16421 7.33579 9.5 7.75 9.5Z"
        fill="currentColor"
      />
      <path
        d="M6.5 9.75C6.5 10.1642 6.16421 10.5 5.75 10.5C5.33579 10.5 5 10.1642 5 9.75C5 9.33579 5.33579 9 5.75 9C6.16421 9 6.5 9.33579 6.5 9.75Z"
        fill="currentColor"
      />
      <path
        d="M6.75 6.5C7.16421 6.5 7.5 6.16421 7.5 5.75C7.5 5.33579 7.16421 5 6.75 5C6.33579 5 6 5.33579 6 5.75C6 6.16421 6.33579 6.5 6.75 6.5Z"
        fill="currentColor"
      />
      <path
        d="M8.5 11.25C8.5 11.6642 8.16421 12 7.75 12C7.33579 12 7 11.6642 7 11.25C7 10.8358 7.33579 10.5 7.75 10.5C8.16421 10.5 8.5 10.8358 8.5 11.25Z"
        fill="currentColor"
      />
      <path
        d="M10.75 8.5C11.1642 8.5 11.5 8.16421 11.5 7.75C11.5 7.33579 11.1642 7 10.75 7C10.3358 7 10 7.33579 10 7.75C10 8.16421 10.3358 8.5 10.75 8.5Z"
        fill="currentColor"
      />
      <path
        d="M9.5 6.75C9.5 7.16421 9.16421 7.5 8.75 7.5C8.33579 7.5 8 7.16421 8 6.75C8 6.33579 8.33579 6 8.75 6C9.16421 6 9.5 6.33579 9.5 6.75Z"
        fill="currentColor"
      />
      <path
        d="M11.75 3.5C12.1642 3.5 12.5 3.16421 12.5 2.75C12.5 2.33579 12.1642 2 11.75 2C11.3358 2 11 2.33579 11 2.75C11 3.16421 11.3358 3.5 11.75 3.5Z"
        fill="currentColor"
      />
      <path
        d="M14.5 1.75C14.5 2.16421 14.1642 2.5 13.75 2.5C13.3358 2.5 13 2.16421 13 1.75C13 1.33579 13.3358 1 13.75 1C14.1642 1 14.5 1.33579 14.5 1.75Z"
        fill="currentColor"
      />
      <path
        d="M11.75 6.5C12.1642 6.5 12.5 6.16421 12.5 5.75C12.5 5.33579 12.1642 5 11.75 5C11.3358 5 11 5.33579 11 5.75C11 6.16421 11.3358 6.5 11.75 6.5Z"
        fill="currentColor"
      />
      <path
        d="M14 4.25C14 4.66421 13.6642 5 13.25 5C12.8358 5 12.5 4.66421 12.5 4.25C12.5 3.83579 12.8358 3.5 13.25 3.5C13.6642 3.5 14 3.83579 14 4.25Z"
        fill="currentColor"
      />
      <path
        d="M9.75 4.5C10.1642 4.5 10.5 4.16421 10.5 3.75C10.5 3.33579 10.1642 3 9.75 3C9.33579 3 9 3.33579 9 3.75C9 4.16421 9.33579 4.5 9.75 4.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const AreaChartIcon = createCustomIcon({
  name: "Area chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M1 1V15H15V14H2V1H1Z" fill="currentColor" fillOpacity="0.3" />
      <path
        d="M3.5 8.11439V12.25C3.5 12.3881 3.61193 12.5 3.75 12.5H14.75C14.8881 12.5 15 12.3881 15 12.25V3.54937C15 3.33484 14.7475 3.21995 14.5858 3.36087L9.41092 7.86927C9.3231 7.94578 9.19408 7.95151 9.09982 7.88308L6.2908 5.8437C6.19686 5.7755 6.06832 5.78094 5.98048 5.85684L3.58655 7.92522C3.53159 7.9727 3.5 8.04175 3.5 8.11439Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path
        clipRule="evenodd"
        d="M4.5 11.5H14V5.19749L10.0678 8.62326C9.6287 9.00582 8.98359 9.03445 8.51232 8.6923L6.1844 7.00221L4.5 8.45755V11.5ZM14.5858 3.36087C14.7475 3.21995 15 3.33484 15 3.54937V12.25C15 12.3881 14.8881 12.5 14.75 12.5H3.75C3.61193 12.5 3.5 12.3881 3.5 12.25V8.11439C3.5 8.04175 3.53159 7.9727 3.58655 7.92522L5.98048 5.85684C6.06832 5.78094 6.19686 5.7755 6.2908 5.8437L9.09982 7.88308C9.19408 7.95151 9.3231 7.94578 9.41092 7.86927L14.5858 3.36087ZM1 1H2V14H15V15H1V1Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const PieChartIcon = createCustomIcon({
  name: "Pie chart",
  category: "Cells / Types: Chart",
  path: (
    <path
      clipRule="evenodd"
      d="M 1 7.985 a 7 7 0 1 1 14 0 a 7 7 0 0 1 -14 0 Z m 6.5 -5.98 a 6 6 0 1 0 4.374 10.561 l -1.931 -1.931 A 3.286 3.286 0 1 1 7.5 4.737 V 2.005 Z m 1 0 v 2.732 c 0.836 0.128 1.569 0.57 2.072 1.203 l 2.545 -1.09 A 5.999 5.999 0 0 0 8.5 2.005 Z m 5.068 3.74 l -2.497 1.07 c 0.139 0.363 0.215 0.758 0.215 1.17 a 3.27 3.27 0 0 1 -0.636 1.943 l 1.931 1.931 A 5.976 5.976 0 0 0 14 7.985 c 0 -0.792 -0.153 -1.548 -0.432 -2.24 Z M 8 5.699 a 2.286 2.286 0 1 0 0 4.572 a 2.286 2.286 0 0 0 0 -4.572 Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SnowflakeIcon = createCustomIcon({
  name: "Snowflake",
  category: "Workspace / Integrations",
  path: (
    <path
      clipRule="evenodd"
      d="m5.91 6.048-2.962-1.71a.87.87 0 1 1 .87-1.508l1.683.971v-1.95a.868.868 0 1 1 1.734 0v3.427c0 .253-.107.48-.28.638a.87.87 0 0 1-1.044.132ZM5.664 8.01a.853.853 0 0 0-.425-.751L2.276 5.55a.85.85 0 0 0-.85 1.473l1.707.985-1.707.986a.84.84 0 0 0-.396.516.853.853 0 0 0 1.246.957l2.962-1.71a.855.855 0 0 0 .425-.746Zm7.368 3.668L10.07 9.968a.872.872 0 0 0-1.302.838v3.345a.867.867 0 0 0 1.734 0v-1.923l1.66.958a.87.87 0 1 0 .87-1.507ZM9.61 8.15a.336.336 0 0 1-.085.204L8.351 9.53a.333.333 0 0 1-.204.084h-.3a.333.333 0 0 1-.204-.084L6.469 8.354a.336.336 0 0 1-.084-.204v-.299a.33.33 0 0 1 .084-.204L7.644 6.47a.333.333 0 0 1 .204-.084h.299c.065 0 .157.038.204.084l1.174 1.176a.33.33 0 0 1 .085.204v.3Zm-1.048-.144v-.012a.249.249 0 0 0-.062-.15l-.347-.346a.237.237 0 0 0-.15-.063H7.99a.243.243 0 0 0-.15.063l-.345.346a.243.243 0 0 0-.062.15v.012c0 .05.028.116.062.15l.345.347a.249.249 0 0 0 .15.062h.013c.05 0 .116-.028.15-.062l.347-.347a.243.243 0 0 0 .062-.15Zm4.47-3.669-2.963 1.71a.87.87 0 0 1-1.302-.837V1.85a.868.868 0 1 1 1.734 0V3.79l1.66-.959a.87.87 0 1 1 .87 1.507Zm-6.527 5.53a.863.863 0 0 0-.594.1L2.948 11.68a.87.87 0 1 0 .87 1.507l1.683-.971v1.936a.867.867 0 0 0 1.734 0v-3.428a.867.867 0 0 0-.73-.856Zm7.189-4.335a.87.87 0 1 1 .87 1.507l-1.678.969 1.678.968a.87.87 0 0 1-.87 1.509L10.73 8.773a.868.868 0 0 1-.435-.762.871.871 0 0 1 .435-.769l2.963-1.71Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const HeatMapIcon = createCustomIcon({
  name: "Heat map",
  category: "Cells / Types: Map",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M15 2.5C15 3.32272 14.3227 4 13.5 4C12.6773 4 12 3.32272 12 2.5C12 1.67728 12.6773 1 13.5 1C14.3227 1 15 1.67728 15 2.5ZM13.5 5C14.875 5 16 3.875 16 2.5C16 1.125 14.875 0 13.5 0C12.125 0 11 1.125 11 2.5C11 3.875 12.125 5 13.5 5ZM2.63619 10.8338L3.38127 10.0011L2.47142 9.3526C1.57878 8.71635 1 7.67575 1 6.5C1 4.567 2.567 3 4.5 3C6.09679 3 7.44622 4.07014 7.86536 5.53435L8.14894 6.52502L9.13066 6.21185C9.56119 6.07451 10.0209 6 10.5 6C12.9853 6 15 8.01472 15 10.5C15 12.9853 12.9853 15 10.5 15C9.45271 15 8.49149 14.6435 7.72715 14.0445L6.98939 13.4664L6.36476 14.1652C5.90552 14.679 5.24091 15 4.5 15C3.11929 15 2 13.8807 2 12.5C2 11.8591 2.23982 11.2767 2.63619 10.8338ZM4.5 2C6.46082 2 8.12873 3.25412 8.74535 5.004C8.77493 5.08794 8.80209 5.17302 8.82675 5.25915C8.93035 5.2261 9.03528 5.19604 9.14145 5.16907C9.57597 5.05867 10.0311 5 10.5 5C13.5376 5 16 7.46243 16 10.5C16 13.5376 13.5376 16 10.5 16C9.22125 16 8.04442 15.5636 7.11033 14.8316C6.46941 15.5487 5.53742 16 4.5 16C2.567 16 1 14.433 1 12.5C1 11.8827 1.1598 11.3027 1.44029 10.7992C1.56707 10.5716 1.71851 10.3597 1.89099 10.1669C1.61867 9.97281 1.36889 9.74913 1.14634 9.50056C0.433483 8.70436 0 7.6528 0 6.5C0 4.01472 2.01472 2 4.5 2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M15 10.5C15 12.9853 12.9853 15 10.5 15C8.01472 15 6 12.9853 6 10.5C6 8.01472 8.01472 6 10.5 6C12.9853 6 15 8.01472 15 10.5Z"
        fill="currentColor"
        opacity="0.2"
      />
    </>
  ),
});

export const AreaMapIcon = createCustomIcon({
  name: "Area map",
  category: "Cells / Types: Map",
  path: (
    <path
      clipRule="evenodd"
      d="M8.76824 2.6402C8.91294 2.46675 9 2.24354 9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2C7 2.24354 7.08706 2.46675 7.23176 2.6402L2.76824 6.3598C2.5848 6.13992 2.30874 6 2 6C1.44772 6 1 6.44772 1 7C1 7.55228 1.44772 8 2 8C2.0953 8 2.18748 7.98667 2.27479 7.96177L3.72521 13.0382C3.30654 13.1576 3 13.543 3 14C3 14.5523 3.44772 15 4 15C4.55228 15 5 14.5523 5 14H11C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14C13 13.543 12.6935 13.1576 12.2748 13.0382L13.7252 7.96177C13.8125 7.98667 13.9047 8 14 8C14.5523 8 15 7.55228 15 7C15 6.44772 14.5523 6 14 6C13.6913 6 13.4152 6.13992 13.2318 6.3598L8.76824 2.6402ZM3.14041 7.35137L8 3.30171L12.8596 7.35137L11.2457 13H4.7543L3.14041 7.35137Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const QuoteIcon = createCustomIcon({
  name: "Quote",
  category: "General / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M5.98973 6.72887L5.98995 6.72637C5.99659 6.65204 6 6.57655 6 6.5C6 5.11929 4.88071 4 3.5 4C2.11929 4 1 5.11929 1 6.5C1 7.71272 1.86449 8.72573 3.01131 8.95245L4.14339 9.17626L3.76081 10.265C3.61761 10.6725 3.45592 11.0898 3.28734 11.4984C3.74604 11.0375 4.19953 10.4993 4.60411 9.92099C5.39846 8.78555 5.91175 7.62777 5.98973 6.72887ZM2.65701 12.935C2.65686 12.9351 2.65715 12.9333 2.65832 12.9296C2.65774 12.9332 2.65715 12.935 2.65701 12.935ZM1.88441 9.60562C0.764579 9.02188 0 7.85023 0 6.5C0 4.567 1.567 3 3.5 3C5.433 3 7 4.567 7 6.5C7 6.60627 6.99526 6.71144 6.98599 6.8153C6.7864 9.11605 4.49238 12.1308 2.56567 13.3979C1.92861 13.8169 1.43958 13.1735 1.76196 12.4825C1.99317 11.9869 2.23607 11.4357 2.45989 10.879C2.5871 10.5625 2.70814 10.2443 2.81736 9.93347C2.48734 9.86822 2.17399 9.75658 1.88441 9.60562Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.9897 6.72887L14.9899 6.72637C14.9966 6.65204 15 6.57655 15 6.5C15 5.11929 13.8807 4 12.5 4C11.1193 4 10 5.11929 10 6.5C10 7.71272 10.8645 8.72573 12.0113 8.95245L13.1434 9.17626L12.7608 10.265C12.6176 10.6725 12.4559 11.0898 12.2873 11.4984C12.746 11.0375 13.1995 10.4993 13.6041 9.92099C14.3985 8.78555 14.9118 7.62777 14.9897 6.72887ZM11.657 12.935C11.6569 12.9351 11.6571 12.9333 11.6583 12.9296C11.6577 12.9332 11.6572 12.935 11.657 12.935ZM10.8844 9.60562C9.76458 9.02188 9 7.85023 9 6.5C9 4.567 10.567 3 12.5 3C14.433 3 16 4.567 16 6.5C16 6.60627 15.9953 6.71144 15.986 6.8153C15.7864 9.11605 13.4924 12.1308 11.5657 13.3979C10.9286 13.8169 10.4396 13.1735 10.762 12.4825C10.9932 11.9869 11.2361 11.4357 11.4599 10.879C11.5871 10.5625 11.7081 10.2443 11.8174 9.93347C11.4873 9.86822 11.174 9.75658 10.8844 9.60562Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const DisallowIcon = createCustomIcon({
  name: "Disallow",
  category: "General / Prevent",
  path: (
    <path
      clipRule="evenodd"
      d="M3 8a5 5 0 0 0 7.313 4.434l.735.735a6 6 0 0 1-8.217-8.217l.735.735A4.978 4.978 0 0 0 3 8Zm10.17 3.048-.736-.735a5 5 0 0 0-6.747-6.747l-.735-.735a6 6 0 0 1 8.217 8.217ZM3.853 3.146a.5.5 0 1 0-.708.708l9 9a.5.5 0 0 0 .708-.708l-9-9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ScatterMapIcon = createCustomIcon({
  name: "Scatter map",
  category: "Cells / Types: Map",
  path: (
    <path
      clipRule="evenodd"
      d="M3.503 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM9.5 7a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM4 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM13.498 7.997a.498.498 0 1 0 0-.997.498.498 0 0 0 0 .997Zm0 1a1.498 1.498 0 1 0 0-2.997 1.498 1.498 0 0 0 0 2.997ZM10 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM11.498 2.997a.498.498 0 1 0 0-.997.498.498 0 0 0 0 .997Zm0 1a1.498 1.498 0 1 0 0-2.997 1.498 1.498 0 0 0 0 2.997Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DirectionIcon = createCustomIcon({
  name: "Direction",
  category: "Cells / Actions: Map",
  path: (
    <path
      clipRule="evenodd"
      d="M1.146 1.146a.5.5 0 0 1 .551-.106l13 5.572a.5.5 0 0 1-.039.934L9.324 9.324l-1.778 5.334a.5.5 0 0 1-.934.039l-5.572-13a.5.5 0 0 1 .106-.55Zm1.306 1.306 4.561 10.642 1.441-4.323a.5.5 0 0 1 .316-.317l4.324-1.441L2.452 2.452Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PinIcon = createCustomIcon({
  name: "Pin",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="m9.293 2-.647-.646.708-.708 6 6-.708.708L14 6.707 8.207 12.5l1.525 1.525-.707.707L5.5 11.207l-4.146 4.147-.708-.707L4.793 10.5 1.269 6.976l.707-.707L3.5 7.793 9.293 2Zm.707.707L4.207 8.5 7.5 11.793 13.293 6 10 2.707Z"
      fill="currentColor"
    />
  ),
});

export const PinEnabledIcon = createCustomIcon({
  name: "Pin: Enabled",
  category: "General / Actions",
  path: (
    <>
      <path
        d="M9.97731 2.5881L4.08896 8.41994L7.49926 11.8808L13.3846 5.99542L9.97731 2.5881Z"
        fill="currentColor"
        fillOpacity="0.25"
      />
      <path
        clipRule="evenodd"
        d="M9.29289 2.00004L8.64645 1.35359L9.35355 0.646484L15.3536 6.64648L14.6464 7.35359L14 6.70714L8.20711 12.5L9.73212 14.0251L9.02501 14.7322L5.5 11.2071L1.35355 15.3536L0.646446 14.6465L4.79289 10.5L1.26895 6.97609L1.97606 6.26899L3.5 7.79293L9.29289 2.00004ZM10 2.70714L4.20711 8.50004L7.5 11.7929L13.2929 6.00004L10 2.70714Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const TimezoneIcon = createCustomIcon({
  name: "Timezone",
  category: "General / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M6.5 0a6.5 6.5 0 0 0-.295 12.993A5.504 5.504 0 0 1 6 11.5c0-1.177.37-2.268 1-3.163V4.562h2.16c.17.596.256 1.218.265 1.843.316-.13.648-.23.99-.298a8.159 8.159 0 0 0-.222-1.545h1.456c.173.46.286.95.33 1.459.349.03.688.092 1.014.184A6.5 6.5 0 0 0 6.5 0ZM6 11.5V9.51H4.16c.429.88 1.053 1.631 1.84 2.151V11.5Zm-5-5c0-.682.124-1.335.351-1.938h1.397a7.942 7.942 0 0 0-.01 3.949H1.378A5.486 5.486 0 0 1 1 6.5Zm2.088-2.938H1.85c.632-1 1.579-1.78 2.7-2.206a7.079 7.079 0 0 0-1.462 2.206Zm1.1 0A6.08 6.08 0 0 1 6 1.414v2.148H4.189Zm-.401 1H6v3.949H3.773a6.924 6.924 0 0 1 .014-3.949Zm-.72 4.949c.31.76.743 1.463 1.291 2.056a5.52 5.52 0 0 1-2.461-2.056h1.17Zm8.083-5.949H9.875A6.82 6.82 0 0 0 8.49 1.371a5.519 5.519 0 0 1 2.661 2.191Zm-4.15 0v-2.17a5.633 5.633 0 0 1 1.786 2.17H7Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M7 11.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM11.5 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-.5 3.5V8.929h1v2.364l1.568 1.568-.707.707-1.715-1.714A.5.5 0 0 1 11 11.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const AlignBottomIcon = createCustomIcon({
  name: "Align: bottom",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M1 14h14v1H1v-1ZM5 13V3h2v10H5ZM9 13V7h2v6H9Z"
      fill="currentColor"
    />
  ),
});

export const AlignVerticalCenterIcon = createCustomIcon({
  name: "Align: vertical center",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M1 7.5h14v1H1v-1Z M5 13V3h2v10H5ZM9 11V5h2v6H9Z"
      fill="currentColor"
    />
  ),
});

export const AlignTopIcon = createCustomIcon({
  name: "Align: top",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M1 1h14v1H1V1ZM5 13V3h2v10H5ZM9 9V3h2v6H9Z"
      fill="currentColor"
    />
  ),
});

export const AlignLeftIcon = createCustomIcon({
  name: "Align: left",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M1 15V1h1v14H1ZM14 7H4V5h10v2ZM10 11H4V9h6v2Z"
      fill="currentColor"
    />
  ),
});

export const AlignHorizontalCenterIcon = createCustomIcon({
  name: "Align: horizontal center",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M7.5 15V1h1v14h-1Z M13 7H3V5h10v2ZM11 11H5V9h6v2Z"
      fill="currentColor"
    />
  ),
});

export const AlignRightIcon = createCustomIcon({
  name: "Align: right",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M14 15V1h1v14h-1ZM12 7H2V5h10v2ZM12 11H6V9h6v2Z"
      fill="currentColor"
    />
  ),
});

export const MapLegendIcon = createCustomIcon({
  name: "Map legend",
  category: "Cells / Actions: Map",
  path: (
    <path
      clipRule="evenodd"
      d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2A1.5 1.5 0 0 1 6 3.5v2A1.5 1.5 0 0 1 4.5 7h-2A1.5 1.5 0 0 1 1 5.5v-2ZM2.5 3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2ZM15 5H7V4h8v1ZM1 10.5A1.5 1.5 0 0 1 2.5 9h2A1.5 1.5 0 0 1 6 10.5v2A1.5 1.5 0 0 1 4.5 14h-2A1.5 1.5 0 0 1 1 12.5v-2Zm1.5-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2ZM7 12v-1h8v1H7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortDescIcon = createCustomIcon({
  name: "Sort: Desc",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M3.53902 14.6144L3.56672 14.5867C3.57153 14.582 3.57621 14.5773 3.58088 14.5725L5.87807 12.2753C6.13642 12.017 6.13643 11.5981 5.87807 11.3397C5.61971 11.0813 5.2008 11.0814 4.94245 11.3397L3.76761 12.5145L3.7675 2.16157C3.76756 1.79615 3.47135 1.49994 3.10593 1.5C2.74055 1.49999 2.44435 1.79619 2.44436 2.16157L2.44443 12.5817L1.20122 11.3385C0.942864 11.0801 0.52395 11.0801 0.265604 11.3385C0.0072571 11.5968 0.00724283 12.0157 0.265604 12.2741L2.57016 14.5786C2.5807 14.5909 2.59181 14.6028 2.6034 14.6144C2.86176 14.8727 3.28067 14.8727 3.53902 14.6144ZM16 2C16 1.72386 15.7761 1.5 15.5 1.5H8.5C8.22386 1.5 8 1.72386 8 2C8 2.27614 8.22386 2.5 8.5 2.5H15.5C15.7761 2.5 16 2.27614 16 2ZM14 6C14 5.72386 13.7761 5.5 13.5 5.5H8.5C8.22386 5.5 8 5.72386 8 6C8 6.27614 8.22386 6.5 8.5 6.5H13.5C13.7761 6.5 14 6.27614 14 6ZM11.5 9.5C11.7761 9.5 12 9.72386 12 10C12 10.2761 11.7761 10.5 11.5 10.5H8.5C8.22386 10.5 8 10.2761 8 10C8 9.72386 8.22386 9.5 8.5 9.5H11.5ZM10 14C10 13.7239 9.77614 13.5 9.5 13.5H8.5C8.22386 13.5 8 13.7239 8 14C8 14.2761 8.22386 14.5 8.5 14.5H9.5C9.77614 14.5 10 14.2761 10 14Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortAscIcon = createCustomIcon({
  name: "Sort: Asc",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M3.53902 14.6144L3.56672 14.5867C3.57153 14.582 3.57621 14.5773 3.58088 14.5725L5.87807 12.2753C6.13642 12.017 6.13643 11.5981 5.87807 11.3397C5.61971 11.0813 5.2008 11.0814 4.94245 11.3397L3.76761 12.5145L3.7675 2.16157C3.76756 1.79615 3.47135 1.49994 3.10593 1.5C2.74055 1.49999 2.44435 1.79619 2.44436 2.16157L2.44443 12.5817L1.20122 11.3385C0.942864 11.0801 0.52395 11.0801 0.265604 11.3385C0.0072571 11.5968 0.00724283 12.0157 0.265604 12.2741L2.57016 14.5786C2.5807 14.5909 2.59181 14.6028 2.6034 14.6144C2.86176 14.8727 3.28067 14.8727 3.53902 14.6144ZM8 2C8 2.27614 8.22386 2.5 8.5 2.5H9.5C9.77614 2.5 10 2.27614 10 2C10 1.72386 9.77614 1.5 9.5 1.5H8.5C8.22386 1.5 8 1.72386 8 2ZM8.5 6.5C8.22386 6.5 8 6.27614 8 6C8 5.72386 8.22386 5.5 8.5 5.5H11.5C11.7761 5.5 12 5.72386 12 6C12 6.27614 11.7761 6.5 11.5 6.5H8.5ZM8 10C8 10.2761 8.22386 10.5 8.5 10.5H13.5C13.7761 10.5 14 10.2761 14 10C14 9.72386 13.7761 9.5 13.5 9.5H8.5C8.22386 9.5 8 9.72386 8 10ZM8 14C8 14.2761 8.22386 14.5 8.5 14.5H15.5C15.7761 14.5 16 14.2761 16 14C16 13.7239 15.7761 13.5 15.5 13.5H8.5C8.22386 13.5 8 13.7239 8 14Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortMixedIcon = createCustomIcon({
  name: "Sort: Mixed",
  category: "General / Sorting",
  path: (
    <path
      d="M8 14.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5ZM8 10.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5ZM8 2.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5ZM8.5 7a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3ZM2.498 1.23a.662.662 0 0 1 .969-.036l.028.027.014.015 2.297 2.297a.662.662 0 1 1-.935.935L3.696 3.294v9.748l1.175-1.175a.662.662 0 0 1 .935.936L3.51 15.1l-.014.014-.028.028a.662.662 0 0 1-.969-.036L.194 12.802a.662.662 0 0 1 .935-.936l1.244 1.243V3.226L1.129 4.47a.662.662 0 1 1-.935-.936L2.498 1.23Z"
      fill="currentColor"
    />
  ),
});

export const SortDescHorizontalIcon = createCustomIcon({
  name: "Sort: Desc horizontal",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="m14.614 12.461-.027-.028a.95.95 0 0 0-.014-.014l-2.298-2.297a.662.662 0 0 0-.935.935l1.175 1.175H2.162a.661.661 0 1 0 0 1.324h10.42l-1.244 1.243a.661.661 0 1 0 .936.935l2.305-2.304a.662.662 0 0 0 .036-.969ZM2 8a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 1 0v7A.5.5 0 0 1 2 8Zm4 0a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5A.5.5 0 0 1 6 8Zm3.5-.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v3ZM14 8a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-.5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortAscHorizontalIcon = createCustomIcon({
  name: "Sort: Asc horizontal",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="m14.614 12.461-.027-.028a.95.95 0 0 0-.014-.014l-2.298-2.297a.662.662 0 0 0-.935.935l1.175 1.175H2.162a.661.661 0 1 0 0 1.324h10.42l-1.244 1.243a.661.661 0 1 0 .936.935l2.305-2.304a.662.662 0 0 0 .036-.969ZM2 8a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-1 0v1A.5.5 0 0 0 2 8ZM6.5 7.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 1 0v3ZM10 8a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 .5.5ZM14 8a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-1 0v7a.5.5 0 0 0 .5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortMixedHorizontalIcon = createCustomIcon({
  name: "Sort: Mixed horizontal",
  category: "General / Sorting",
  path: (
    <>
      <path
        d="M9 7.5a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-1 0v7ZM1 7.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0v5ZM5.5 8a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5ZM13 7.5a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-1 0v2ZM14.469 12.505l.027.028a.661.661 0 0 1-.036.969l-2.304 2.304a.661.661 0 1 1-.936-.935l1.243-1.244H2.043a.662.662 0 1 1 0-1.323h10.353l-1.175-1.175a.662.662 0 0 1 .936-.935l2.297 2.297.014.014Z"
        fill="currentColor"
      />
      <path
        d="m1.221 12.505-.027.028a.662.662 0 0 0 .036.969l2.304 2.304a.662.662 0 1 0 .936-.935l-1.244-1.244.068-1.323 1.174-1.175a.662.662 0 1 0-.935-.935L1.236 12.49a.553.553 0 0 0-.015.014Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SortAlphaIcon = createCustomIcon({
  name: "Sort: Alpha vertical",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M13.654 8.99999L13.038 7.04199H10.31L9.70502 8.99999H8.23102L10.805 1.32199H12.609L15.161 8.99999H13.654ZM11.696 2.64199H11.641L10.662 5.79899H12.686L11.696 2.64199ZM4.46718 14.6144L4.49488 14.5867C4.49969 14.582 4.50437 14.5773 4.50904 14.5725L6.80623 12.2753C7.06458 12.017 7.0646 11.5981 6.80623 11.3397C6.54787 11.0813 6.12896 11.0814 5.87061 11.3397L4.69578 12.5145L4.69566 2.16157C4.69572 1.79615 4.39951 1.49994 4.03409 1.5C3.66872 1.49999 3.37251 1.79619 3.37252 2.16157L3.37259 12.5817L2.12939 11.3385C1.87103 11.0801 1.45211 11.0801 1.19377 11.3385C0.935419 11.5968 0.935404 12.0157 1.19377 12.2741L3.49833 14.5786C3.50886 14.5909 3.51997 14.6028 3.53156 14.6144C3.78992 14.8727 4.20884 14.8727 4.46718 14.6144ZM9.75897 15H13.378V14.3H10.648L13.301 10.821V10.114H9.89897V10.814H12.412L9.75897 14.293V15Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortReverseAlphaIcon = createCustomIcon({
  name: "Sort: Alpha vertical reverse",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M14.253 8.99999H8.5V7.70199L12.471 2.60899H8.698V1.32199H14.143V2.61999L10.161 7.71299H14.253V8.99999ZM4.46718 14.6144L4.49488 14.5867C4.49969 14.582 4.50437 14.5773 4.50904 14.5725L6.80623 12.2753C7.06458 12.017 7.0646 11.5981 6.80623 11.3397C6.54787 11.0813 6.12896 11.0814 5.87061 11.3397L4.69578 12.5145L4.69566 2.16157C4.69572 1.79615 4.39951 1.49994 4.03409 1.5C3.66871 1.49999 3.37251 1.79619 3.37252 2.16157L3.37259 12.5817L2.12939 11.3385C1.87103 11.0801 1.45211 11.0801 1.19377 11.3385C0.935419 11.5968 0.935404 12.0157 1.19377 12.2741L3.49833 14.5786C3.50886 14.5909 3.51997 14.6028 3.53156 14.6144C3.78992 14.8727 4.20884 14.8727 4.46718 14.6144ZM12.295 13.677L12.736 15H13.562L11.896 10.114H10.902L9.23596 15H10.041L10.468 13.677H12.295ZM11.364 10.842H11.399L12.099 12.998H10.657L11.364 10.842Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortAlphaHorizontalIcon = createCustomIcon({
  name: "Sort: Alpha horizontal",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M14.6144 11.461L14.5867 11.4333L14.5802 11.4267L14.5725 11.4191L12.2753 9.12193C12.017 8.86358 11.5981 8.86357 11.3397 9.12193C11.0813 9.38029 11.0814 9.7992 11.3397 10.0575L12.5145 11.2324L2.16157 11.2325C1.79615 11.2324 1.49994 11.5287 1.5 11.8941C1.49999 12.2594 1.79619 12.5557 2.16157 12.5556L12.5817 12.5556L11.3385 13.7988C11.0801 14.0571 11.0801 14.476 11.3385 14.7344C11.5968 14.9927 12.0157 14.9928 12.2741 14.7344L14.5786 12.4298C14.5909 12.4193 14.6028 12.4082 14.6144 12.3966C14.8727 12.1382 14.8727 11.7193 14.6144 11.461ZM7.423 9.678L6.807 7.72H4.079L3.474 9.678H2L4.574 2H6.378L8.93 9.678H7.423ZM5.465 3.32H5.41L4.431 6.477H6.455L5.465 3.32ZM10 6.886H13.619V6.186H10.889L13.542 2.707V2H10.14V2.7H12.653L10 6.179V6.886Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortReverseAlphaHorizontalIcon = createCustomIcon({
  name: "Sort: Alpha horizontal reverse",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M14.6144 11.461L14.5867 11.4333L14.5802 11.4267L14.5725 11.4191L12.2753 9.12193C12.017 8.86358 11.5981 8.86357 11.3397 9.12193C11.0813 9.38029 11.0814 9.7992 11.3397 10.0575L12.5145 11.2324L2.16157 11.2325C1.79615 11.2324 1.49994 11.5287 1.5 11.8941C1.49999 12.2594 1.79619 12.5557 2.16157 12.5556L12.5817 12.5556L11.3385 13.7988C11.0801 14.0571 11.0801 14.476 11.3385 14.7344C11.5968 14.9927 12.0157 14.9928 12.2741 14.7344L14.5786 12.4298C14.5909 12.4193 14.6028 12.4082 14.6144 12.3966C14.8727 12.1382 14.8727 11.7193 14.6144 11.461ZM8.253 9.678H2.5L2.5 8.38L6.471 3.287H2.698V2H8.143V3.298L4.161 8.391H8.253V9.678ZM12.559 5.563L13 6.886H13.826L12.16 2H11.166L9.5 6.886H10.305L10.732 5.563H12.559ZM11.628 2.728H11.663L12.363 4.884H10.921L11.628 2.728Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortNumericAscIcon = createCustomIcon({
  name: "Sort: Numeric ASC",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M14.061 4.014C14.061 4.564 13.9767 5.08467 13.808 5.576C13.6467 6.06 13.434 6.50733 13.17 6.918C12.906 7.32133 12.609 7.68433 12.279 8.007C11.9563 8.32233 11.6337 8.59 11.311 8.81H9.35301C9.80034 8.48733 10.2037 8.17567 10.563 7.875C10.9223 7.57433 11.234 7.27 11.498 6.962C11.7693 6.654 11.9893 6.335 12.158 6.005C12.334 5.66767 12.466 5.30467 12.554 4.916L12.466 4.894C12.3927 5.04067 12.3047 5.18367 12.202 5.323C12.1067 5.46233 11.9893 5.58333 11.85 5.686C11.7107 5.78867 11.5493 5.873 11.366 5.939C11.1827 5.99767 10.97 6.027 10.728 6.027C10.4053 6.027 10.1083 5.972 9.83701 5.862C9.56568 5.752 9.32734 5.59433 9.12201 5.389C8.92401 5.17633 8.76634 4.927 8.64901 4.641C8.53901 4.34767 8.48401 4.01767 8.48401 3.651C8.48401 3.26233 8.55001 2.90667 8.68201 2.584C8.81401 2.26133 9.00101 1.98267 9.24301 1.748C9.48501 1.51333 9.77468 1.33 10.112 1.198C10.4567 1.066 10.8417 1 11.267 1C11.707 1 12.0993 1.07333 12.444 1.22C12.7887 1.35933 13.082 1.561 13.324 1.825C13.566 2.08167 13.7493 2.397 13.874 2.771C13.9987 3.13767 14.061 3.552 14.061 4.014ZM11.267 4.905C11.6777 4.905 11.9967 4.795 12.224 4.575C12.4513 4.34767 12.565 4.025 12.565 3.607V3.442C12.565 3.024 12.4513 2.705 12.224 2.485C11.9967 2.25767 11.6777 2.144 11.267 2.144C10.8637 2.144 10.5447 2.25767 10.31 2.485C10.0827 2.705 9.96901 3.024 9.96901 3.442V3.607C9.96901 4.025 10.0827 4.34767 10.31 4.575C10.5447 4.795 10.8637 4.905 11.267 4.905ZM3.53282 1.69377L3.50512 1.72146C3.50031 1.72613 3.49563 1.73081 3.49096 1.73562L1.19377 4.03282C0.935419 4.29116 0.935404 4.71008 1.19377 4.96844C1.45213 5.2268 1.87104 5.22679 2.12939 4.96844L3.30422 3.7936L3.30434 14.1466C3.30428 14.512 3.60049 14.8082 3.96591 14.8081C4.33128 14.8082 4.62749 14.512 4.62748 14.1466L4.62741 3.72649L5.87061 4.9697C6.12897 5.22806 6.54789 5.22804 6.80623 4.9697C7.06458 4.71135 7.0646 4.29243 6.80623 4.03407L4.50167 1.72951C4.49114 1.71726 4.48003 1.70536 4.46844 1.69377C4.21008 1.4354 3.79116 1.43542 3.53282 1.69377ZM10.051 14.152V14.81H13.39V14.152H12.2V9.92401H10.996L9.75 11.275L10.233 11.709L11.367 10.498H11.423V14.152H10.051Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortNumericDescIcon = createCustomIcon({
  name: "Sort: Numeric DESC",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M9.54799 8.5V7.35029H11.611V2.02077H11.5143L9.88109 3.95487L9 3.21347L10.8589 1H12.9971V7.35029H14.7163V8.5H9.54799ZM3.53282 1.69377L3.50512 1.72146C3.50031 1.72613 3.49563 1.73081 3.49096 1.73562L1.19377 4.03282C0.935419 4.29116 0.935404 4.71008 1.19377 4.96844C1.45213 5.2268 1.87104 5.22679 2.12939 4.96844L3.30422 3.7936L3.30434 14.1466C3.30428 14.512 3.60049 14.8082 3.96591 14.8081C4.33128 14.8082 4.62749 14.512 4.62748 14.1466L4.62741 3.72649L5.87061 4.9697C6.12897 5.22806 6.54789 5.22804 6.80623 4.9697C7.06458 4.71135 7.0646 4.29243 6.80623 4.03407L4.50167 1.72951C4.49114 1.71726 4.48003 1.70536 4.46844 1.69377C4.21008 1.4354 3.79116 1.43542 3.53282 1.69377ZM13.8606 12.5687C13.974 12.2384 14.0307 11.8859 14.0307 11.5113C14.0307 11.2007 13.9888 10.9222 13.905 10.6757C13.8212 10.4292 13.7004 10.2197 13.5426 10.0472C13.3898 9.86972 13.2 9.73415 12.9733 9.64049C12.7514 9.54683 12.4976 9.5 12.2116 9.5C11.9356 9.5 11.6866 9.54437 11.4648 9.6331C11.243 9.7169 11.0532 9.83521 10.8954 9.98803C10.7377 10.1408 10.6145 10.3257 10.5257 10.5426C10.4419 10.7595 10.4 10.9961 10.4 11.2525C10.4 11.4989 10.437 11.7208 10.5109 11.918C10.5898 12.1102 10.6958 12.2778 10.8289 12.4208C10.9669 12.5588 11.1271 12.6648 11.3095 12.7387C11.4969 12.8127 11.699 12.8496 11.9159 12.8496C12.0785 12.8496 12.2215 12.8299 12.3447 12.7905C12.468 12.7511 12.5764 12.6968 12.6701 12.6278C12.7687 12.5588 12.8525 12.4799 12.9215 12.3912C12.9954 12.2975 13.0595 12.1989 13.1138 12.0954L13.1655 12.1102C13.1014 12.3863 13.0102 12.6401 12.8919 12.8718C12.7785 13.1035 12.6356 13.3229 12.4631 13.5299C12.2905 13.737 12.0884 13.9391 11.8567 14.1363C11.625 14.3335 11.3638 14.538 11.0729 14.75H12.1821C12.394 14.612 12.6085 14.4345 12.8254 14.2176C13.0472 14.0007 13.2469 13.7542 13.4243 13.4782C13.6018 13.2021 13.7472 12.8989 13.8606 12.5687ZM12.9141 11.9401C12.7465 12.0979 12.5123 12.1768 12.2116 12.1768C11.9109 12.1768 11.6768 12.0979 11.5092 11.9401C11.3416 11.7775 11.2578 11.5408 11.2578 11.2303V11.1268C11.2578 10.8162 11.3416 10.582 11.5092 10.4243C11.6768 10.2616 11.9109 10.1803 12.2116 10.1803C12.5123 10.1803 12.7465 10.2616 12.9141 10.4243C13.0817 10.582 13.1655 10.8162 13.1655 11.1268V11.2303C13.1655 11.5408 13.0817 11.7775 12.9141 11.9401Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortNumericAscHorizontalIcon = createCustomIcon({
  name: "Sort: Numeric ASC horizontal",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M14.6144 11.461L14.5867 11.4333L14.5802 11.4267L14.5725 11.4191L12.2753 9.12193C12.017 8.86358 11.5981 8.86357 11.3397 9.12193C11.0813 9.38029 11.0814 9.7992 11.3397 10.0575L12.5145 11.2324L2.16157 11.2325C1.79615 11.2324 1.49994 11.5287 1.5 11.8941C1.49999 12.2594 1.79619 12.5557 2.16157 12.5556L12.5817 12.5556L11.3385 13.7988C11.0801 14.0571 11.0801 14.476 11.3385 14.7344C11.5968 14.9927 12.0157 14.9928 12.2741 14.7344L14.5786 12.4298C14.5909 12.4193 14.6028 12.4082 14.6144 12.3966C14.8727 12.1382 14.8727 11.7193 14.6144 11.461ZM3.05598 9.376V8.248H5.40798V1.984H5.31198L3.36798 4.06L2.53998 3.316L4.67598 1H6.73998L6.73998 8.248H8.77998V9.376H3.05598ZM14.1197 4.90317C14.2547 4.50998 14.3222 4.09038 14.3222 3.64437C14.3222 3.27465 14.2723 2.94308 14.1725 2.64965C14.0728 2.35622 13.929 2.10681 13.7412 1.90141C13.5593 1.69014 13.3333 1.52876 13.0634 1.41725C12.7993 1.30575 12.4971 1.25 12.1567 1.25C11.8281 1.25 11.5317 1.30282 11.2676 1.40845C11.0035 1.50822 10.7776 1.64906 10.5898 1.83099C10.402 2.01291 10.2553 2.23298 10.1496 2.4912C10.0499 2.74941 10 3.0311 10 3.33627C10 3.6297 10.044 3.89378 10.132 4.12852C10.2259 4.3574 10.3521 4.55693 10.5106 4.72711C10.6749 4.89143 10.8656 5.01761 11.0827 5.10563C11.3058 5.19366 11.5464 5.23768 11.8046 5.23768C11.9982 5.23768 12.1684 5.2142 12.3151 5.16725C12.4619 5.12031 12.591 5.05575 12.7025 4.97359C12.8198 4.89143 12.9196 4.79754 13.0018 4.6919C13.0898 4.5804 13.1661 4.46303 13.2306 4.33979L13.2923 4.3574C13.216 4.68603 13.1074 4.98826 12.9665 5.26409C12.8316 5.53991 12.6614 5.80106 12.456 6.04754C12.2506 6.29401 12.01 6.53462 11.7342 6.76937C11.4583 7.00411 11.1473 7.24765 10.8011 7.5H12.1215C12.3738 7.33568 12.6291 7.12441 12.8873 6.8662C13.1514 6.60798 13.3891 6.31456 13.6004 5.98592C13.8116 5.65728 13.9847 5.29636 14.1197 4.90317ZM12.993 4.15493C12.7934 4.34272 12.5147 4.43662 12.1567 4.43662C11.7987 4.43662 11.52 4.34272 11.3204 4.15493C11.1209 3.96127 11.0211 3.67958 11.0211 3.30986V3.18662C11.0211 2.8169 11.1209 2.53815 11.3204 2.35035C11.52 2.15669 11.7987 2.05986 12.1567 2.05986C12.5147 2.05986 12.7934 2.15669 12.993 2.35035C13.1925 2.53815 13.2923 2.8169 13.2923 3.18662V3.30986C13.2923 3.67958 13.1925 3.96127 12.993 4.15493Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SortNumericDescHorizontalIcon = createCustomIcon({
  name: "Sort: Numeric DESC horizontal",
  category: "General / Sorting",
  path: (
    <path
      clipRule="evenodd"
      d="M14.6144 11.461L14.5867 11.4333L14.5802 11.4267L14.5725 11.4191L12.2753 9.12193C12.017 8.86358 11.5981 8.86357 11.3397 9.12193C11.0813 9.38029 11.0814 9.7992 11.3397 10.0575L12.5145 11.2324L2.16157 11.2325C1.79615 11.2324 1.49994 11.5287 1.5 11.8941C1.49999 12.2594 1.79619 12.5557 2.16157 12.5556L12.5817 12.5556L11.3385 13.7988C11.0801 14.0571 11.0801 14.476 11.3385 14.7344C11.5968 14.9927 12.0157 14.9928 12.2741 14.7344L14.5786 12.4298C14.5909 12.4193 14.6028 12.4082 14.6144 12.3966C14.8727 12.1382 14.8727 11.7193 14.6144 11.461ZM8.06489 4.35977C8.06489 4.98561 7.97019 5.5744 7.78079 6.12613C7.59139 6.67786 7.34846 7.18429 7.05201 7.64544C6.75556 8.10658 6.42206 8.51832 6.05149 8.88065C5.68916 9.24298 5.33095 9.53943 4.97686 9.77H3.12404C3.60989 9.41591 4.04633 9.07416 4.43337 8.74478C4.8204 8.41539 5.15802 8.07776 5.44624 7.7319C5.73446 7.38604 5.97326 7.0196 6.16266 6.63256C6.3603 6.24553 6.51264 5.82144 6.61969 5.3603L6.53323 5.33559C6.44264 5.50852 6.33559 5.67322 6.21207 5.82968C6.09678 5.9779 5.95679 6.10966 5.7921 6.22494C5.63564 6.34023 5.45447 6.43081 5.24861 6.49669C5.04274 6.56257 4.80393 6.59551 4.53218 6.59551C4.16985 6.59551 3.83223 6.53375 3.51931 6.41023C3.21462 6.2867 2.947 6.10966 2.71642 5.87908C2.49408 5.64028 2.31704 5.3603 2.18528 5.03914C2.06176 4.70975 2 4.33919 2 3.92745C2 3.49924 2.07 3.10398 2.20999 2.74165C2.35821 2.37932 2.56408 2.07052 2.82759 1.81524C3.0911 1.55996 3.40814 1.36233 3.7787 1.22234C4.14927 1.07411 4.56512 1 5.02627 1C5.50388 1 5.92797 1.07823 6.29853 1.23469C6.67733 1.39115 6.99437 1.61761 7.24965 1.91406C7.51316 2.20227 7.71491 2.55225 7.8549 2.96399C7.99489 3.37572 8.06489 3.84099 8.06489 4.35977ZM5.02627 5.47147C5.52859 5.47147 5.91974 5.33971 6.19972 5.0762C6.4797 4.80445 6.61969 4.40918 6.61969 3.8904V3.71747C6.61969 3.19868 6.4797 2.80753 6.19972 2.54401C5.91974 2.27227 5.52859 2.13639 5.02627 2.13639C4.52395 2.13639 4.1328 2.27227 3.85282 2.54401C3.57284 2.80753 3.43285 3.19868 3.43285 3.71747V3.8904C3.43285 4.40918 3.57284 4.80445 3.85282 5.0762C4.1328 5.33971 4.52395 5.47147 5.02627 5.47147ZM10.7384 6.58023V7.5H14.8731V6.58023H13.4978V1.5H11.7872L10.3 3.27077L11.0049 3.8639L12.3115 2.31662H12.3889V6.58023H10.7384Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MemoryIcon = createCustomIcon({
  name: "memory",
  category: "Threads",
  path: (
    <path
      d="M9.04883 1.55172C9.3407 1.48414 9.64415 1.48242 9.93652 1.54781C10.229 1.61323 10.503 1.7441 10.7383 1.92965C10.9735 2.11516 11.1641 2.35106 11.2959 2.62008C11.4065 2.84602 11.4702 3.09086 11.4902 3.34078C11.661 3.30501 11.837 3.29268 12.0137 3.3027C12.4851 3.32951 12.9325 3.52206 13.2754 3.84664C13.6182 4.1712 13.835 4.60698 13.8877 5.07613C13.9253 5.41091 13.8758 5.74669 13.75 6.05465C13.9905 6.32043 14.181 6.62896 14.3096 6.96578C14.4812 7.41558 14.5384 7.90155 14.4756 8.37887C14.4127 8.85627 14.2315 9.31106 13.9492 9.70113C13.7485 9.97835 13.4999 10.2154 13.2178 10.4052C13.3036 10.726 13.3198 11.0613 13.2637 11.3886C13.2071 11.7185 13.0789 12.0323 12.8887 12.3076C12.6985 12.5828 12.4505 12.8129 12.1621 12.9824C11.8736 13.152 11.5518 13.2568 11.2188 13.289C11.0878 13.3017 10.9566 13.2997 10.8262 13.29C10.746 13.5562 10.6024 13.8017 10.4023 14.0019C10.0836 14.3207 9.65094 14.4999 9.2002 14.5C8.75005 14.5 8.31864 14.3208 8 14.0029C7.68136 14.3208 7.24995 14.5 6.7998 14.5C6.34906 14.4999 5.91637 14.3207 5.59766 14.0019C5.39749 13.8016 5.25304 13.5563 5.17285 13.29C5.04271 13.2997 4.91188 13.3017 4.78125 13.289C4.44818 13.2568 4.12638 13.152 3.83789 12.9824C3.5495 12.8129 3.30153 12.5828 3.11133 12.3076C2.92109 12.0323 2.7929 11.7185 2.73633 11.3886C2.68022 11.0614 2.69543 10.7259 2.78125 10.4052C2.49937 10.2155 2.2513 9.97813 2.05078 9.70113C1.76847 9.31106 1.58728 8.85627 1.52441 8.37887C1.4616 7.90154 1.51876 7.41558 1.69043 6.96578C1.81895 6.62916 2.00872 6.32032 2.24902 6.05465C2.12335 5.74678 2.07475 5.41079 2.1123 5.07613C2.16502 4.60698 2.38178 4.1712 2.72461 3.84664C3.06755 3.52206 3.51491 3.32951 3.98633 3.3027C4.16269 3.2927 4.33835 3.30515 4.50879 3.34078C4.52877 3.09083 4.59344 2.84604 4.7041 2.62008C4.83588 2.35106 5.02652 2.11516 5.26172 1.92965C5.49702 1.7441 5.77105 1.61323 6.06348 1.54781C6.35585 1.48242 6.6593 1.48414 6.95117 1.55172C7.24312 1.61936 7.5161 1.75206 7.75 1.93942C7.84108 2.01237 7.92342 2.09447 8 2.1816C8.07658 2.09447 8.15892 2.01237 8.25 1.93942C8.4839 1.75206 8.75688 1.61936 9.04883 1.55172ZM7.5 3.49996C7.49998 3.35022 7.46615 3.20234 7.40137 3.06735C7.33649 2.93228 7.24193 2.81336 7.125 2.71969C7.00806 2.62602 6.87154 2.55917 6.72559 2.52535C6.57979 2.49162 6.42828 2.49174 6.28223 2.52438C6.13602 2.55708 5.99851 2.62203 5.88086 2.71481C5.76329 2.80756 5.66841 2.926 5.60254 3.06051C5.5367 3.19502 5.50117 3.34239 5.5 3.49215C5.49883 3.642 5.5319 3.79015 5.5957 3.92574C5.71328 4.1756 5.60533 4.4732 5.35547 4.59078C5.21924 4.6548 5.07012 4.64999 4.94238 4.59371C4.85746 4.58384 4.77351 4.55494 4.7002 4.49996C4.51151 4.35822 4.27855 4.2874 4.04297 4.30074C3.8073 4.31415 3.58357 4.41092 3.41211 4.5732C3.24081 4.73546 3.13182 4.95295 3.10547 5.18746C3.07912 5.42206 3.13743 5.65818 3.26855 5.85445C3.36802 6.00331 3.37516 6.18584 3.30664 6.33785C3.27913 6.42103 3.2314 6.4992 3.16016 6.56051C2.92126 6.76624 2.73743 7.02863 2.625 7.3232C2.5126 7.61787 2.47542 7.9363 2.5166 8.24899C2.55786 8.5616 2.67646 8.85879 2.86133 9.11422C2.97094 9.26566 3.10334 9.39732 3.25098 9.50973C3.46519 9.25784 3.73149 9.05478 4.03125 8.915C4.33447 8.77366 4.66546 8.70066 5 8.70016C5.27592 8.7 5.49959 8.9232 5.5 9.19918C5.5004 9.47532 5.27711 9.69975 5.00098 9.70016C4.81205 9.70044 4.62537 9.74148 4.4541 9.82125C4.28269 9.90118 4.13059 10.0183 4.00879 10.163C3.88708 10.3077 3.79758 10.4767 3.74805 10.6591C3.69853 10.8417 3.68972 11.0333 3.72168 11.2197C3.75366 11.4061 3.82607 11.5836 3.93359 11.7392C4.04111 11.8948 4.18172 12.0252 4.34473 12.1211C4.50768 12.2168 4.68984 12.2757 4.87793 12.2939C5.06609 12.3121 5.25624 12.2893 5.43457 12.2265C5.69501 12.135 5.98064 12.2718 6.07227 12.5322C6.098 12.6055 6.10281 12.6805 6.09473 12.7529C6.09619 12.7684 6.10058 12.7839 6.10059 12.7998C6.10059 12.9854 6.1744 13.1636 6.30566 13.2949C6.43684 13.426 6.6144 13.4999 6.7998 13.5C6.98541 13.5 7.16366 13.4262 7.29492 13.2949C7.42618 13.1636 7.5 12.9854 7.5 12.7998V3.49996ZM8.5 4.99996L8.50684 5.12789C8.53632 5.42563 8.66749 5.7055 8.88086 5.91891C9.12462 6.1627 9.4551 6.29976 9.7998 6.29977C10.0759 6.29977 10.2998 6.52365 10.2998 6.79977C10.2998 7.07591 10.0759 7.29977 9.7998 7.29977C9.33226 7.29976 8.88022 7.15622 8.5 6.89547V12.7998C8.5 12.9854 8.57382 13.1636 8.70508 13.2949C8.83634 13.4262 9.01459 13.5 9.2002 13.5C9.3856 13.4999 9.56317 13.426 9.69434 13.2949C9.8256 13.1636 9.89941 12.9854 9.89941 12.7998C9.89942 12.7839 9.90284 12.7684 9.9043 12.7529C9.89622 12.6806 9.90201 12.6054 9.92773 12.5322C10.0194 12.2718 10.305 12.135 10.5654 12.2265C10.7438 12.2893 10.9339 12.3121 11.1221 12.2939C11.3102 12.2757 11.4923 12.2168 11.6553 12.1211C11.8183 12.0252 11.9589 11.8948 12.0664 11.7392C12.1739 11.5836 12.2463 11.4061 12.2783 11.2197C12.3103 11.0332 12.3015 10.8417 12.252 10.6591C12.2024 10.4767 12.1129 10.3077 11.9912 10.163C11.8694 10.0183 11.7173 9.90118 11.5459 9.82125C11.3746 9.74147 11.188 9.70044 10.999 9.70016C10.7229 9.69975 10.4996 9.4753 10.5 9.19918C10.5004 8.9232 10.7241 8.7 11 8.70016C11.3345 8.70066 11.6655 8.77365 11.9688 8.915C12.2683 9.05469 12.5339 9.25805 12.748 9.50973C12.8959 9.39723 13.0289 9.26587 13.1387 9.11422C13.3235 8.85879 13.4421 8.5616 13.4834 8.24899C13.5246 7.93629 13.4874 7.61787 13.375 7.3232C13.2626 7.02862 13.0787 6.76624 12.8398 6.56051C12.7685 6.49913 12.7199 6.42115 12.6924 6.33785C12.624 6.18591 12.6321 6.00319 12.7314 5.85445C12.8626 5.65818 12.9209 5.42206 12.8945 5.18746C12.8682 4.95295 12.7592 4.73546 12.5879 4.5732C12.4164 4.41092 12.1927 4.31415 11.957 4.30074C11.7214 4.2874 11.4885 4.35822 11.2998 4.49996C11.2262 4.55515 11.1419 4.58397 11.0566 4.59371C10.9291 4.64964 10.7805 4.65466 10.6445 4.59078C10.3947 4.4732 10.2867 4.1756 10.4043 3.92574C10.4681 3.79015 10.5012 3.642 10.5 3.49215C10.4988 3.34239 10.4633 3.19502 10.3975 3.06051C10.3316 2.926 10.2367 2.80757 10.1191 2.71481C10.0015 2.62203 9.86398 2.55708 9.71777 2.52438C9.57172 2.49175 9.42021 2.49162 9.27441 2.52535C9.12846 2.55917 8.99194 2.62602 8.875 2.71969C8.75807 2.81336 8.66351 2.93228 8.59863 3.06735C8.53385 3.20235 8.50002 3.35022 8.5 3.49996V4.99996Z"
      fill="currentColor"
    />
  ),
});

export const SuccessIcon = createCustomIcon({
  name: "Success",
  category: "General / Status",
  tags: ["approved", "accepted", "reviews"],
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm8.416-1.723a.5.5 0 1 0-.832-.554l-2.62 3.93L5.89 7.689a.5.5 0 1 0-.78.624l2 2.5a.5.5 0 0 0 .806-.035l3-4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DataframeModeIcon = createCustomIcon({
  name: "Return mode: Dataframe",
  category: "Cells / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M4.14646 3.14645C4.24023 3.05268 4.3674 3 4.50001 3H8.00001V5H4.00001V3.5C4.00001 3.36739 4.05269 3.24021 4.14646 3.14645ZM3.00001 3.99999L4.00001 5L5.00002 6H8.00001V13H5.00002L4.0646 13.9354C4.20452 13.9779 4.35113 14 4.50001 14H11H12H13.5C13.8978 14 14.2794 13.842 14.5607 13.5607C14.842 13.2794 15 12.8978 15 12.5V3.5C15 3.10217 14.842 2.72064 14.5607 2.43934C14.2794 2.15804 13.8978 2 13.5 2H12H11H4.50001C4.10219 2 3.72065 2.15804 3.43935 2.43934C3.15805 2.72064 3.00001 3.10218 3.00001 3.5V3.99999ZM9.00001 5V3H11V5H9.00001ZM11 6H9.00001V13H11V6ZM12 6H14V12.5C14 12.6326 13.9473 12.7598 13.8536 12.8536C13.7598 12.9473 13.6326 13 13.5 13H12V6ZM12 3H13.5C13.6326 3 13.7598 3.05268 13.8536 3.14645C13.9473 3.24022 14 3.36739 14 3.5V5H12V3ZM0 6H1V9.00355H5.29289L3.14645 6.85711L3.85355 6.15L7.20711 9.50355L3.85355 12.8571L3.14645 12.15L5.29289 10.0036H1V10H0V6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const QueryModeIcon = createCustomIcon({
  name: "Return mode: Query",
  category: "Cells / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M5.14916 2.1139L5.21356 2.09347C6.37997 1.72345 7.07012 1.50452 9.00003 1.50452C9.96507 1.50452 11.6447 1.731 12.8507 2.11298C13.4511 2.30313 13.963 2.54074 14.3352 2.83042C14.704 3.11753 15 3.51015 15 4.00352V11.9965C15 12.4896 14.7037 12.882 14.3351 13.1688C13.963 13.4583 13.4512 13.696 12.8508 13.8863C11.6449 14.2685 9.96518 14.4955 9.00003 14.4955C7.06989 14.4955 6.37984 14.2768 5.21314 13.9069L5.14926 13.8867C4.81582 13.781 4.50969 13.6607 4.23963 13.5251L4.99497 12.7697C5.13273 12.8258 5.28477 12.8806 5.4513 12.9334L5.64026 12.9935C6.60207 13.3005 7.21324 13.4955 9.00003 13.4955C9.90087 13.4955 11.4712 13.2745 12.5487 12.933C13.0901 12.7614 13.4785 12.5683 13.721 12.3796C13.9671 12.1881 14 12.0549 14 11.9965V9.39917C13.6768 9.58937 13.2873 9.75278 12.8509 9.89113C11.6449 10.2735 9.96518 10.5005 9.00003 10.5005C8.31822 10.5005 7.79115 10.4732 7.34315 10.4215L8.26469 9.5L8.25157 9.48689C8.47682 9.49587 8.72444 9.50052 9.00003 9.50052C9.90088 9.50052 11.4712 9.27952 12.5487 8.9379C13.0901 8.76625 13.4784 8.57302 13.7209 8.38422C13.9669 8.19276 14 8.0593 14 8.00052V5.40125C13.6768 5.5913 13.2872 5.75457 12.8507 5.8928C11.6448 6.27477 9.96514 6.50152 9.00003 6.50152C7.0704 6.50152 6.38025 6.28288 5.21418 5.91348L5.14935 5.89294C4.86041 5.80146 4.59199 5.69901 4.34978 5.58509L3.00003 4.23534V4.00452C3.00003 3.5113 3.29612 3.11876 3.66486 2.83172C4.03701 2.54202 4.5488 2.30425 5.14916 2.1139ZM14 4.00352C14 4.06185 13.9671 4.19504 13.7211 4.38634C13.4786 4.57496 13.0902 4.76799 12.5488 4.93948C11.4713 5.28077 9.90092 5.50152 9.00003 5.50152C7.21359 5.50152 6.60228 5.30655 5.64073 4.99988L5.4512 4.93959C4.90976 4.76816 4.52139 4.57519 4.27883 4.38667C4.03276 4.19542 4.00003 4.06243 4.00003 4.00452C4.00003 3.94573 4.03318 3.81227 4.27913 3.62082C4.52167 3.43201 4.91 3.23879 5.45139 3.06713L5.64075 3.00681C6.60231 2.69972 7.21353 2.50452 9.00003 2.50452C9.90098 2.50452 11.4713 2.72503 12.5488 3.0663C13.0902 3.23778 13.4785 3.43085 13.721 3.61958C13.9668 3.81088 14 3.94439 14 4.00352ZM0 6H1V9H0V6ZM3.85355 6.15L7.20711 9.50355L3.85355 12.8571L3.14645 12.15L5.29289 10.0036H0V9.00355H5.29289L3.14645 6.85711L3.85355 6.15Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ViewCompiledSqlIcon = createCustomIcon({
  name: "View compiled SQL",
  category: "Cells / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M5.5 3C5.10218 3 4.72064 3.15804 4.43934 3.43934C4.15804 3.72064 4 4.10218 4 4.5V11.5C4 11.8978 4.15804 12.2794 4.43934 12.5607C4.72064 12.842 5.10218 13 5.5 13H6V14H5.5C4.83696 14 4.20107 13.7366 3.73223 13.2678C3.26339 12.7989 3 12.163 3 11.5V9H1V8H3V4.5C3 3.83696 3.26339 3.20107 3.73223 2.73223C4.20107 2.26339 4.83696 2 5.5 2H6V3H5.5ZM10 2H10.5C11.163 2 11.7989 2.26339 12.2678 2.73223C12.7366 3.20107 13 3.83696 13 4.5V8H15V9H13V11.5C13 12.163 12.7366 12.7989 12.2678 13.2678C11.7989 13.7366 11.163 14 10.5 14H10V13H10.5C10.8978 13 11.2794 12.842 11.5607 12.5607C11.842 12.2794 12 11.8978 12 11.5V4.5C12 4.10218 11.842 3.72064 11.5607 3.43934C11.2794 3.15804 10.8978 3 10.5 3H10V2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MatchCaseIcon = createCustomIcon({
  name: "Match: Case",
  category: "Project / Search",
  path: (
    <path
      clipRule="evenodd"
      d="M5 3a.5.5 0 0 0-.468.324l-3 8a.5.5 0 0 0 .936.352l1.004-2.677L3.5 9h3.528l1.004 2.676a.5.5 0 0 0 .936-.352l-3-8A.5.5 0 0 0 5.5 3H5Zm1.654 5L5.25 4.257 3.847 8h2.807ZM12.5 7c-.54 0-1.066.023-1.396.354a.5.5 0 0 1-.707-.708C11.045 5.998 11.98 6 12.456 6h.044c.632 0 1.094.228 1.411.54.305.298.452.647.52.868.063.201.07.397.07.542v3.55a.5.5 0 0 1-.998.056c-.357.214-.882.444-1.503.444-.576 0-1.136-.143-1.562-.485-.442-.353-.688-.877-.688-1.515 0-.338.086-.64.256-.895.168-.251.399-.429.646-.552.479-.24 1.073-.303 1.598-.303a4.16 4.16 0 0 0 1.004-.11 2.117 2.117 0 0 0 .246-.077V7.95a.852.852 0 0 0-.024-.246c-.04-.13-.12-.31-.265-.45-.132-.13-.342-.254-.71-.254Zm1 2.11h-.004c-.288.072-.704.14-1.246.14-.474 0-.88.062-1.151.197a.65.65 0 0 0-.261.213.59.59 0 0 0-.088.34c0 .362.129.588.313.735.198.158.513.265.937.265.377 0 .725-.143.993-.304a2.619 2.619 0 0 0 .386-.283l.017-.016.002-.002a.497.497 0 0 1 .102-.078V9.109Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const FromCacheIcon = createCustomIcon({
  name: "From cache",
  category: "Project / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M10.8649 2H1.5C0.671572 2 0 2.67157 0 3.5V12.5C0 13.3284 0.671574 14 1.5 14H8.50658L8.67324 13H1.5C1.22386 13 1 12.7761 1 12.5V9H5.26491L6.06491 8H1V3.5C1 3.22386 1.22386 3 1.5 3H10.0649L10.8649 2ZM4.46491 10H3V11H6V10.5811H4L4.46491 10ZM3 5H6V6H3V5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.6038 1.44153L5.72076 10.0453H10.0227L9.16229 15.2076L16.0453 6.60381H11.7434L12.6038 1.44153ZM14.2552 7.46419H10.7278L11.2121 4.55848L7.51089 9.18495H11.0383L10.554 12.0907L14.2552 7.46419Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M11.3132 4.02267L6.58115 10.0453H10.0227L9.59248 13.4869L14.7548 7.4642H10.883L11.3132 4.02267Z"
        fill="currentColor"
        opacity="0.2"
      />
    </>
  ),
});

export const DragHandleVerticalIcon = createCustomIcon({
  name: "Drag handle vertical",
  category: "General / Drag",
  path: (
    <path
      clipRule="evenodd"
      d="M5.29289 3.29289C5.48043 3.10536 5.73478 3 6 3C6.26522 3 6.51957 3.10536 6.70711 3.29289C6.89464 3.48043 7 3.73478 7 4C7 4.26522 6.89464 4.51957 6.70711 4.70711C6.51957 4.89464 6.26522 5 6 5C5.73478 5 5.48043 4.89464 5.29289 4.70711C5.10536 4.51957 5 4.26522 5 4C5 3.73478 5.10536 3.48043 5.29289 3.29289ZM9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3C10.2652 3 10.5196 3.10536 10.7071 3.29289C10.8946 3.48043 11 3.73478 11 4C11 4.26522 10.8946 4.51957 10.7071 4.70711C10.5196 4.89464 10.2652 5 10 5C9.73478 5 9.48043 4.89464 9.29289 4.70711C9.10536 4.51957 9 4.26522 9 4C9 3.73478 9.10536 3.48043 9.29289 3.29289ZM5.29289 7.29289C5.48043 7.10536 5.73478 7 6 7C6.26522 7 6.51957 7.10536 6.70711 7.29289C6.89464 7.48043 7 7.73478 7 8C7 8.26522 6.89464 8.51957 6.70711 8.70711C6.51957 8.89464 6.26522 9 6 9C5.73478 9 5.48043 8.89464 5.29289 8.70711C5.10536 8.51957 5 8.26522 5 8C5 7.73478 5.10536 7.48043 5.29289 7.29289ZM9.29289 7.29289C9.48043 7.10536 9.73478 7 10 7C10.2652 7 10.5196 7.10536 10.7071 7.29289C10.8946 7.48043 11 7.73478 11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73478 9 9.48043 8.89464 9.29289 8.70711C9.10536 8.51957 9 8.26522 9 8C9 7.73478 9.10536 7.48043 9.29289 7.29289ZM5.29289 11.2929C5.48043 11.1054 5.73478 11 6 11C6.26522 11 6.51957 11.1054 6.70711 11.2929C6.89464 11.4804 7 11.7348 7 12C7 12.2652 6.89464 12.5196 6.70711 12.7071C6.51957 12.8946 6.26522 13 6 13C5.73478 13 5.48043 12.8946 5.29289 12.7071C5.10536 12.5196 5 12.2652 5 12C5 11.7348 5.10536 11.4804 5.29289 11.2929ZM9.29289 11.2929C9.48043 11.1054 9.73479 11 10 11C10.2652 11 10.5196 11.1054 10.7071 11.2929C10.8946 11.4804 11 11.7348 11 12C11 12.2652 10.8946 12.5196 10.7071 12.7071C10.5196 12.8946 10.2652 13 10 13C9.73479 13 9.48043 12.8946 9.29289 12.7071C9.10536 12.5196 9 12.2652 9 12C9 11.7348 9.10536 11.4804 9.29289 11.2929Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DragHandleHorizontalIcon = createCustomIcon({
  name: "Drag handle horizontal",
  category: "General / Drag",
  path: (
    <path
      clipRule="evenodd"
      d="M4 4.49995C4.55228 4.49995 5 4.94767 5 5.49995C5 6.05224 4.55228 6.49995 4 6.49995C3.44772 6.49995 3 6.05224 3 5.49995C3 4.94767 3.44772 4.49995 4 4.49995ZM8 4.49995C8.55228 4.49995 9 4.94767 9 5.49995C9 6.05224 8.55228 6.49995 8 6.49995C7.44772 6.49995 7 6.05224 7 5.49995C7 4.94767 7.44772 4.49995 8 4.49995ZM13 5.49995C13 4.94767 12.5523 4.49995 12 4.49995C11.4477 4.49995 11 4.94767 11 5.49995C11 6.05224 11.4477 6.49995 12 6.49995C12.5523 6.49995 13 6.05224 13 5.49995ZM13 10.5C13 9.94767 12.5523 9.49995 12 9.49995C11.4477 9.49995 11 9.94767 11 10.5C11 11.0522 11.4477 11.5 12 11.5C12.5523 11.5 13 11.0522 13 10.5ZM9 10.5C9 9.94767 8.55228 9.49995 8 9.49995C7.44772 9.49995 7 9.94767 7 10.5C7 11.0522 7.44772 11.5 8 11.5C8.55228 11.5 9 11.0522 9 10.5ZM5 10.5C5 9.94767 4.55228 9.49995 4 9.49995C3.44772 9.49995 3 9.94767 3 10.5C3 11.0522 3.44772 11.5 4 11.5C4.55228 11.5 5 11.0522 5 10.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ApiIcon = createCustomIcon({
  name: "API",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M9.5 2.48Zm0 .02a.67.67 0 0 0-.25-.2A2.5 2.5 0 0 0 8 2c-.54 0-.98.13-1.25.3a.67.67 0 0 0-.24.2c.02.04.08.1.24.2.27.17.71.3 1.25.3s.98-.13 1.25-.3c.16-.1.22-.16.24-.2Zm-3-.02ZM8 4a3.7 3.7 0 0 0 1.5-.3v1.1a.86.86 0 0 1-.2.15c-.23.14-.64.3-1.3.3a2.5 2.5 0 0 1-1.3-.3c-.09-.05-.15-.1-.2-.14V3.7c.42.19.94.3 1.5.3Zm0-3c1.38 0 2.5.67 2.5 1.5v.3l3.24 1.76A.5.5 0 0 1 14 5v6a.5.5 0 0 1-.26.44l-5.5 3a.5.5 0 0 1-.49 0l-5.49-3A.5.5 0 0 1 2 11V5c0-.18.1-.35.26-.44L5.5 2.8v-.3C5.5 1.67 6.62 1 8 1ZM5.5 3.93 3.23 5.17 8 7.45l4.77-2.28-2.27-1.24V5c0 .1-.03.2-.08.28L10 5l.42.28h-.01l-.01.02a1.11 1.11 0 0 1-.15.17c-.1.1-.24.22-.43.33-.4.24-.98.45-1.82.45-.84 0-1.43-.21-1.82-.45a2.24 2.24 0 0 1-.58-.5h-.01v-.01L6 5l-.42.28A.5.5 0 0 1 5.5 5V3.93Zm3 9.23L13 10.7V6.17L8.5 8.32v4.84ZM3 6.17v4.53l4.5 2.46V8.32L3 6.17Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TrendingIcon = createCustomIcon({
  name: "Trending",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M10.5 4a.5.5 0 0 0 0 1h1.831L8.9977 8.75l-1.876-2.0845a.5.5 0 0 0-.7352-.0088l-4.25 4.5a.5.5 0 1 0 .727.6866l3.8776-4.1057 1.8872 2.0969a.5002.5002 0 0 0 .7454-.0023L13 5.7526V7.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5h-3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MaintenanceIcon = createCustomIcon({
  name: "Maintenance",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M12.1 2.49c.2.2.2.51 0 .7l-1.6 1.6.71.7 1.6-1.59c.19-.2.5-.2.7 0l-.35.36.35-.36.01.02a1.37 1.37 0 0 1 .1.1l.2.29c.15.24.32.6.4 1.05.17.94-.08 2.16-1.42 3.5-1 1-1.96 1.14-2.72.97a2.6 2.6 0 0 1-.76-.32l-4.3 4.3a2 2 0 1 1-2.82-2.84l4.29-4.29a2.6 2.6 0 0 1-.32-.76c-.17-.76-.02-1.73.98-2.72 1.33-1.34 2.55-1.6 3.49-1.42a3 3 0 0 1 1.44.7h.01l-.35.36.36-.35Zm-1.14.43c-.14-.07-.3-.13-.5-.16-.56-.1-1.46 0-2.6 1.14-.78.77-.8 1.4-.71 1.8a1.62 1.62 0 0 0 .35.68.5.5 0 0 1 0 .7l-4.6 4.6a1 1 0 1 0 1.42 1.42l4.6-4.6a.5.5 0 0 1 .7 0l.03.03.14.1c.13.08.3.17.52.22.4.1 1.02.07 1.79-.7C13.24 7 13.34 6.1 13.24 5.54c-.03-.2-.1-.36-.16-.5l-1.51 1.52a.5.5 0 0 1-.71 0L9.44 5.14a.5.5 0 0 1 0-.7l1.52-1.52Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ComponentIcon = createCustomIcon({
  name: "Component",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M7.76 2.06a.5.5 0 0 1 .48 0l5.5 3a.5.5 0 0 1 0 .88l-5.5 3a.5.5 0 0 1-.48 0l-5.5-3a.5.5 0 0 1 0-.88l5.5-3ZM8 3.07 3.54 5.5 8 7.93l4.46-2.43L8 3.07Zm-5.94 4.7a.5.5 0 0 1 .68-.2L8 10.42l5.26-2.87a.5.5 0 1 1 .48.88l-5.5 3a.5.5 0 0 1-.48 0l-5.5-3a.5.5 0 0 1-.2-.68Zm.68 2.3a.5.5 0 1 0-.48.87l5.5 3a.5.5 0 0 0 .48 0l5.5-3a.5.5 0 1 0-.48-.88L8 12.93l-5.26-2.87Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ProjectIcon = createCustomIcon({
  name: "Project",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M2.5 3a1 1 0 0 1 1-1H10a.5.5 0 0 1 .38.175l3 3.5A.5.5 0 0 1 13.5 6v7a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V3Zm7.27 0H3.5v10h9V6.185L9.77 3ZM4.5 6.5A.5.5 0 0 1 5 6h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm1 1.5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5Zm0 3V9h5v2h-5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const AttentionIcon = createCustomIcon({
  name: "Attention",
  category: "General / Status",
  path: (
    <path
      clipRule="evenodd"
      d="M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm.639 6.015a.5.5 0 0 1-.5.486H7.86a.5.5 0 0 1-.5-.487l-.097-3.5a.5.5 0 0 1 .5-.514h.472a.5.5 0 0 1 .5.514l-.097 3.5ZM8 10a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SendIcon = createCustomIcon({
  name: "Send",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M15.354 1.146a.5.5 0 0 1 .106.551l-5.572 13a.5.5 0 0 1-.888.06l-2.722-4.535L1.743 7.5a.5.5 0 0 1 .06-.888l13-5.572a.5.5 0 0 1 .55.106ZM7.272 9.935l2.082 3.47 4.164-9.716-6.246 6.246Zm5.539-6.953L3.096 7.146l3.47 2.082 6.245-6.246Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MinimizeIcon = createCustomIcon({
  name: "Minimize",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M10.698 6.009h2.82a.5.5 0 0 1 0 1H9v-4.5a.5.5 0 0 1 1 0v2.784l3.646-3.647a.5.5 0 0 1 .708.708l-3.656 3.655ZM6.508 9h.51v4.536a.5.5 0 0 1-1 0v-2.847l-3.664 3.665a.5.5 0 0 1-.708-.708L5.293 10H2.518a.5.5 0 0 1 0-1h3.989Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MaximizeIcon = createCustomIcon({
  name: "Maximize",
  category: "General / Arrows",
  path: (
    <path
      clipRule="evenodd"
      d="M8.644 6.648a.5.5 0 0 0 .712.703l3.662-3.705V6.5a.5.5 0 0 0 1 0V2h-.35a.502.502 0 0 0-.371 0H9.5a.5.5 0 0 0 0 1h2.75L8.644 6.648Zm-1.29 2.706a.5.5 0 1 0-.708-.708L3 12.293V9.5a.5.5 0 0 0-1 0v4.536h4.5a.5.5 0 0 0 0-1H3.672l3.682-3.682Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GroupedColumnChartIcon = createCustomIcon({
  name: "Grouped column chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M5 1H7V13H5V1Z" fill="currentColor" />
      <path d="M2 7H4V13H2V7Z" fill="currentColor" />
      <path d="M1 14H15V15H1V14Z" fill="currentColor" />
      <path d="M11 9H9V13H11V9Z" fill="currentColor" />
      <path d="M14 4H12V13H14V4Z" fill="currentColor" />
    </>
  ),
});

export const StackedColumnChartIcon = createCustomIcon({
  name: "Stacked column chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M7 1H9V8H7V1Z" fill="currentColor" />
      <path d="M3 4H5V9H3V4Z" fill="currentColor" />
      <path d="M1 14H15V15H1V14Z" fill="currentColor" />
      <path d="M9 9H7V13H9V9Z" fill="currentColor" />
      <path d="M11 7H13V13H11V7Z" fill="currentColor" />
      <path d="M5 10H3V13H5V10Z" fill="currentColor" />
      <path d="M13 3H11V6H13V3Z" fill="currentColor" />
    </>
  ),
});

export const Stacked100ColumnChartIcon = createCustomIcon({
  name: "Stacked 100 column chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M9 1H7V10H9V1Z" fill="currentColor" />
      <path d="M11 6H13V13H11V6Z" fill="currentColor" />
      <path d="M5 9H3V13H5V9Z" fill="currentColor" />
      <path d="M7 11H9V13H7V11Z" fill="currentColor" />
      <path d="M1 14H15V15H1V14Z" fill="currentColor" />
      <path d="M3 1H5V8H3V1Z" fill="currentColor" />
      <path d="M13 1H11V5H13V1Z" fill="currentColor" />
    </>
  ),
});

export const GroupedBarChartIcon = createCustomIcon({
  name: "Grouped bar chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M15 4.5L15 6.5L3 6.5L3 4.5L15 4.5Z" fill="currentColor" />
      <path d="M9 1.5L9 3.5L3 3.5L3 1.5L9 1.5Z" fill="currentColor" />
      <path
        d="M2 0.999999L2 15L0.999999 15L1 0.999999L2 0.999999Z"
        fill="currentColor"
      />
      <path d="M7 11.5L7 9.5L3 9.5L3 11.5L7 11.5Z" fill="currentColor" />
      <path d="M12 14.5L12 12.5L3 12.5L3 14.5L12 14.5Z" fill="currentColor" />
    </>
  ),
});

export const StackedBarChartIcon = createCustomIcon({
  name: "Stacked bar chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M15 7V9H8V7H15Z" fill="currentColor" />
      <path d="M12 3V5L7 5V3L12 3Z" fill="currentColor" />
      <path d="M2 1V15H1V1H2Z" fill="currentColor" />
      <path d="M7 9L7 7H3V9H7Z" fill="currentColor" />
      <path d="M9 11V13H3V11H9Z" fill="currentColor" />
      <path d="M6 5V3L3 3V5H6Z" fill="currentColor" />
      <path d="M13 13V11H10V13H13Z" fill="currentColor" />
    </>
  ),
});

export const Stacked100AreaChartIcon = createCustomIcon({
  name: "Stacked 100 area chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path
        d="M4.5 7.5L6 6.5L9.5 8.5L14 4.5V11.5H4.5V7.5Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path
        clipRule="evenodd"
        d="M14.9958 3.50212L15 3.5V1.5C15 1.22386 14.7761 1 14.5 1H4C3.72386 1 3.5 1.22386 3.5 1.5V8H3.5277C3.5097 8.03499 3.5 8.07414 3.5 8.11439V12.25C3.5 12.3881 3.61193 12.5 3.75 12.5H14.75C14.8881 12.5 15 12.3881 15 12.25V3.54937C15 3.53302 14.9985 3.51725 14.9958 3.50212ZM14 11.5H4.5V8.45755L6.1844 7.00221L8.51232 8.6923C8.98359 9.03445 9.6287 9.00582 10.0678 8.62326L14 5.19749V11.5ZM14 3.87121V2H4.5V7.13599L5.98048 5.85684C6.06832 5.78094 6.19686 5.7755 6.2908 5.8437L9.09982 7.88308C9.19408 7.95151 9.3231 7.94578 9.41092 7.86927L14 3.87121Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path d="M2 1H1V15H15V14H2V1Z" fill="currentColor" />
    </>
  ),
});

export const Stacked100BarChartIcon = createCustomIcon({
  name: "Stacked 100 bar chart",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M15 9V7L6 7V9H15Z" fill="currentColor" />
      <path d="M10 11V13H3V11H10Z" fill="currentColor" />
      <path d="M7 5V3L3 3V5H7Z" fill="currentColor" />
      <path d="M5 7V9H3V7H5Z" fill="currentColor" />
      <path d="M2 1V15H1V1H2Z" fill="currentColor" />
      <path d="M15 3V5H8V3L15 3Z" fill="currentColor" />
      <path d="M15 13V11H11V13H15Z" fill="currentColor" />
    </>
  ),
});

export const GanttChartIcon = createCustomIcon({
  name: "Gantt chart",
  category: "Cells / Types: Chart",
  path: (
    <path
      clipRule="evenodd"
      d="M1 1H2V14H15V15H1V1ZM3 3H6V4H3V3ZM4 6H9V7H4V6ZM6 9H9V10H6V9ZM9 12H15V13H9V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const EjectComponentIcon = createCustomIcon({
  name: "Eject component",
  category: "Project / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="m.304 7.485 3.75-1.597.392.92-2.67 1.137L8 10.597l6.224-2.652-2.67-1.137.392-.92 3.75 1.597a.5.5 0 0 1 0 .92l-7.5 3.196a.5.5 0 0 1-.392 0l-7.5-3.196a.5.5 0 0 1 0-.92ZM8 13.793.696 10.681l-.392.92L8 14.881l7.696-3.28-.392-.92L8 13.793Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.188 3.351 8 1.101l2.812 2.25-.624.781L8.5 2.782v6.21h-1v-6.21l-1.688 1.35-.624-.78Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const PulseIcon = createCustomIcon({
  name: "Pulse",
  category: "General / Misc",
  tags: ["status"],
  path: (
    <path
      clipRule="evenodd"
      d="M9.5 3a.5.5 0 0 0-.4743.3419L6.5 10.9189l-1.0257-3.077A.5.5 0 0 0 5 7.5H2a.5.5 0 0 0 0 1h2.6396l1.386 4.1581a.5.5 0 0 0 .9487 0L9.5 5.0811l1.0257 3.077a.4999.4999 0 0 0 .4743.342h3a.5.5 0 0 0 0-1h-2.6396l-1.386-4.1582A.5.5 0 0 0 9.5 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const HistogramIcon = createCustomIcon({
  name: "Histogram",
  category: "Cells / Types: Chart",
  path: (
    <>
      <path d="M1 14H15V15H1V14Z" fill="currentColor" />
      <path d="M1 12H3V13H1V12Z" fill="currentColor" />
      <path d="M7 7H9V13H7V7Z" fill="currentColor" />
      <path d="M4 10H6V13H4V10Z" fill="currentColor" />
      <path d="M10 1H12V13H10V1Z" fill="currentColor" />
      <path d="M13 9H15V13H13V9Z" fill="currentColor" />
    </>
  ),
});

export const KeyEnterIcon = createCustomIcon({
  name: "Key: Enter",
  category: "General / Keys",
  path: (
    <path
      clipRule="evenodd"
      d="M12.0502 3.5C12.7956 3.50011 13.3996 4.10427 13.3998 4.84961V8.4502C13.3997 9.19562 12.7956 9.7997 12.0502 9.7998H4.13613L6.06777 11.7314C6.24351 11.9072 6.24351 12.1924 6.06777 12.3682C5.89205 12.5437 5.60771 12.5437 5.43203 12.3682L2.73183 9.66797C2.6475 9.58359 2.6 9.46891 2.6 9.34961C2.6001 9.2305 2.64766 9.11651 2.73183 9.03223L5.43203 6.33203C5.60773 6.15633 5.89203 6.15639 6.06777 6.33203C6.24351 6.50777 6.24351 6.79204 6.06777 6.96777L4.13515 8.90039H12.0502C12.2986 8.90029 12.5003 8.69857 12.5004 8.4502V4.84961C12.5002 4.60133 12.2985 4.4005 12.0502 4.40039H10.2504C10.0019 4.40039 9.8003 4.19863 9.80019 3.9502C9.80019 3.70167 10.0019 3.5 10.2504 3.5H12.0502Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const KeyShiftIcon = createCustomIcon({
  name: "Key: Shift",
  category: "General / Keys",
  path: (
    <path
      clipRule="evenodd"
      d="M7.28166 3.35749C7.64742 2.88084 8.35258 2.88084 8.71834 3.35749L12.8031 7.74513C13.2741 8.35887 12.847 9.25843 12.0847 9.25843H10.7407V12.0646C10.7407 12.5812 10.3316 13 9.82711 13H6.17289C5.66835 13 5.25934 12.5812 5.25934 12.0646V9.25843H3.91525C3.15296 9.25843 2.72595 8.35887 3.19691 7.74514L7.28166 3.35749ZM8 3.93539L3.91525 8.32304L6.17289 8.32304V12.0646H9.82711V8.32304H12.0847L8 3.93539Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const KeyOptionIcon = createCustomIcon({
  name: "Key: Option",
  category: "General / Keys",
  path: (
    <path
      d="M6 3.5L6.07031 3.50488C6.23141 3.52773 6.37319 3.62821 6.44727 3.77637L10.3086 11.5H13C13.2761 11.5 13.5 11.7239 13.5 12C13.5 12.2761 13.2761 12.5 13 12.5H10C9.81061 12.5 9.63743 12.393 9.55273 12.2236L5.69141 4.5H3C2.72386 4.5 2.5 4.27614 2.5 4C2.5 3.72386 2.72386 3.5 3 3.5H6ZM13 3.5C13.2761 3.5 13.5 3.72386 13.5 4C13.5 4.27614 13.2761 4.5 13 4.5H9.5C9.22386 4.5 9 4.27614 9 4C9 3.72386 9.22386 3.5 9.5 3.5H13Z"
      fill="currentColor"
    />
  ),
});

export const KeyCtrlIcon = createCustomIcon({
  name: "Key: Ctrl",
  category: "General / Keys",
  path: (
    <path
      clipRule="evenodd"
      d="M7.99999 6.88389L11.6464 10.5303L12.3535 9.82323L7.99999 5.46967L3.64644 9.82323L4.35355 10.5303L7.99999 6.88389Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const KeyCommandIcon = createCustomIcon({
  name: "Key: Command",
  category: "General / Keys",
  path: (
    <path
      clipRule="evenodd"
      d="M3 5.00006C3 3.89549 3.89543 3.00006 5 3.00006C6.10457 3.00006 7 3.89549 7 5.00006V6.00006H9V5.00006C9 3.89549 9.89543 3.00006 11 3.00006C12.1046 3.00006 13 3.89549 13 5.00006C13 6.10463 12.1046 7.00006 11 7.00006H10V9.00006H11C12.1046 9.00006 13 9.89549 13 11.0001C13 12.1046 12.1046 13.0001 11 13.0001C9.89543 13.0001 9 12.1046 9 11.0001V10.0001H7V11.0001C7 12.1046 6.10457 13.0001 5 13.0001C3.89543 13.0001 3 12.1046 3 11.0001C3 9.89549 3.89543 9.00006 5 9.00006H6V7.00006H5C3.89543 7.00006 3 6.10463 3 5.00006ZM10 10.0001V11.0001C10 11.5523 10.4477 12.0001 11 12.0001C11.5523 12.0001 12 11.5523 12 11.0001C12 10.4478 11.5523 10.0001 11 10.0001H10ZM9 9.00006V7.00006H7V9.00006H9ZM11 6.00006H10V5.00006C10 4.44778 10.4477 4.00006 11 4.00006C11.5523 4.00006 12 4.44778 12 5.00006C12 5.55235 11.5523 6.00006 11 6.00006ZM6 10.0001H5C4.44772 10.0001 4 10.4478 4 11.0001C4 11.5523 4.44772 12.0001 5 12.0001C5.55228 12.0001 6 11.5523 6 11.0001V10.0001ZM6 5.00006V6.00006H5C4.44772 6.00006 4 5.55235 4 5.00006C4 4.44778 4.44772 4.00006 5 4.00006C5.55228 4.00006 6 4.44778 6 5.00006Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const SelectCellIcon = createCustomIcon({
  name: "Select cell",
  category: "Cells / Actions",
  path: (
    <path
      d="M4.68848 4.1377C4.86291 3.99137 5.1166 3.95889 5.32812 4.05469L15.6777 8.74121C15.8834 8.83435 16.0095 9.03164 15.999 9.24316C15.9885 9.45462 15.8438 9.64042 15.6299 9.71582L11.4609 11.1836L10.0625 15.6172C9.99316 15.8369 9.77963 15.9914 9.53223 16C9.28495 16.0085 9.05968 15.8694 8.97266 15.6553L4.53711 4.71875C4.45439 4.5148 4.51404 4.2841 4.68848 4.1377ZM12.917 0.5C13.3692 0.500104 13.7796 0.716473 14.0664 1.06055C14.3511 1.40215 14.5 1.84897 14.5 2.2998V4.49902H13.5V2.2998C13.5 2.06138 13.4203 1.84707 13.2988 1.70117C13.1795 1.55802 13.0391 1.5001 12.917 1.5H2.08301C1.96085 1.5001 1.82047 1.55802 1.70117 1.70117C1.57973 1.84707 1.50004 2.06138 1.5 2.2998V12.7002C1.50004 12.9386 1.57973 13.1529 1.70117 13.2988C1.82047 13.442 1.96085 13.4999 2.08301 13.5H5.5V14.5H2.08301C1.63085 14.4999 1.22044 14.2835 0.933594 13.9395C0.648924 13.5978 0.500043 13.151 0.5 12.7002V2.2998C0.500043 1.84897 0.648923 1.40215 0.933594 1.06055C1.22044 0.716473 1.63085 0.500104 2.08301 0.5H12.917ZM9.44238 13.7861L10.4375 10.6328C10.4879 10.473 10.616 10.3435 10.7842 10.2842L13.9834 9.1582L6.12109 5.59766L9.44238 13.7861Z"
      fill="currentColor"
    />
  ),
});

export const ImportReferenceIcon = createCustomIcon({
  name: "Import reference",
  category: "Project / Object",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M7.002 1h3.804L14 3.92v10.513c0 .258-.295.567-.667.567H2.567A.567.567 0 0 1 2 14.433V6.005H1v8.428C1 15.3 1.701 16 2.567 16h10.766C14.14 16 15 15.354 15 14.433V3.48l-.163-.149-3.5-3.2L11.194 0H7.002v1ZM4.5 6H4v5h7V6H4.5ZM5 8V7h2v1H5Zm3 0V7h2v1H8Zm0 1h2v1H8V9ZM7 9v1H5V9h2Zm5 4v-1H4v1h8ZM6 4.5V1H5v2.294L1.709 0l-.707.707L4.294 4H2v1h4v-.5Z"
        fill="currentColor"
      />
      <path
        d="M4.948 6.99h5.1v3.059h-5.1v-3.06Z"
        fill="currentColor"
        opacity=".2"
      />
    </>
  ),
});

export const CollectionIcon = createCustomIcon({
  name: "Collection",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M2 7a.5.5 0 0 0 .5.5H7a.5.5 0 0 0 .5-.5V2.5A.5.5 0 0 0 7 2H2.5a.5.5 0 0 0-.5.5V7Zm4.5-.5H3V3h3.5v3.5Zm2 .5a.5.5 0 0 0 .5.5h4.5A.5.5 0 0 0 14 7V2.5a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5V7Zm4.5-.5H9.5V3H13v3.5ZM2.5 14a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-.5.5H2.5Zm.5-1h3.5V9.5H3V13Zm5.5.5a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v4.5ZM13 13H9.5V9.5H13V13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const RemoveCollectionIcon = createCustomIcon({
  name: "Remove from collection",
  category: "Workspace / Organization",
  path: (
    <path
      clipRule="evenodd"
      d="M3 3h.537a.5.5 0 0 0 0-1h-.593A.944.944 0 0 0 2 2.944v.593a.5.5 0 0 0 1 0V3Zm2.407-.5a.5.5 0 0 1 .5-.5h1.186a.5.5 0 0 1 0 1H5.907a.5.5 0 0 1-.5-.5Zm3.556 0a.5.5 0 0 1 .5-.5h.593c.521 0 .944.423.944.944v.593a.5.5 0 0 1-1 0V3h-.537a.5.5 0 0 1-.5-.5ZM10.5 5.407a.5.5 0 0 1 .5.5v1.186a.5.5 0 0 1-1 0V5.907a.5.5 0 0 1 .5-.5Zm-8 0a.5.5 0 0 1 .5.5v1.186a.5.5 0 1 1-1 0V5.907a.5.5 0 0 1 .5-.5Zm8 3.556a.5.5 0 0 1 .5.5v.593a.944.944 0 0 1-.944.944h-.593a.5.5 0 0 1 0-1H10v-.537a.5.5 0 0 1 .5-.5Zm-8 0a.5.5 0 0 1 .5.5V10h.537a.5.5 0 0 1 0 1h-.593A.944.944 0 0 1 2 10.056v-.593a.5.5 0 0 1 .5-.5ZM5.407 10.5a.5.5 0 0 1 .5-.5h1.186a.5.5 0 0 1 0 1H5.907a.5.5 0 0 1-.5-.5ZM8 6a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h3Zm4.5-1a.5.5 0 0 0 0 1h.5v7H6v-.5a.5.5 0 0 0-1 0v.556c0 .521.423.944.944.944h7.112a.944.944 0 0 0 .944-.944V5.944A.944.944 0 0 0 13.056 5H12.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const BugIcon = createCustomIcon({
  name: "Bug",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M8 3.5A2 2 0 0 0 6.06 5h3.88A2 2 0 0 0 8 3.5ZM5.07 6.47c.06-.1.19-.27.55-.47H7.5v4a.5.5 0 0 0 1 0V6h1.88c.36.2.5.36.55.47.06.13.07.27.07.53v3.47c-.23 1.97-1.63 2.9-3 2.9s-2.77-.93-3-2.9V7c0-.26 0-.4.07-.53ZM8 2.5a3 3 0 0 1 2.94 2.42L12.7 3.6a.5.5 0 0 1 .6.8l-1.71 1.28c.1.11.17.23.23.35.18.35.18.7.18.94v.53h2a.5.5 0 0 1 0 1h-2v1.75l1.8 1.35a.5.5 0 0 1-.6.8l-1.36-1.02a3.95 3.95 0 0 1-7.68 0L2.8 12.4a.5.5 0 1 1-.6-.8L4 10.25V8.5H2a.5.5 0 0 1 0-1h2v-.53c0-.23 0-.59.18-.94.06-.12.14-.24.23-.35L2.7 4.4a.5.5 0 0 1 .6-.8l1.76 1.32A3 3 0 0 1 8 2.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const CodeCommentIcon = createCustomIcon({
  name: "Code comment",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M5.4931 4.99999L6.0068 1.91779L6.9932 2.08218L6.5069 4.99999H10.4931L11.0068 1.91779L11.9932 2.08218L11.5069 4.99999H14V5.99999H11.3402L10.6736 9.99998H14V11H10.5069L9.9932 14.0822L9.0068 13.9178L9.4931 11H5.5069L4.9932 14.0822L4.0068 13.9178L4.4931 11H2V9.99998H4.65977L5.32644 5.99999H2V4.99999H5.4931ZM6.34023 5.99999L5.67356 9.99998H9.65977L10.3264 5.99999H6.34023Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MagicIcon = createCustomIcon({
  name: "Magic",
  category: "Magic",
  path: (
    <path
      clipRule="evenodd"
      d="M11.4649 8C10.7733 9.1956 9.48056 10 8 10C6.51943 10 5.22675 9.1956 4.53513 8C5.22675 6.8044 6.51943 6 8 6C9.48056 6 10.7733 6.8044 11.4649 8ZM11.9039 6.87563C10.9876 5.73219 9.57928 5 8 5C6.42072 5 5.01245 5.73219 4.09613 6.87563C4.0332 6.59382 4 6.30079 4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6C12 6.30079 11.9668 6.59382 11.9039 6.87563ZM12.584 8C12.8516 7.38754 13 6.7111 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 6.7111 3.14845 7.38754 3.41604 8C3.14845 8.61246 3 9.2889 3 10C3 12.7614 5.23858 15 8 15C10.7614 15 13 12.7614 13 10C13 9.2889 12.8516 8.61246 12.584 8ZM11.9039 9.12437C10.9876 10.2678 9.57928 11 8 11C6.42072 11 5.01245 10.2678 4.09613 9.12437C4.0332 9.40618 4 9.69921 4 10C4 12.2091 5.79086 14 8 14C10.2091 14 12 12.2091 12 10C12 9.69921 11.9668 9.40618 11.9039 9.12437Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MagicAddIcon = createCustomIcon({
  name: "Magic add",
  category: "Magic",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M12.3303 8C12.2295 7.96966 12.1196 7.93935 12.0001 7.90948C11.0144 7.66306 9.59972 7.5 8 7.5C6.40028 7.5 4.98558 7.66306 3.99989 7.90948C3.88044 7.93935 3.77047 7.96966 3.66974 8C3.77047 8.03034 3.88044 8.06065 3.99989 8.09052C4.98558 8.33694 6.40028 8.5 8 8.5C9.59972 8.5 11.0144 8.33694 12.0001 8.09052C12.1196 8.06066 12.2295 8.03034 12.3303 8ZM14 8C14 8.82843 11.3137 9.5 8 9.5C4.68629 9.5 2 8.82843 2 8C2 7.17157 4.68629 6.5 8 6.5C11.3137 6.5 14 7.17157 14 8Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.09052 12.0001C8.33694 11.0144 8.5 9.59972 8.5 8C8.5 6.40028 8.33694 4.98558 8.09052 3.99989C8.06065 3.88044 8.03034 3.77047 8 3.66974C7.96966 3.77047 7.93935 3.88044 7.90948 3.99989C7.66306 4.98558 7.5 6.40028 7.5 8C7.5 9.59972 7.66306 11.0144 7.90948 12.0001C7.93935 12.1196 7.96966 12.2295 8 12.3303C8.03034 12.2295 8.06066 12.1196 8.09052 12.0001ZM9.5 8C9.5 11.3137 8.82843 14 8 14C7.17157 14 6.5 11.3137 6.5 8C6.5 4.68629 7.17157 2 8 2C8.82843 2 9.5 4.68629 9.5 8Z"
        fill="currentColor"
        fillRule="evenodd"
        opacity="0.8"
      />
    </>
  ),
});

export const MagicTypeaheadIcon = createCustomIcon({
  name: "Magic typeahead",
  category: "Magic",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M10.5005 2.5C8.56716 2.5 7 4.06706 7 6C7 6.34779 7.05074 6.68374 7.14521 7.00084C7.96931 6.07972 9.16721 5.5 10.5005 5.5C11.8338 5.5 13.0317 6.07972 13.8558 7.00084C13.9502 6.68374 14.001 6.34779 14.001 6C14.001 4.06706 12.4338 2.5 10.5005 2.5ZM14.5332 8C14.8326 7.39753 15.001 6.71843 15.001 6C15.001 3.51466 12.986 1.5 10.5005 1.5C8.01499 1.5 6 3.51466 6 6C6 6.71843 6.16837 7.39753 6.46781 8C6.16837 8.60247 6 9.28157 6 10C6 12.4853 8.01499 14.5 10.5005 14.5C12.986 14.5 15.001 12.4853 15.001 10C15.001 9.28157 14.8326 8.60247 14.5332 8ZM13.3735 8C12.741 7.09327 11.6901 6.5 10.5005 6.5C9.31093 6.5 8.25999 7.09327 7.62743 8C8.25999 8.90673 9.31093 9.5 10.5005 9.5C11.6901 9.5 12.741 8.90673 13.3735 8ZM7.14521 8.99916C7.96931 9.92028 9.16721 10.5 10.5005 10.5C11.8338 10.5 13.0317 9.92028 13.8558 8.99916C13.9502 9.31626 14.001 9.65221 14.001 10C14.001 11.9329 12.4338 13.5 10.5005 13.5C8.56716 13.5 7 11.9329 7 10C7 9.65221 7.05074 9.31626 7.14521 8.99916Z"
        fill="currentColor"
        fillRule="evenodd"
        opacity="0.3"
      />
      <path
        clipRule="evenodd"
        d="M2.11421 2.83934C1.84684 2.63881 1.45456 2.5 1 2.5V1.5C1.65001 1.5 2.25773 1.69697 2.71421 2.03934C2.81665 2.11617 2.91267 2.20149 3 2.29448C3.08733 2.20149 3.18335 2.11617 3.28579 2.03934C3.74227 1.69697 4.34999 1.5 5 1.5V2.5C4.54544 2.5 4.15316 2.63881 3.88579 2.83934C3.61857 3.03975 3.5 3.27845 3.5 3.5V7.5H5V8.5H3.5V12.5C3.5 12.7215 3.61857 12.9602 3.88579 13.1607C4.15316 13.3612 4.54544 13.5 5 13.5V14.5C4.34999 14.5 3.74227 14.303 3.28579 13.9607C3.18335 13.8838 3.08733 13.7985 3 13.7055C2.91267 13.7985 2.81665 13.8838 2.71421 13.9607C2.25773 14.303 1.65001 14.5 1 14.5V13.5C1.45456 13.5 1.84684 13.3612 2.11421 13.1607C2.38143 12.9602 2.5 12.7215 2.5 12.5V8.5H1V7.5H2.5V3.5C2.5 3.27845 2.38143 3.03975 2.11421 2.83934Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const CategoryTagIcon = createCustomIcon({
  name: "Category tag",
  category: "Workspace / Objects",
  tags: ["category", "categories"],
  path: (
    <path
      clipRule="evenodd"
      d="M8.1214 2a2 2 0 0 0-1.4142.5858L2.3536 6.9393c-.5857.5858-.5857 1.5356 0 2.1214l4.5858 4.5857c.5858.5858 1.5356.5858 2.1214 0l4.3535-4.3535a1.9999 1.9999 0 0 0 .5858-1.4142V3.5c0-.8284-.6716-1.5-1.5-1.5H8.1214Zm-.707 1.2929A1 1 0 0 1 8.1213 3H12.5a.5.5 0 0 1 .5.5v4.3787a.9997.9997 0 0 1-.2929.707l-4.3536 4.3536a.5.5 0 0 1-.707 0L3.0607 8.3536a.5.5 0 0 1 0-.7072L7.4143 3.293ZM10.5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM9 5.5c0-.8284.6716-1.5 1.5-1.5s1.5.6716 1.5 1.5S11.3284 7 10.5 7 9 6.3284 9 5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GemIcon = createCustomIcon({
  name: "Gem",
  category: "Workspace / Feature gating",
  path: (
    <path
      clipRule="evenodd"
      d="M4.5 2a.5.5 0 0 0-.42.23l-2.5 4a.5.5 0 0 0 .04.6l6 7a.5.5 0 0 0 .76 0l6-7a.5.5 0 0 0 .04-.6l-2.5-4A.5.5 0 0 0 11.5 2h-7ZM2.9 6l1.88-3h1.5L5.15 6H2.9Zm.19 1 3.75 4.38L5.16 7H3.09Zm6.07 4.38L12.9 7h-2.07l-1.68 4.38ZM13.1 6l-1.88-3h-1.5l1.13 3h2.25ZM8.65 3h-1.3L6.22 6h3.56L8.65 3ZM8 11.6 6.23 7h3.54L8 11.6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ListSearchIcon = createCustomIcon({
  name: "Search: list",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M8.8 2a4.8 4.8 0 0 1 3.716 7.837L15 12.32a.48.48 0 1 1-.679.679l-2.484-2.484A4.8 4.8 0 1 1 8.8 2ZM6.5 12a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5Zm2.3-9.04a3.84 3.84 0 1 0 0 7.68 3.84 3.84 0 0 0 0-7.68ZM3 9a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1 0-1H3Zm-.5-3a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm1-3a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1h2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MenuIcon = createCustomIcon({
  name: "Menu",
  category: "Workspace / Navigation",
  path: (
    <>
      <path
        d="M13 11.5C13.2761 11.5 13.5 11.7239 13.5 12C13.5 12.2761 13.2761 12.5 13 12.5H3C2.72386 12.5 2.5 12.2761 2.5 12C2.5 11.7239 2.72386 11.5 3 11.5H13ZM9 7.5C9.2761 7.5 9.5 7.72386 9.5 8C9.5 8.27614 9.2761 8.5 9 8.5H3C2.72386 8.5 2.5 8.27614 2.5 8C2.5 7.72386 2.72386 7.5 3 7.5H9ZM13 3.5C13.2761 3.5 13.5 3.72386 13.5 4C13.5 4.27614 13.2761 4.5 13 4.5H3C2.72386 4.5 2.5 4.27614 2.5 4C2.5 3.72386 2.72386 3.5 3 3.5H13Z"
        fill="currentColor"
      />
    </>
  ),
});

export const StylesIcon = createCustomIcon({
  name: "Styles",
  category: "General / Editing",
  path: (
    <path
      clipRule="evenodd"
      d="M12.9 3.1a.66.66 0 0 0-.9-.04L8.88 5.67l1.47 1.47L12.95 4a.66.66 0 0 0-.05-.9ZM7.24 7.05l.87-.73a.5.5 0 0 0 .04.04l1.5 1.5a.5.5 0 0 0 .06.06l-.74.9-1.73-1.77Zm4.12-4.74a1.66 1.66 0 0 1 2.35 2.33L9.4 9.88a.5.5 0 0 1-.75.03l-2.5-2.56a.5.5 0 0 1 .04-.73l5.18-4.32ZM3.6 10.1c.83-.82 1.99-.75 2.57-.23.23.2.5.57.6.94.08.34.05.7-.36 1.07-.21.2-.4.29-.54.34-.15.04-.3.05-.48.04l-.3-.02h-.02l-.33-.04a2.7 2.7 0 0 0-.86.06c-.38.1-.73.29-1 .44a4.99 4.99 0 0 1 0-.88c.07-.64.27-1.26.72-1.72Zm3.23-.97c-1-.9-2.76-.91-3.93.27a3.72 3.72 0 0 0-1.01 2.32 6.3 6.3 0 0 0 .12 1.89.5.5 0 0 0 .65.36c.12-.04.25-.11.35-.17l.15-.1.2-.12a3 3 0 0 1 .76-.34c.18-.05.36-.05.55-.04l.3.03.36.03c.25.02.53 0 .84-.09.3-.1.6-.27.92-.55.7-.64.82-1.4.64-2.06a3.08 3.08 0 0 0-.9-1.43Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PackageIcon = createCustomIcon({
  name: "Package",
  category: "Workspace / Objects",
  path: (
    <path
      clipRule="evenodd"
      d="M8.2 1.54a.5.5 0 0 0-.4 0l-5.5 2.5a.5.5 0 0 0-.3.46v6c0 .17.09.33.23.42l5.5 3.5c.17.1.37.1.54 0l5.5-3.5a.5.5 0 0 0 .23-.42v-6a.5.5 0 0 0-.3-.46l-5.5-2.5ZM3 5.32v4.9l4.5 2.87v-5.3L3 5.33Zm5.5 7.77 4.5-2.86v-4.9L8.5 7.8v5.29Zm3.86-8.56L8 2.55 3.64 4.53 8 6.93l4.36-2.4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const JinjaIcon = createCustomIcon({
  name: "Jinja",
  category: "Project / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M2.95957 1.80305C3.06835 2.05686 2.95077 2.3508 2.69696 2.45958C2.32627 2.61845 2.1726 2.83448 2.09394 3.0471C2.00448 3.28896 2 3.55575 2 3.84616C2 4.0439 2.00005 4.40609 2.00011 4.81085C2.00021 5.55256 2.00033 6.43717 2.0002 6.71453C2.00007 6.99419 1.84855 7.22821 1.74366 7.36789C1.62502 7.52589 1.47616 7.67697 1.34827 7.80111C1.29109 7.8566 1.24042 7.90465 1.19453 7.94816C1.17556 7.96615 1.15741 7.98336 1.13995 8.00001C1.15739 8.01663 1.17552 8.03384 1.19447 8.05181C1.24038 8.09533 1.29106 8.1434 1.34826 8.19892C1.47615 8.32306 1.625 8.47415 1.74363 8.63216C1.84851 8.77186 2.00002 9.00593 2.00006 9.28565L2 12.1539C2 12.4443 2.00448 12.711 2.09394 12.9529C2.1726 13.1655 2.32627 13.3816 2.69696 13.5404C2.95077 13.6492 3.06835 13.9432 2.95957 14.197C2.85079 14.4508 2.55686 14.5684 2.30304 14.4596C1.67373 14.1899 1.3274 13.763 1.15606 13.2999C0.999696 12.8772 0.999879 12.4468 0.999994 12.1752C0.999997 12.168 1 12.1609 1 12.1538L1.00006 9.31901C0.993626 9.30627 0.978116 9.2781 0.943917 9.23254C0.875029 9.14078 0.77387 9.035 0.651753 8.91647C0.614733 8.88053 0.572884 8.84076 0.529875 8.79988C0.448282 8.72233 0.362517 8.64082 0.297633 8.57403C0.245536 8.52041 0.18607 8.45566 0.136955 8.38732C0.10528 8.34325 2.98023e-08 8.19677 0 8.00001C0 7.80324 0.104989 7.65717 0.136665 7.6131C0.185781 7.54476 0.245541 7.4796 0.297639 7.42598C0.362547 7.35917 0.448335 7.27764 0.529948 7.20007C0.57294 7.15922 0.614772 7.11946 0.651784 7.08353C0.773912 6.965 0.875094 6.8592 0.944009 6.76743C0.97827 6.7218 0.99379 6.6936 1.00022 6.68087C1.00032 6.3718 1.00021 5.52583 1.00011 4.81178C1.00005 4.4068 1 4.04426 1 3.84616C1 3.83914 0.999997 3.83201 0.999994 3.82476C0.999879 3.55316 0.999696 3.12285 1.15606 2.70016C1.3274 2.23697 1.67373 1.81014 2.30304 1.54043C2.55686 1.43166 2.85079 1.54923 2.95957 1.80305ZM0.948983 7.8037C0.941188 7.79286 0.944267 7.79473 0.951835 7.80749C0.950649 7.80597 0.949706 7.80471 0.948983 7.8037ZM0.951834 8.19252C0.944266 8.20529 0.941187 8.20716 0.948981 8.19631C0.949705 8.19531 0.950648 8.19405 0.951834 8.19252Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.5404 14.197C10.4316 13.9431 10.5492 13.6492 10.803 13.5404C11.1737 13.3816 11.3274 13.1655 11.4061 12.9529C11.4955 12.711 11.5 12.4443 11.5 12.1538C11.5 11.9561 11.4999 11.5939 11.4999 11.1892C11.4998 10.4474 11.4997 9.56283 11.4998 9.28547C11.4999 9.00581 11.6514 8.77179 11.7563 8.63211C11.875 8.47411 12.0238 8.32303 12.1517 8.19889C12.2089 8.1434 12.2596 8.09535 12.3055 8.05184C12.3244 8.03385 12.3426 8.01664 12.3601 7.99999C12.3426 7.98337 12.3245 7.96616 12.3055 7.94819C12.2596 7.90467 12.2089 7.8566 12.1517 7.80108C12.0238 7.67694 11.875 7.52585 11.7564 7.36784C11.6515 7.22814 11.5 6.99407 11.4999 6.71435L11.5 3.84614C11.5 3.55574 11.4955 3.28895 11.4061 3.04709C11.3274 2.83446 11.1737 2.61843 10.803 2.45957C10.5492 2.35079 10.4316 2.05685 10.5404 1.80303C10.6492 1.54922 10.9431 1.43164 11.197 1.54042C11.8263 1.81013 12.1726 2.23695 12.3439 2.70015C12.5003 3.12284 12.5001 3.55315 12.5 3.82475C12.5 3.832 12.5 3.83913 12.5 3.84616L12.4999 6.68099C12.5064 6.69373 12.5219 6.7219 12.5561 6.76746C12.625 6.85922 12.7261 6.965 12.8482 7.08353C12.8853 7.11947 12.9271 7.15924 12.9701 7.20012C13.0517 7.27767 13.1375 7.35918 13.2024 7.42597C13.2545 7.47959 13.3139 7.54434 13.363 7.61268C13.3947 7.65675 13.5 7.80323 13.5 7.99999C13.5 8.19676 13.395 8.34283 13.3633 8.3869C13.3142 8.45524 13.2545 8.5204 13.2024 8.57402C13.1375 8.64083 13.0517 8.72236 12.9701 8.79993C12.9271 8.84078 12.8852 8.88054 12.8482 8.91647C12.7261 9.035 12.6249 9.1408 12.556 9.23257C12.5217 9.2782 12.5062 9.3064 12.4998 9.31913C12.4997 9.6282 12.4998 10.4742 12.4999 11.1882C12.4999 11.5932 12.5 11.9557 12.5 12.1538C12.5 12.1609 12.5 12.168 12.5 12.1752C12.5001 12.4468 12.5003 12.8772 12.3439 13.2998C12.1726 13.763 11.8263 14.1899 11.197 14.4596C10.9431 14.5683 10.6492 14.4508 10.5404 14.197ZM12.551 8.1963C12.5588 8.20714 12.5557 8.20527 12.5482 8.19251C12.5494 8.19403 12.5503 8.19529 12.551 8.1963ZM12.5482 7.80748C12.5557 7.79471 12.5588 7.79284 12.551 7.80369C12.5503 7.80469 12.5494 7.80595 12.5482 7.80748Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.45957 1.80305C5.56835 2.05686 5.45077 2.3508 5.19696 2.45958C4.82627 2.61845 4.6726 2.83448 4.59394 3.0471C4.50448 3.28896 4.5 3.55575 4.5 3.84616C4.5 4.0439 4.50005 4.40609 4.50011 4.81085C4.50021 5.55256 4.50033 6.43717 4.5002 6.71453C4.50007 6.99419 4.34855 7.22821 4.24366 7.36789C4.12502 7.52589 3.97616 7.67697 3.84827 7.80111C3.79109 7.8566 3.74042 7.90465 3.69453 7.94816C3.67556 7.96615 3.65741 7.98336 3.63995 8.00001C3.65739 8.01663 3.67552 8.03384 3.69447 8.05181C3.74038 8.09533 3.79106 8.1434 3.84826 8.19892C3.97615 8.32306 4.125 8.47415 4.24363 8.63216C4.34851 8.77186 4.50002 9.00593 4.50006 9.28565L4.5 12.1539C4.5 12.4443 4.50448 12.711 4.59394 12.9529C4.6726 13.1655 4.82627 13.3816 5.19696 13.5404C5.45077 13.6492 5.56835 13.9432 5.45957 14.197C5.35079 14.4508 5.05686 14.5684 4.80304 14.4596C4.17373 14.1899 3.8274 13.763 3.65606 13.2999C3.4997 12.8772 3.49988 12.4468 3.49999 12.1752C3.5 12.168 3.5 12.1609 3.5 12.1538L3.50006 9.31901C3.49363 9.30627 3.47812 9.2781 3.44392 9.23254C3.37503 9.14078 3.27387 9.035 3.15175 8.91647C3.11473 8.88053 3.07288 8.84076 3.02987 8.79988C2.94828 8.72233 2.86252 8.64082 2.79763 8.57403C2.74554 8.52041 2.68607 8.45566 2.63696 8.38732C2.60528 8.34325 2.5 8.19677 2.5 8.00001C2.5 7.80324 2.60499 7.65717 2.63667 7.6131C2.68578 7.54476 2.74554 7.4796 2.79764 7.42598C2.86255 7.35917 2.94834 7.27764 3.02995 7.20007C3.07294 7.15922 3.11477 7.11946 3.15178 7.08353C3.27391 6.965 3.37509 6.8592 3.44401 6.76743C3.47827 6.7218 3.49379 6.6936 3.50022 6.68087C3.50032 6.3718 3.50021 5.52583 3.50011 4.81178C3.50005 4.4068 3.5 4.04426 3.5 3.84616C3.5 3.83914 3.5 3.83201 3.49999 3.82476C3.49988 3.55316 3.4997 3.12285 3.65606 2.70016C3.8274 2.23697 4.17373 1.81014 4.80304 1.54043C5.05686 1.43166 5.35079 1.54923 5.45957 1.80305ZM3.44898 7.8037C3.44119 7.79286 3.44427 7.79473 3.45183 7.80749C3.45065 7.80597 3.44971 7.80471 3.44898 7.8037ZM3.45183 8.19252C3.44427 8.20529 3.44119 8.20716 3.44898 8.19631C3.4497 8.19531 3.45065 8.19405 3.45183 8.19252Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.0404 14.197C12.9316 13.9431 13.0492 13.6492 13.303 13.5404C13.6737 13.3816 13.8274 13.1655 13.9061 12.9529C13.9955 12.711 14 12.4443 14 12.1538C14 11.9561 13.9999 11.5939 13.9999 11.1892C13.9998 10.4474 13.9997 9.56283 13.9998 9.28547C13.9999 9.00581 14.1514 8.77179 14.2563 8.63211C14.375 8.47411 14.5238 8.32303 14.6517 8.19889C14.7089 8.1434 14.7596 8.09535 14.8055 8.05184C14.8244 8.03385 14.8426 8.01664 14.8601 7.99999C14.8426 7.98337 14.8245 7.96616 14.8055 7.94819C14.7596 7.90467 14.7089 7.8566 14.6517 7.80108C14.5238 7.67694 14.375 7.52585 14.2564 7.36784C14.1515 7.22814 14 6.99407 13.9999 6.71435L14 3.84614C14 3.55574 13.9955 3.28895 13.9061 3.04709C13.8274 2.83446 13.6737 2.61843 13.303 2.45957C13.0492 2.35079 12.9316 2.05685 13.0404 1.80303C13.1492 1.54922 13.4431 1.43164 13.697 1.54042C14.3263 1.81013 14.6726 2.23695 14.8439 2.70015C15.0003 3.12284 15.0001 3.55315 15 3.82475C15 3.832 15 3.83913 15 3.84616L14.9999 6.68099C15.0064 6.69373 15.0219 6.7219 15.0561 6.76746C15.125 6.85922 15.2261 6.965 15.3482 7.08353C15.3853 7.11947 15.4271 7.15924 15.4701 7.20012C15.5517 7.27767 15.6375 7.35918 15.7024 7.42597C15.7545 7.47959 15.8139 7.54434 15.863 7.61268C15.8947 7.65675 16 7.80323 16 7.99999C16 8.19676 15.895 8.34283 15.8633 8.3869C15.8142 8.45524 15.7545 8.5204 15.7024 8.57402C15.6375 8.64083 15.5517 8.72236 15.4701 8.79993C15.4271 8.84078 15.3852 8.88054 15.3482 8.91647C15.2261 9.035 15.1249 9.1408 15.056 9.23257C15.0217 9.2782 15.0062 9.3064 14.9998 9.31913C14.9997 9.6282 14.9998 10.4742 14.9999 11.1882C14.9999 11.5932 15 11.9557 15 12.1538C15 12.1609 15 12.168 15 12.1752C15.0001 12.4468 15.0003 12.8772 14.8439 13.2998C14.6726 13.763 14.3263 14.1899 13.697 14.4596C13.4431 14.5683 13.1492 14.4508 13.0404 14.197ZM15.051 8.1963C15.0588 8.20714 15.0557 8.20527 15.0482 8.19251C15.0494 8.19403 15.0503 8.19529 15.051 8.1963ZM15.0482 7.80748C15.0557 7.79471 15.0588 7.79284 15.051 7.80369C15.0503 7.80469 15.0494 7.80595 15.0482 7.80748Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.088 9.61693C5.97067 9.73426 5.97067 9.92448 6.088 10.0418C6.20532 10.1591 6.39555 10.1591 6.51288 10.0418L8.00002 8.55467L9.48724 10.0419C9.60457 10.1592 9.79479 10.1592 9.91212 10.0419C10.0294 9.92456 10.0294 9.73433 9.91212 9.61701L8.4249 8.12979L9.91193 6.64276C10.0293 6.52543 10.0293 6.33521 9.91193 6.21788C9.7946 6.10055 9.60437 6.10055 9.48705 6.21788L8.00002 7.70491L6.51307 6.21795C6.39574 6.10063 6.20551 6.10063 6.08819 6.21795C5.97086 6.33528 5.97086 6.52551 6.08819 6.64284L7.57514 8.12979L6.088 9.61693Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M6.088 10.0418L6.22942 9.90039L6.22942 9.90039L6.088 10.0418ZM6.088 9.61693L5.94657 9.47551L5.94657 9.47551L6.088 9.61693ZM6.51288 10.0418L6.37146 9.90039L6.37146 9.90039L6.51288 10.0418ZM8.00002 8.55467L8.14144 8.41325L8.00002 8.27183L7.8586 8.41325L8.00002 8.55467ZM9.48724 10.0419L9.34582 10.1833L9.34582 10.1833L9.48724 10.0419ZM9.91212 10.0419L9.7707 9.90047L9.7707 9.90047L9.91212 10.0419ZM9.91212 9.61701L9.7707 9.75843L9.7707 9.75843L9.91212 9.61701ZM8.4249 8.12979L8.28348 7.98837L8.14206 8.12979L8.28348 8.27121L8.4249 8.12979ZM9.91193 6.64276L9.77051 6.50134L9.91193 6.64276ZM9.91193 6.21788L9.77051 6.3593L9.77051 6.3593L9.91193 6.21788ZM9.48705 6.21788L9.34563 6.07646L9.34563 6.07646L9.48705 6.21788ZM8.00002 7.70491L7.8586 7.84633L8.00002 7.98775L8.14144 7.84633L8.00002 7.70491ZM6.51307 6.21795L6.65449 6.07653L6.65449 6.07653L6.51307 6.21795ZM6.08819 6.21795L6.22961 6.35938L6.22961 6.35938L6.08819 6.21795ZM6.08819 6.64284L5.94676 6.78426L5.94676 6.78426L6.08819 6.64284ZM7.57514 8.12979L7.71656 8.27121L7.85798 8.12979L7.71656 7.98837L7.57514 8.12979ZM6.22942 9.90039C6.19019 9.86117 6.19019 9.79757 6.22942 9.75835L5.94657 9.47551C5.75114 9.67094 5.75114 9.9878 5.94657 10.1832L6.22942 9.90039ZM6.37146 9.90039C6.33223 9.93961 6.26864 9.93961 6.22942 9.90039L5.94657 10.1832C6.14201 10.3787 6.45887 10.3787 6.6543 10.1832L6.37146 9.90039ZM7.8586 8.41325L6.37146 9.90039L6.6543 10.1832L8.14144 8.69609L7.8586 8.41325ZM9.62866 9.90047L8.14144 8.41325L7.8586 8.69609L9.34582 10.1833L9.62866 9.90047ZM9.7707 9.90047C9.73148 9.93969 9.66788 9.93969 9.62866 9.90047L9.34582 10.1833C9.54125 10.3787 9.85811 10.3787 10.0535 10.1833L9.7707 9.90047ZM9.7707 9.75843C9.80992 9.79765 9.80992 9.86124 9.7707 9.90047L10.0535 10.1833C10.249 9.98788 10.249 9.67102 10.0535 9.47558L9.7707 9.75843ZM8.28348 8.27121L9.7707 9.75843L10.0535 9.47558L8.56632 7.98837L8.28348 8.27121ZM9.77051 6.50134L8.28348 7.98837L8.56632 8.27121L10.0534 6.78418L9.77051 6.50134ZM9.77051 6.3593C9.80973 6.39852 9.80973 6.46212 9.77051 6.50134L10.0534 6.78418C10.2488 6.58875 10.2488 6.27189 10.0534 6.07646L9.77051 6.3593ZM9.62847 6.3593C9.66769 6.32008 9.73128 6.32008 9.77051 6.3593L10.0534 6.07646C9.85792 5.88102 9.54106 5.88102 9.34563 6.07646L9.62847 6.3593ZM8.14144 7.84633L9.62847 6.3593L9.34563 6.07646L7.8586 7.56348L8.14144 7.84633ZM6.37165 6.35938L7.8586 7.84633L8.14144 7.56348L6.65449 6.07653L6.37165 6.35938ZM6.22961 6.35938C6.26883 6.32015 6.33242 6.32015 6.37165 6.35938L6.65449 6.07653C6.45906 5.8811 6.1422 5.8811 5.94676 6.07653L6.22961 6.35938ZM6.22961 6.50141C6.19038 6.46219 6.19038 6.3986 6.22961 6.35938L5.94676 6.07653C5.75133 6.27197 5.75133 6.58882 5.94676 6.78426L6.22961 6.50141ZM7.71656 7.98837L6.22961 6.50141L5.94676 6.78426L7.43372 8.27121L7.71656 7.98837ZM6.22942 9.75835L7.71656 8.27121L7.43372 7.98837L5.94657 9.47551L6.22942 9.75835Z"
        fill="currentColor"
      />
    </>
  ),
});

export const LinearIcon = createCustomIcon({
  name: "Linear",
  category: "Workspace / Integrations",
  iconColors: {
    [ThemeType.LIGHT]: "#222326",
    [ThemeType.DARK]: "#FFFFFF",
  },
  path: (
    <>
      <path
        d="M1.17156 9.61319C1.14041 9.4804 1.2986 9.39676 1.39505 9.49321L6.50679 14.6049C6.60323 14.7014 6.5196 14.8596 6.38681 14.8284C3.80721 14.2233 1.77669 12.1928 1.17156 9.61319ZM1.00026 7.56447C0.997795 7.60413 1.01271 7.64286 1.0408 7.67096L8.32904 14.9592C8.35714 14.9873 8.39586 15.0022 8.43553 14.9997C8.76721 14.9791 9.09266 14.9353 9.41026 14.8701C9.51729 14.8481 9.55448 14.7166 9.47721 14.6394L1.36063 6.52279C1.28337 6.44552 1.15187 6.48271 1.12989 6.58974C1.06466 6.90734 1.02092 7.23278 1.00026 7.56447ZM1.58953 5.15875C1.56622 5.21109 1.57809 5.27224 1.6186 5.31275L10.6872 14.3814C10.7278 14.4219 10.7889 14.4338 10.8412 14.4105C11.0913 14.2991 11.3336 14.1735 11.5672 14.0347C11.6445 13.9888 11.6564 13.8826 11.5929 13.819L2.18099 4.40714C2.11742 4.34356 2.01121 4.35549 1.96529 4.43278C1.8265 4.66636 1.70091 4.9087 1.58953 5.15875ZM2.77222 3.53036C2.7204 3.47854 2.7172 3.39544 2.76602 3.34079C4.04913 1.9043 5.9156 1 7.99327 1C11.863 1 15 4.13702 15 8.00673C15 10.0844 14.0957 11.9509 12.6592 13.234C12.6046 13.2828 12.5215 13.2796 12.4696 13.2278L2.77222 3.53036Z"
        fill="currentColor"
      />
    </>
  ),
});

export const NotionIcon = createCustomIcon({
  name: "Notion",
  category: "Workspace / Integrations",
  path: (id) => (
    <>
      <g clipPath={`url(#clip0_${id})`}>
        <g clipPath={`url(#clip1_${id})`}>
          <mask
            height="16"
            id={`mask0_${id}`}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: "luminance",
            }}
            width="16"
            x="0"
            y="0"
          >
            <path
              d="M15.25 0.25V15.375H0.75V0.25H15.25Z"
              fill="white"
              stroke="white"
              strokeWidth="0.5"
            />
          </mask>
          <g mask={`url(#mask0_${id})`}>
            <path
              d="M9.95117 0.285156C10.4468 0.242644 10.7951 0.229901 11.1035 0.299805C11.4193 0.37139 11.6718 0.523577 11.9893 0.753906H11.9902L14.5732 2.57031L14.5781 2.57324C14.7759 2.71808 14.9509 2.83941 15.0635 2.96973C15.1996 3.12751 15.248 3.29619 15.248 3.51172V13.4697C15.248 13.8051 15.1884 14.1281 14.9727 14.373C14.7549 14.6202 14.423 14.739 13.9941 14.7695H13.9912L4.59277 15.3369H4.58984C4.28318 15.3515 4.02188 15.3398 3.78906 15.2549C3.54774 15.1668 3.36329 15.0104 3.18848 14.7881L3.18652 14.7861L1.28418 12.3174L1.28223 12.3154C0.924075 11.8381 0.750093 11.4459 0.75 10.9736V2.12207C0.75 1.83359 0.813873 1.5378 0.998047 1.30176C1.18744 1.05919 1.47752 0.912869 1.8584 0.879883H1.86133L9.95117 0.285156Z"
              fill="white"
              stroke="white"
              strokeWidth="0.5"
            />
            <path
              d="M9.95117 0.285156C10.4468 0.242644 10.7951 0.229901 11.1035 0.299805C11.4193 0.37139 11.6718 0.523577 11.9893 0.753906H11.9902L14.5732 2.57031L14.5781 2.57324C14.6 2.58929 14.6211 2.6051 14.6416 2.62012C14.8181 2.74899 14.9775 2.86247 15.082 2.99219C15.2055 3.14548 15.248 3.30951 15.248 3.51172V13.4697C15.248 13.8051 15.1884 14.1281 14.9727 14.373C14.7549 14.6202 14.423 14.739 13.9941 14.7695H13.9912L4.59277 15.3369H4.58984C4.28318 15.3515 4.02188 15.3398 3.78906 15.2549C3.54774 15.1668 3.36329 15.0104 3.18848 14.7881L3.18652 14.7861L1.28418 12.3174L1.28223 12.3154C0.924075 11.8381 0.750093 11.4459 0.75 10.9736V2.12207C0.75 1.83359 0.813873 1.5378 0.998047 1.30176C1.18744 1.05919 1.47752 0.912869 1.8584 0.879883H1.86133L9.95117 0.285156ZM13.6006 4.07324L13.5928 4.07422L4.37012 4.61133L4.37109 4.6123C4.23726 4.62358 4.20442 4.65749 4.19336 4.67188C4.17401 4.69718 4.14651 4.76256 4.14648 4.93066V13.3848C4.14648 13.575 4.19377 13.6396 4.22949 13.668C4.27686 13.7055 4.38335 13.7444 4.62012 13.7314L13.4502 13.2207H13.4512C13.6529 13.2096 13.7052 13.1488 13.7275 13.1123C13.7652 13.0503 13.7832 12.9453 13.7832 12.7607V4.36328C13.7832 4.2028 13.7503 4.12975 13.7285 4.10254C13.7195 4.09139 13.697 4.0645 13.6006 4.07324ZM10.335 1.57715H10.3311L2.6543 2.13672L3.56934 2.8623L3.57129 2.86426C3.77444 3.02929 3.88822 3.08527 4.02246 3.10938C4.17882 3.13744 4.37741 3.12642 4.77441 3.09961C4.80638 3.09745 4.83984 3.09505 4.87402 3.09277H4.875L12.4385 2.6377L11.416 1.89941L11.4092 1.89453C11.2875 1.80009 11.1622 1.71158 10.999 1.65039C10.8378 1.58994 10.627 1.55171 10.335 1.57715ZM8.37695 12.0693C8.37659 12.0771 8.37517 12.0871 8.37402 12.0986C8.37171 12.1218 8.36764 12.1529 8.35938 12.1885C8.34288 12.2594 8.30967 12.3546 8.24316 12.4502C8.1004 12.6551 7.84002 12.8124 7.41699 12.8125V12.8115L5.47266 12.9258L5.30762 12.9346L5.23438 12.7881C5.19642 12.7123 5.18586 12.6298 5.18652 12.5625C5.18724 12.4916 5.2009 12.4169 5.22559 12.3457C5.27292 12.2092 5.38215 12.0403 5.58789 11.9814H5.58984L5.91797 11.8896V6.72168L5.4375 6.68359L5.25391 6.66895L5.21387 6.48828C5.17181 6.29882 5.20294 6.0766 5.31543 5.89258C5.43357 5.69935 5.63971 5.5526 5.92285 5.53223H5.92383L8.02539 5.39062L8.1709 5.38086L8.25098 5.50293L10.6885 9.22656V6.37305L10.1709 6.31445L9.9873 6.29297L9.9541 6.11035C9.86609 5.62507 10.2311 5.28953 10.6289 5.25L10.6396 5.24902L12.5986 5.13477L12.8115 5.12207L12.8574 5.33008C12.8919 5.48565 12.8987 5.66888 12.835 5.83105C12.7652 6.00815 12.6156 6.14267 12.3955 6.1709L12.1816 6.21289V12.3994L12.0508 12.4707C11.6663 12.6774 11.2822 12.8124 10.9385 12.8125C10.6828 12.8125 10.4836 12.7716 10.2988 12.6436C10.1342 12.5294 9.99515 12.3527 9.83398 12.1514L9.82617 12.1406L9.81836 12.1289L7.49609 8.48242V11.6523L8.18164 11.8076L8.37695 11.8516V12.0693Z"
              fill="black"
              stroke="white"
              strokeWidth="0.5"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id={`clip0_${id}`}>
          <rect fill="white" height="16" width="16" />
        </clipPath>
        <clipPath id={`clip1_${id}`}>
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </>
  ),
});

export const SlackIcon = createCustomIcon({
  name: "Slack",
  category: "Workspace / Integrations",
  path: (
    <>
      <path
        d="M4.521 9.583c0 .694-.567 1.26-1.26 1.26A1.263 1.263 0 0 1 2 9.583c0-.694.567-1.26 1.26-1.26h1.261v1.26Zm.635 0c0-.694.567-1.26 1.26-1.26.695 0 1.261.566 1.261 1.26v3.156c0 .694-.566 1.261-1.26 1.261-.694 0-1.26-.567-1.26-1.26V9.582Z"
        fill="#E01E5A"
      />
      <path
        d="M6.417 4.521c-.694 0-1.26-.567-1.26-1.26 0-.694.566-1.261 1.26-1.261.694 0 1.26.567 1.26 1.26v1.261h-1.26Zm0 .635c.694 0 1.26.567 1.26 1.26 0 .695-.566 1.261-1.26 1.261H3.26A1.262 1.262 0 0 1 2 6.418c0-.694.567-1.26 1.26-1.26h3.157Z"
        fill="#36C5F0"
      />
      <path
        d="M11.479 6.417c0-.694.567-1.26 1.26-1.26.694 0 1.26.566 1.26 1.26 0 .694-.566 1.26-1.26 1.26h-1.26v-1.26Zm-.635 0c0 .694-.567 1.26-1.261 1.26s-1.26-.566-1.26-1.26V3.26c0-.694.566-1.261 1.26-1.261.694 0 1.26.567 1.26 1.26v3.157Z"
        fill="#2EB67D"
      />
      <path
        d="M9.583 11.479c.694 0 1.26.567 1.26 1.26 0 .694-.566 1.261-1.26 1.261-.694 0-1.26-.567-1.26-1.26v-1.261h1.26Zm0-.635c-.694 0-1.26-.567-1.26-1.26 0-.695.566-1.262 1.26-1.262h3.156c.694 0 1.261.567 1.261 1.261s-.567 1.26-1.26 1.26H9.582Z"
        fill="#ECB22E"
      />
    </>
  ),
});

export const ExplodeIcon = createCustomIcon({
  name: "Explode cell contents",
  category: "Magic",
  path: (
    <path
      clipRule="evenodd"
      d="M7.66459 0.60869C7.87574 0.503117 8.12427 0.503117 8.33541 0.60869L13.7764 3.32918C14.3292 3.60557 14.3292 4.39443 13.7764 4.67082L8.33541 7.39131C8.12427 7.49689 7.87574 7.49689 7.66459 7.39131L2.22361 4.67082C1.67083 4.39443 1.67082 3.60558 2.22361 3.32918L7.66459 0.60869ZM8 1.55902L3.11804 4L8 6.44098L12.882 4L8 1.55902ZM14 7.80901L10 9.80901V14.6169L14 12.2169V7.80901ZM13.9146 6.73368C14.4133 6.48434 15 6.84696 15 7.4045V12.3584C15 12.6219 14.8618 12.866 14.6359 13.0016L10.1359 15.7016C9.63598 16.0015 9 15.6414 9 15.0584V9.6545C9 9.37042 9.1605 9.11073 9.41459 8.98368L13.9146 6.73368ZM6 9.80901L2 7.80901V12.2169L6 14.6169V9.80901ZM1 7.4045C1 6.84696 1.58674 6.48434 2.08541 6.73368L6.58541 8.98368C6.8395 9.11073 7 9.37042 7 9.6545V15.0584C7 15.6414 6.36402 16.0015 5.86413 15.7016L1.36413 13.0016C1.13822 12.866 1 12.6219 1 12.3584V7.4045Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const WordWrapIcon = createCustomIcon({
  name: "Word wrap",
  category: "General / Formatting",
  path: (
    <path
      clipRule="evenodd"
      d="M11.53 4H2.5a.5.5 0 0 1 0-1h9.01a1.92 1.92 0 0 1 .37.02c.23.04.54.1.86.28.32.17.64.44.88.85s.38.94.38 1.6c0 .66-.14 1.19-.38 1.6-.24.41-.56.68-.88.85a2.58 2.58 0 0 1-1.23.3h-2.8l1.14 1.15a.5.5 0 1 1-.7.7L6.79 8l2.36-2.35a.5.5 0 1 1 .7.7L8.71 7.5h2.86a1.55 1.55 0 0 0 .7-.18c.17-.1.35-.24.49-.47.13-.23.24-.58.24-1.1 0-.52-.1-.87-.24-1.1a1.22 1.22 0 0 0-.5-.47 1.58 1.58 0 0 0-.73-.18ZM2.5 7.5a.5.5 0 0 0 0 1h3.37v-1H2.5Zm0 4.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1h-11Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const VimIcon = createCustomIcon({
  name: "vim",
  category: "Project / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M1.63 3.646a.7.7 0 0 1 0-.99l.454-.453a.7.7 0 0 1 .495-.205h3.58a.7.7 0 0 1 .495.205l.17.17a.7.7 0 0 1 0 .99l-.736.735v2.976L9.27 3.891l-.4-.399a.7.7 0 0 1 0-.99l.3-.3a.7.7 0 0 1 .495-.204h3.67a.7.7 0 0 1 .495.205l.454.453a.7.7 0 0 1 0 .99L3.912 14.043a.7.7 0 0 1-.745.16l-.72-.275a.7.7 0 0 1-.451-.655V4.013l-.366-.366Zm.92-.495.24.242a.7.7 0 0 1 .206.495v9.179l.346.132L13.366 3.152l-.155-.154h-3.42l.4.398a.7.7 0 0 1 0 .99L6.282 8.293a.7.7 0 0 1-1.195-.495V3.974a.7.7 0 0 1 .205-.495l.481-.481H2.703l-.154.153Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ExploreIcon = createCustomIcon({
  name: "Explore",
  category: "Workspace / Objects",
  tags: ["compass"],
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M11.354 4.896a.5.5 0 0 1 .093.578l-2 4a.5.5 0 0 1-.223.223l-4 2a.5.5 0 0 1-.671-.67l2-4a.5.5 0 0 1 .223-.224l4-2a.5.5 0 0 1 .578.093ZM7.373 7.623l-1.255 2.509 2.51-1.255 1.254-2.509-2.51 1.255Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M3.572 3.822c-2.564 2.563-2.622 6.613-.19 9.045 2.433 2.433 6.483 2.374 9.046-.189 2.564-2.563 2.622-6.613.19-9.046-2.434-2.432-6.483-2.374-9.046.19Zm-.897 9.753c-2.849-2.85-2.738-7.533.19-10.46 2.927-2.928 7.61-3.039 10.46-.19 2.849 2.85 2.738 7.533-.19 10.46-2.927 2.928-7.61 3.039-10.46.19Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const MapStyleIcon = createCustomIcon({
  name: "Map style",
  category: "Cells / Actions: Map",
  path: (
    <path
      clipRule="evenodd"
      d="M5.5 2A2.5 2.5 0 0 0 3 4.5v4A2.5 2.5 0 0 0 5.5 11H6v1.5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5V11h.5A2.5 2.5 0 0 0 13 8.5v-4A2.5 2.5 0 0 0 10.5 2h-5ZM4 4.5C4 3.67 4.67 3 5.5 3H6v2.5a.5.5 0 0 0 1 0V3h1v1.5a.5.5 0 0 0 1 0V3h1.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5h-1A1.5 1.5 0 0 1 4 8.5V8h8V7H4V4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PresentationModeIcon = createCustomIcon({
  name: "Presentation mode",
  category: "Project / Navigation",
  path: (
    <path
      clipRule="evenodd"
      d="M3 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4.5v2H5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H8.5v-2H13a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3Zm10 7H3V4h10v6ZM9.6 7.72c.3-.17.4-.48.4-.72s-.1-.55-.4-.72L7.66 5.1a.73.73 0 0 0-.82.04.84.84 0 0 0-.33.68v2.34c0 .27.12.52.33.68.22.17.54.21.82.04L9.6 7.72ZM7.5 6.18 8.87 7l-1.37.82V6.18Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const TVModeIcon = createCustomIcon({
  name: "tv-mode",
  category: "General / Misc",
  path: (
    <path
      clipRule="evenodd"
      d="M4.715 1.589a.5.5 0 0 1 .696.126L7.5 4.733l2.089-3.018a.5.5 0 0 1 .822.57L8.454 5.112h3.76c.332 0 .655.123.898.352.245.23.388.548.388.887v5.91c0 .339-.143.657-.388.887a1.312 1.312 0 0 1-.898.352H2.786c-.332 0-.655-.123-.898-.352a1.217 1.217 0 0 1-.388-.887v-5.91c0-.34.143-.657.388-.887.243-.229.566-.352.898-.352h3.76L4.589 2.285a.5.5 0 0 1 .126-.696Zm-1.93 4.523a.312.312 0 0 0-.212.08.217.217 0 0 0-.073.159v5.91c0 .053.022.11.073.158.051.049.127.081.213.081h9.428a.312.312 0 0 0 .213-.08.218.218 0 0 0 .073-.159v-5.91a.217.217 0 0 0-.073-.158.312.312 0 0 0-.213-.081H2.786Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const BookmarkIcon = createCustomIcon({
  name: "Bookmark",
  category: "General / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M3 3.5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v10a.5.5 0 0 1-.777.416L8 11.101l-4.223 2.815A.5.5 0 0 1 3 13.5v-10Zm9 0H4v9.066l3.723-2.482a.5.5 0 0 1 .554 0L12 12.566V3.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const IncludeIcon = createCustomIcon({
  name: "Include",
  category: "Cells / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 5H2a1 1 0 0 0-1 1v1.5h1V6h1V5Zm7 8v1H8.5v1H10a1 1 0 0 0 1-1v-1h-1Zm-9 1v-1.5h1V14h1.5v1H2a1 1 0 0 1-1-1Zm.5-2.5H1v-3h1v3h-.5Zm6 3v.5h-3v-1h3v.5ZM14 2H5v9h9V2ZM5 1a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10 7v3H9V7H6V6h3V3h1v3h3v1h-3Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ExcludeIcon = createCustomIcon({
  name: "Exclude",
  category: "Cells / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 5H2C1.44772 5 1 5.44772 1 6V14C1 14.5523 1.44772 15 2 15H10C10.5523 15 11 14.5523 11 14V13H10V14H2V6H3V5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4 9.3125V11C4 11.5523 4.44771 12 5 12H6.6875V11H5L5 9.3125H4ZM4 8.1875H5V4.8125H4V8.1875ZM4 3.6875H5V2L6.6875 2V1H5C4.44772 1 4 1.44771 4 2V3.6875ZM7.8125 1V2H11.1875V1H7.8125ZM12.3125 1V2H14V3.6875H15V2C15 1.44772 14.5523 1 14 1H12.3125ZM15 4.8125H14V8.1875H15V4.8125ZM15 9.3125H14V11H12.3125V12H14C14.5523 12 15 11.5523 15 11V9.3125ZM11.1875 12V11H7.8125V12H11.1875Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M12.5 7L6.5 7L6.5 6L12.5 6L12.5 7Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ExchangeIcon = createCustomIcon({
  name: "Exchange",
  category: "General / Misc",
  path: (
    <path
      d="M4.5 6.00033C5.60457 6.00033 6.5 6.89576 6.5 8.00033C6.5 8.93443 5.85886 9.71597 4.99316 9.93588C4.99591 9.95709 5 9.97837 5 10.0003V11.0003C5 11.2765 5.22386 11.5003 5.5 11.5003H9.29297L8.14648 10.3538C7.95122 10.1586 7.95122 9.84207 8.14648 9.64681C8.34175 9.45155 8.65825 9.45155 8.85352 9.64681L10.8535 11.6468C11.0488 11.8421 11.0488 12.1586 10.8535 12.3538L8.85352 14.3538C8.65825 14.5491 8.34175 14.5491 8.14648 14.3538C7.95122 14.1586 7.95122 13.8421 8.14648 13.6468L9.29297 12.5003H5.5C4.67157 12.5003 4 11.8288 4 11.0003V10.0003C4 9.97841 4.00313 9.95705 4.00586 9.93588C3.14063 9.71565 2.5 8.9341 2.5 8.00033C2.5 6.89576 3.39543 6.00033 4.5 6.00033ZM8.14648 2.64681C8.34175 2.45155 8.65825 2.45155 8.85352 2.64681C9.04878 2.84207 9.04878 3.15858 8.85352 3.35384L7.70703 4.50033H11.5C12.3284 4.50033 13 5.1719 13 6.00033V6.56576C13.8623 6.78798 14.5 7.56862 14.5 8.50033C14.5 9.6049 13.6046 10.5003 12.5 10.5003C11.3954 10.5003 10.5 9.6049 10.5 8.50033C10.5 7.56862 11.1377 6.78798 12 6.56576V6.00033C12 5.72419 11.7761 5.50033 11.5 5.50033H7.70703L8.85352 6.64681C9.04878 6.84207 9.04878 7.15858 8.85352 7.35384C8.65825 7.54911 8.34175 7.54911 8.14648 7.35384L6.14648 5.35384C5.95122 5.15858 5.95122 4.84208 6.14648 4.64681L8.14648 2.64681ZM12.5 7.50033C11.9477 7.50033 11.5 7.94804 11.5 8.50033C11.5 9.05261 11.9477 9.50033 12.5 9.50033C13.0523 9.50033 13.5 9.05261 13.5 8.50033C13.5 7.94804 13.0523 7.50033 12.5 7.50033ZM4.5 7.00033C3.94772 7.00033 3.5 7.44804 3.5 8.00033C3.5 8.55261 3.94772 9.00033 4.5 9.00033C5.05228 9.00033 5.5 8.55261 5.5 8.00033C5.5 7.44804 5.05228 7.00033 4.5 7.00033Z"
      fill="currentColor"
    />
  ),
});

export const NotificationUnreadIcon = createCustomIcon({
  name: "Notification: unread",
  category: "Workspace / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M7.926 3.605a5.529 5.529 0 0 1 2.148 0 .5.5 0 0 0 .194-.981 6.53 6.53 0 0 0-2.536 0 .5.5 0 0 0 .194.98Zm-1.982.821a.5.5 0 0 0-.556-.83 6.533 6.533 0 0 0-1.793 1.792.5.5 0 0 0 .831.556c.402-.6.918-1.116 1.518-1.518Zm6.668-.83a.5.5 0 0 0-.556.83c.6.402 1.116.918 1.518 1.518a.5.5 0 0 0 .83-.556 6.533 6.533 0 0 0-1.792-1.793Zm-9.007 4.33a.5.5 0 0 0-.981-.194 6.53 6.53 0 0 0 0 2.536.5.5 0 1 0 .98-.194 5.528 5.528 0 0 1 0-2.148Zm11.771-.194a.5.5 0 1 0-.98.194 5.532 5.532 0 0 1 0 2.148.5.5 0 0 0 .98.194 6.53 6.53 0 0 0 0-2.536Zm-10.95 4.324a.5.5 0 0 0-.83.556 6.533 6.533 0 0 0 1.792 1.793.5.5 0 0 0 .556-.831 5.533 5.533 0 0 1-1.518-1.518Zm9.979.556a.5.5 0 0 0-.831-.556 5.533 5.533 0 0 1-1.518 1.518.5.5 0 0 0 .556.83 6.533 6.533 0 0 0 1.793-1.792Zm-6.479 1.783a.5.5 0 0 0-.194.981 6.53 6.53 0 0 0 2.536 0 .5.5 0 1 0-.194-.98 5.531 5.531 0 0 1-2.148 0Zm3.99-7.118a.5.5 0 1 0-.832-.554l-2.62 3.93L6.89 8.689a.5.5 0 1 0-.78.624l2 2.5a.5.5 0 0 0 .806-.035l3-4.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const NotificationReadIcon = createCustomIcon({
  name: "Notification: read",
  category: "Workspace / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Zm8.416-1.723a.5.5 0 1 0-.832-.554l-2.62 3.93L5.89 7.689a.5.5 0 1 0-.78.624l2 2.5a.5.5 0 0 0 .806-.035l3-4.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const FormulaIcon = createCustomIcon({
  name: "Formula",
  category: "General / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M8.864 3.64a.523.523 0 0 1 .172-.137c.02.013.08.058.166.193.095.152.174.343.231.51a3.635 3.635 0 0 1 .077.253l.003.012v.002a.5.5 0 1 0 .974-.23l-.001-.003-.002-.007-.005-.022a3.962 3.962 0 0 0-.1-.33 3.543 3.543 0 0 0-.33-.717c-.143-.228-.387-.532-.765-.632-.434-.115-.83.085-1.148.422-.187.198-.34.486-.47.784-.134.31-.265.68-.393 1.083-.115.364-.23.763-.344 1.179H5v1h1.66l-.144.548c-.25.954-.496 1.877-.74 2.604a7.43 7.43 0 0 1-.35.89 1.94 1.94 0 0 1-.147.256c-.042.06-.066.08-.068.08-.178.127-.272.125-.301.12-.033-.004-.087-.024-.158-.105a1.067 1.067 0 0 1-.186-.342 1.089 1.089 0 0 1-.066-.325.5.5 0 0 0-1 0c0 .369.158.932.498 1.323.18.206.438.396.78.441.345.046.689-.067 1.01-.295.236-.166.406-.449.535-.711.14-.283.273-.632.401-1.014.256-.765.51-1.721.76-2.668l.044-.169L7.695 7H10V6H7.967c.087-.309.173-.604.26-.877.122-.388.241-.722.356-.986.12-.275.218-.43.28-.497ZM10 4.358l.487-.115-.487.115ZM9.053 3.5s-.004.002-.012.001c.008-.002.012-.002.012-.001Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M9.31 9.999a3.968 3.968 0 0 1-.193.006.5.5 0 0 1 0-1c.04 0 .085-.002.144-.005h.014c.052-.003.116-.007.179-.007.133-.002.318.003.502.064.473.157.759.562.932.895.015.027.029.055.042.083l1.194-1.364.752.658-1.558 1.78.057.202.008.03c.038.137.074.267.115.393.075.236.156.428.256.576.02 0 .048 0 .089-.002l.032-.002c.05-.002.12-.006.186-.006a.5.5 0 1 1 0 1c-.037 0-.07.002-.117.004l-.052.003a1.818 1.818 0 0 1-.253-.002.893.893 0 0 1-.665-.366c-.207-.282-.335-.608-.428-.9a4.508 4.508 0 0 1-.011-.034L9.376 13.33l-.752-.658 1.571-1.796a3.484 3.484 0 0 0-.193-.46c-.138-.265-.267-.377-.362-.41a.583.583 0 0 0-.17-.013l-.15.006h-.01Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ExportIcon = createCustomIcon({
  name: "Export",
  category: "Project / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M2 4.5C2 3.67157 2.67157 3 3.5 3H6.5C6.77614 3 7 3.22386 7 3.5C7 3.77614 6.77614 4 6.5 4H3.5C3.22386 4 3 4.22386 3 4.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V9.5C12 9.22386 12.2239 9 12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V4.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.5 2C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H12.2929L5.64645 9.64645C5.45118 9.84171 5.45118 10.1583 5.64645 10.3536C5.84171 10.5488 6.15829 10.5488 6.35355 10.3536L13 3.70711V6.5C13 6.77614 13.2239 7 13.5 7C13.7761 7 14 6.77614 14 6.5V2.5C14 2.22386 13.7761 2 13.5 2H9.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ArchiveIcon = createCustomIcon({
  name: "Archive",
  category: "Workspace / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V5C14 5.37354 13.7952 5.69924 13.4917 5.87094C13.4972 5.91319 13.5 5.95627 13.5 6V13C13.5 13.5523 13.0523 14 12.5 14H3.5C2.94772 14 2.5 13.5523 2.5 13V6C2.5 5.95627 2.50281 5.91319 2.50825 5.87094C2.20481 5.69924 2 5.37354 2 5V3ZM3.5 6H12.5V13H3.5V6ZM13 5H12.5H3.5H3V3H13V5ZM6.5 7.5C6.22386 7.5 6 7.72386 6 8C6 8.27614 6.22386 8.5 6.5 8.5H9.5C9.77614 8.5 10 8.27614 10 8C10 7.72386 9.77614 7.5 9.5 7.5H6.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const UnarchiveIcon = createCustomIcon({
  name: "Unarchive",
  category: "Workspace / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M10.3536 3.85355C10.1583 4.04882 9.84171 4.04882 9.64645 3.85355L9 3.20711V5C9 5.27614 8.77614 5.5 8.5 5.5C8.22386 5.5 8 5.27614 8 5V3.20711L7.35355 3.85355C7.15829 4.04882 6.84171 4.04882 6.64645 3.85355C6.45118 3.65829 6.45118 3.34171 6.64645 3.14645L8.14645 1.64645C8.34171 1.45118 8.65829 1.45118 8.85356 1.64645L10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355ZM4.83852 4.5H5.5V3.5H4.58463C4.32906 3.5 4.09925 3.65559 4.00433 3.89288L3.0447 6.29195C3.01517 6.36578 3 6.44456 3 6.52407V13.375C3 13.7202 3.27982 14 3.625 14H13.375C13.7202 14 14 13.7202 14 13.375V6.52407C14 6.44456 13.9848 6.36578 13.9553 6.29195L12.9957 3.89288C12.9008 3.65559 12.6709 3.5 12.4154 3.5H11.5V4.5H12.1615L12.9615 6.5H4.03852L4.83852 4.5ZM4 13L4 7.5H13V13H4ZM7 8.5C6.72386 8.5 6.5 8.72386 6.5 9C6.5 9.27614 6.72386 9.5 7 9.5H10C10.2761 9.5 10.5 9.27614 10.5 9C10.5 8.72386 10.2761 8.5 10 8.5H7Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const ColumnsIcon = createCustomIcon({
  name: "Columns",
  category: "Data",
  path: (
    <path
      clipRule="evenodd"
      d="M3 14C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44771 2 3 2H5.5H6.5H9.5H10.5H13C13.5523 2 14 2.44772 14 3L14 13C14 13.5523 13.5523 14 13 14L10.5 14H9.5H6.5H5.5H3ZM10.5 13H13L13 3L10.5 3V13ZM9.5 3V13H6.5V3L9.5 3ZM3 3L5.5 3V13H3L3 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PublishedProjectIcon = createCustomIcon({
  name: "Published project",
  category: "Workspace / Objects",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M13 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10ZM3 4v9h10V4H3Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M11.127 6.167a.496.496 0 0 1 .87.335L12 6.5V12H4v-1.5l.002-.003c0-.112.037-.225.114-.317l2-2.4a.5.5 0 0 1 .6-.13L9 9l2.127-2.833Z"
        fill="currentColor"
        opacity="0.3"
      />
      <path
        d="M11.127 6.167a.5.5 0 0 1 .746.666l-2.25 2.742a.685.685 0 0 1-.84.176l-2.15-1.032-1.75 2.101a.5.5 0 0 1-.767-.64l2-2.4a.497.497 0 0 1 .6-.13l2.311 1.123 2.1-2.606Z"
        fill="currentColor"
      />
    </>
  ),
});

export const DataframeIcon = createCustomIcon({
  name: "Dataframe",
  category: "Project / Object",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3.14645 2.14645C3.24021 2.05268 3.36739 2 3.5 2H11V5H3V2.5C3 2.36739 3.05268 2.24021 3.14645 2.14645ZM12 5V2H14.5C14.6326 2 14.7598 2.05268 14.8536 2.14645C14.9473 2.24022 15 2.36739 15 2.5V5H12ZM12 6H15V13.5C15 13.6326 14.9473 13.7598 14.8536 13.8536C14.7598 13.9473 14.6326 14 14.5 14H12V6ZM3 6H11V14V15H14.5C14.8978 15 15.2794 14.842 15.5607 14.5607C15.842 14.2794 16 13.8978 16 13.5V2.5C16 2.10217 15.842 1.72064 15.5607 1.43934C15.2794 1.15804 14.8978 1 14.5 1H3.5C3.10218 1 2.72064 1.15804 2.43934 1.43934C2.15804 1.72064 2 2.10218 2 2.5V6H3Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M3 6H2V12H3V12.0035H7.29289L5.14645 14.15L5.85355 14.8571L9.20711 11.5035L5.85355 8.14999L5.14645 8.8571L7.29289 11.0035H3V6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const MergeIcon = createCustomIcon({
  name: "Merge",
  category: "General / Git",
  tags: ["reviews"],
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M1 4V3H4.99998C5.72287 3 6.22888 3.419 6.58926 3.90551C6.93478 4.37197 7.20343 4.97654 7.44357 5.51698L7.45688 5.54693C7.71335 6.12398 7.94118 6.63061 8.21426 6.99926C8.47888 7.3565 8.72287 7.5 8.99998 7.5H13.7929L11.1465 4.85359L11.8536 4.14648L15.7071 8.00004L11.8536 11.8536L11.1465 11.1465L13.793 8.5H8.99998C8.72287 8.5 8.47888 8.6435 8.21426 9.00074C7.94118 9.36939 7.71335 9.87602 7.45688 10.4531L7.44357 10.483C7.20343 11.0235 6.93478 11.628 6.58926 12.0945C6.22888 12.581 5.72287 13 4.99998 13H1V12H4.99998C5.27709 12 5.52108 11.8565 5.7857 11.4993C6.05878 11.1306 6.28661 10.624 6.54307 10.0469L6.55638 10.017C6.79653 9.47654 7.06517 8.87197 7.4107 8.40551C7.51747 8.26137 7.63703 8.12315 7.77122 8C7.63703 7.87685 7.51747 7.73863 7.4107 7.59449C7.06518 7.12803 6.79653 6.52346 6.55639 5.98303L6.54307 5.95307C6.28661 5.37602 6.05878 4.86939 5.7857 4.50074C5.52108 4.1435 5.27709 4 4.99998 4H1Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const CardGridIcon = createCustomIcon({
  name: "Card grid",
  category: "Workspace / Organization",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M2 6.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4ZM6 6H3V3h3v3Zm3 .5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4Zm4-.5h-3V3h3v3ZM2.5 14a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4Zm.5-1h3v-3H3v3Zm6 .5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4Zm4-.5h-3v-3h3v3Z"
        fillRule="evenodd"
      />
    </>
  ),
});

export const VersionIcon = createCustomIcon({
  name: "Version",
  category: "Project / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M13 2H9C8.44772 2 8 2.44772 8 3V13C8 13.5523 8.44772 14 9 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2ZM9 1C7.89543 1 7 1.89543 7 3V13C7 14.1046 7.89543 15 9 15H13C14.1046 15 15 14.1046 15 13V3C15 1.89543 14.1046 1 13 1H9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M6 2C4.89543 2 4 2.89543 4 4V12C4 13.1046 4.89543 14 6 14V13C5.44772 13 5 12.5523 5 12V4C5 3.44772 5.44772 3 6 3V2Z"
        fill="currentColor"
      />
      <path
        d="M3 3C1.89543 3 1 3.89543 1 5V11C1 12.1046 1.89543 13 3 13V12C2.44772 12 2 11.5523 2 11V5C2 4.44772 2.44772 4 3 4V3Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ReviewInProgressIcon = createCustomIcon({
  name: "Review in progress",
  category: "Project / Reviews",
  tags: ["reviews"],
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M11.15 2.314a6.5 6.5 0 0 0-4.244-.721.5.5 0 0 0 .169.985 5.5 5.5 0 0 1 4.081 9.926.5.5 0 0 0 .574.82 6.5 6.5 0 0 0-.58-11.01Zm-6.068.418a.5.5 0 0 1-.138.694c-.6.402-1.116.918-1.518 1.518a.5.5 0 1 1-.83-.556 6.533 6.533 0 0 1 1.792-1.793.5.5 0 0 1 .694.137ZM2.212 6.34a.5.5 0 0 1 .393.587 5.529 5.529 0 0 0 0 2.148.5.5 0 0 1-.981.194 6.53 6.53 0 0 1 0-2.536.5.5 0 0 1 .587-.393Zm.52 4.58a.5.5 0 0 1 .694.136c.402.6.918 1.117 1.518 1.519a.5.5 0 0 1-.556.83 6.533 6.533 0 0 1-1.793-1.792.5.5 0 0 1 .137-.694Zm3.607 2.87a.5.5 0 0 1 .587-.394 5.532 5.532 0 0 0 2.148 0 .5.5 0 0 1 .194.981 6.53 6.53 0 0 1-2.536 0 .5.5 0 0 1-.393-.587Zm4.438-8.205a.5.5 0 0 1 .139.693l-3 4.5a.5.5 0 0 1-.806.035l-2-2.5a.5.5 0 0 1 .78-.624l1.573 1.966 2.621-3.931a.5.5 0 0 1 .693-.139Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const SmallCircleIcon = createCustomIcon({
  name: "Small circle",
  category: "General / Misc",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const OpenStatusIcon = createCustomIcon({
  name: "Open status",
  category: "General / Status",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const DismissedIcon = createCustomIcon({
  name: "Dismissed",
  category: "General / Status",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM4.5 8a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const PopOutIcon = createCustomIcon({
  name: "Pop out",
  category: "General / Arrows",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M2 12.417c0 .452.216.863.56 1.15.342.284.79.433 1.24.433h8.4c.45 0 .898-.149 1.24-.433a1.5 1.5 0 0 0 .56-1.15V9h-1v3.417a.503.503 0 0 1-.2.382.944.944 0 0 1-.6.201H3.8a.944.944 0 0 1-.6-.201.503.503 0 0 1-.2-.382V3.583c0-.122.058-.262.2-.382A.944.944 0 0 1 3.8 3H7V2H3.8c-.45 0-.898.148-1.24.433A1.5 1.5 0 0 0 2 3.583v8.834Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14 2H9v1h3.293L7.646 7.646l.708.708L13 3.707V7h1V2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const SigmaIcon = createCustomIcon({
  name: "Sigma",
  category: "Cells / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M12 12a1 1 0 0 1-1 1H4v-1l4-4v-.058L4 4V3h7a1 1 0 0 1 1 1v.5a.5.5 0 0 1-.5.5H11V4H5.5L9 7.5v1L5.5 12H11v-1h.5a.5.5 0 0 1 .5.5v.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const TransferOwnerIcon = createCustomIcon({
  name: "Transfer owner",
  category: "Workspace / Users",
  path: (
    <path
      clipRule="evenodd"
      d="M4.5 5.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0ZM7 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.364 9a2.637 2.637 0 0 0-2.559 2h7.846a2.637 2.637 0 0 0-2.56-2H5.637Zm0-1A3.636 3.636 0 0 0 2 13.636c0 .201.163.364.364.364h9.272a.364.364 0 0 0 .364-.364A3.636 3.636 0 0 0 8.364 10H5.636Zm7.01.354a.5.5 0 0 1 0-.708L13.293 9H11a.5.5 0 0 1 0-1h2.293l-.646-.646a.5.5 0 1 1 .707-.708l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.707 0Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const MatchWholeWordIcon = createCustomIcon({
  name: "Match: Whole word",
  category: "Project / Search",
  path: (
    <path
      clipRule="evenodd"
      d="M9.5 2.5a.5.5 0 0 0-1 0v8a.5.5 0 0 0 .993.085c.398.237.9.415 1.507.415.685 0 1.265-.348 1.657-.897.386-.541.593-1.275.593-2.103 0-.828-.207-1.562-.593-2.103C12.265 5.348 11.685 5 11 5a2.75 2.75 0 0 0-1.5.461V2.5Zm0 4.234v2.581c.302.327.803.685 1.5.685.315 0 .61-.152.843-.478.239-.334.407-.85.407-1.522s-.168-1.188-.407-1.522C11.61 6.152 11.315 6 11 6c-.643 0-1.035.336-1.435.679l-.065.055ZM5.5 6c-.54 0-1.066.023-1.396.354a.5.5 0 0 1-.708-.708C4.045 4.998 4.98 5 5.456 5H5.5c.632 0 1.094.228 1.411.54.305.298.451.647.52.868.063.201.069.397.069.542v3.55a.5.5 0 0 1-.997.056C6.146 10.77 5.621 11 5 11c-.576 0-1.136-.143-1.562-.485-.442-.353-.688-.877-.688-1.515 0-.338.086-.64.256-.895a1.65 1.65 0 0 1 .645-.552c.48-.24 1.073-.303 1.599-.303a4.16 4.16 0 0 0 1.004-.11c.106-.027.181-.052.227-.07l.019-.007V6.95a.853.853 0 0 0-.024-.246c-.04-.13-.12-.31-.265-.45C6.08 6.123 5.87 6 5.5 6Zm1 2.11h-.004c-.288.072-.704.14-1.246.14-.474 0-.88.062-1.151.197a.65.65 0 0 0-.261.213.59.59 0 0 0-.088.34c0 .362.129.588.312.735.199.158.514.265.938.265.377 0 .725-.143.993-.304a2.622 2.622 0 0 0 .403-.299l.002-.002a.5.5 0 0 1 .102-.078V8.109ZM1.5 10a.5.5 0 0 1 .5.5V13h12v-2.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const OpacityIcon = createCustomIcon({
  name: "Opacity",
  category: "Project / Misc",
  path: (
    <>
      <path d="M8 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" fill="currentColor" />
      <path
        d="M14 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        fill="currentColor"
        opacity=".2"
      />
      <path
        d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        fill="currentColor"
        opacity=".5"
      />
    </>
  ),
});

export const ComboChartIcon = createCustomIcon({
  name: "Combo chart",
  category: "Cells / Types: Chart",
  path: (
    <path
      clipRule="evenodd"
      d="M2 1H1V15H15V14H2V1ZM14.94 1.581L10.285 8.098C10.2393 8.16183 10.1793 8.21402 10.1097 8.25034C10.0402 8.28666 9.96301 8.3061 9.88453 8.30707C9.80606 8.30804 9.72845 8.29053 9.658 8.25595C9.58755 8.22136 9.52623 8.17068 9.479 8.108L7.109 4.949L3.777 9.947L2.945 9.393L6.67 3.806C6.71441 3.73951 6.77412 3.68464 6.84413 3.64599C6.91413 3.60734 6.99238 3.58605 7.07231 3.58389C7.15224 3.58174 7.23152 3.59879 7.3035 3.6336C7.37549 3.66842 7.43807 3.72 7.486 3.784L9.87 6.96L14.127 1L14.941 1.581H14.94ZM11 3.657V3H10V5.057L11 3.657ZM7.398 7L8 7.803V13H7V7H7.398ZM4 10.922C4.24959 10.8652 4.46791 10.7149 4.61 10.502L4.943 10H5V13H4V10.922ZM10 9.303C10.3852 9.27169 10.7434 9.09294 11 8.804V13H10V9.303ZM13 6.019V13H14V4.619L13 6.019Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GreaterThanIcon = createCustomIcon({
  name: "Greater than",
  category: "General / Math",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M4.08 3.23a.5.5 0 0 1 .69-.15l7 4.5a.5.5 0 0 1 0 .84l-7 4.5a.5.5 0 0 1-.54-.84L10.575 8 4.23 3.92a.5.5 0 0 1-.15-.69Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const LessThanIcon = createCustomIcon({
  name: "Less than",
  category: "General / Math",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M11.92 3.23a.5.5 0 0 0-.69-.15l-7 4.5a.5.5 0 0 0 0 .84l7 4.5a.5.5 0 0 0 .54-.84L5.425 8l6.345-4.08a.5.5 0 0 0 .15-.69Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const GreaterThanOrEqualIcon = createCustomIcon({
  name: "Greater than or equal to",
  category: "General / Math",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M4.224 2.053a.5.5 0 1 0-.448.894L10.883 6.5l-7.105 3.553a.5.5 0 1 0 .447.894l8-4a.5.5 0 0 0 0-.894l-8-4ZM3.5 13a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const LessThanOrEqualIcon = createCustomIcon({
  name: "Less than or equal to",
  category: "General / Math",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M11.776 2.053a.5.5 0 1 1 .447.894L5.118 6.5l7.105 3.553a.5.5 0 1 1-.447.894l-8-4a.5.5 0 0 1 0-.894l8-4ZM3.5 13a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const NotEqualIcon = createCustomIcon({
  name: "Not equal to",
  category: "General / Math",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M10.955 2.707a.5.5 0 1 0-.91-.414L8.815 5H3.5a.5.5 0 0 0 0 1h4.86l-1.818 4H3.5a.5.5 0 0 0 0 1h2.587l-1.042 2.293a.5.5 0 0 0 .91.414l5-11ZM12.5 10H8.64l-.454 1H12.5a.5.5 0 0 0 0-1Zm-1.587-5-.454 1H12.5a.5.5 0 0 0 0-1h-1.587Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const EqualToIcon = createCustomIcon({
  name: "Equal to",
  category: "General / Math",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3.5 5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Zm0 5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const PivotRowsIcon = createCustomIcon({
  name: "Pivot row",
  category: "Explore / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M5 3H2v2h3V3Zm9 .5H7v1h7v-1Zm0 4H7v1h7v-1Zm-7 4h7v1H7v-1ZM2 7h3v2H2V7Zm3 4H2v2h3v-2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const PivotColumnsIcon = createCustomIcon({
  name: "Pivot column",
  category: "Explore / Actions",
  path: (
    <>
      <path
        d="M13 7v7h-1V7h1ZM8 7v7H7V7h1ZM3 7v7H2V7h1ZM14 3v2h-3V3h3ZM9 3v2H6V3h3ZM4 3v2H1V3h3Z"
        fill="currentColor"
      />
    </>
  ),
});

export const FacetHorizontalIcon = createCustomIcon({
  name: "Facet horizontal",
  category: "Explore / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M5.5 13.5H2v-1h2.5v-9H2v-1h3.5v11Zm8.5-10h-2.5v9H14v1h-3.5v-11H14v1ZM8.5 11h-1V5h1v6Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const FacetVerticalIcon = createCustomIcon({
  name: "Facet vertical",
  category: "Explore / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M13.5 14h-1v-2.5h-9V14h-1v-3.5h11V14ZM11 8.5H5v-1h6v1Zm-7.5-4h9V2h1v3.5h-11V2h1v2.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ColorIcon = createCustomIcon({
  name: "Color",
  category: "Explore / Actions",
  path: (
    <svg fill="none" height="17" width="16" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="5" fill="#5987E0" r="2.5" />
      <circle cx="4.5" cy="11" fill="#FFC940" r="2.5" />
      <circle cx="11.5" cy="11" fill="#FF6E4A" r="2.5" />
    </svg>
  ),
});

export const XAxisIcon = createCustomIcon({
  name: "X-axis",
  category: "Explore / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 2v10h11.5v1H2V2h1Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11.705 15.295a.417.417 0 0 1 0-.59l2.206-2.205-2.206-2.205a.417.417 0 0 1 .59-.59l2.794 2.795-2.794 2.795a.417.417 0 0 1-.59 0Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M6.547 8.5a.513.513 0 0 1-.406-.828l1.973-2.547-1.007-2.327a.571.571 0 1 1 1.057-.431l.76 1.983h.057l1.559-2.14a.513.513 0 1 1 .82.616L9.454 5.288l1.071 2.405a.574.574 0 1 1-1.058.447l-.824-2.064h-.056L6.96 8.29a.513.513 0 0 1-.414.21Z"
        fill="currentColor"
      />
    </>
  ),
});

export const YAxisIcon = createCustomIcon({
  name: "Y-axis",
  category: "Explore / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M4.00016 12.9994V1.49941H3.00016V13.9994H14.0002V12.9994H4.00016Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0.705535 4.29404C0.868253 4.45676 1.13207 4.45676 1.29479 4.29404L3.50016 2.08867L5.70553 4.29404C5.86825 4.45676 6.13207 4.45676 6.29479 4.29404C6.45751 4.13132 6.45751 3.8675 6.29479 3.70478L3.50016 0.910156L0.705535 3.70478C0.542817 3.8675 0.542816 4.13132 0.705535 4.29404Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M12.6663 2.29063C12.7548 2.11259 12.9364 2 13.1352 2V2C13.5286 2 13.7815 2.41766 13.5991 2.76625L10.3786 8.92222C10.2786 9.11482 10.1786 9.27778 10.0786 9.41111C9.98571 9.54444 9.87857 9.65556 9.75714 9.74444C9.64286 9.83333 9.51071 9.8963 9.36071 9.93333C9.21071 9.97778 9.03929 10 8.84643 10H8L8.18214 9.04444H9.2L9.725 8.02222L8.9648 2.61349C8.91925 2.28944 9.17086 2 9.49809 2V2C9.7688 2 9.99743 2.20095 10.0322 2.46942L10.3036 4.56667L10.5071 6.68889H10.5607L11.5357 4.56667L12.6663 2.29063Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SemanticDatasetIcon = createCustomIcon({
  name: "Semantic dataset",
  category: "Data / Assets",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 3v10h10V3z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path d="M3 5h10v1H3z" fill="currentColor" />
      <path d="M3 3h10v2H3z" fill="currentColor" opacity=".3" />
      <path
        d="M6 8H4V7h2zM12 8H7V7h5zM12 12H7v-1h5zM6 12H4v-1h2zM6 10H4V9h2zM12 10H7V9h5z"
        fill="currentColor"
      />
    </>
  ),
});

export const SemanticViewIcon = createCustomIcon({
  name: "Semantic view",
  category: "Data / Assets",
  path: (
    <>
      <path
        d="M13 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM3 6v7h10V6zm0-1h10V3H3z"
        fill="currentColor"
      />
      <path
        d="M6 8H4V7h2zM6 12H4v-1h2zM6 10H4V9h2zM12 8H7V7h5zM12 12H7v-1h5zM8 11H7V8h1zM12 11h-1V8h1z"
        fill="currentColor"
      />
      <path d="M3 3h10v2H3z" fill="currentColor" opacity=".3" />
    </>
  ),
});

export const WarehouseTableIcon = createCustomIcon({
  name: "Warehouse table",
  category: "Data / Assets",
  path: (
    <>
      <path
        d="M13 2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM3 6v7h2V6zm3 0v7h7V6zM3 5h10V3H3z"
        fill="currentColor"
      />
      <path d="M3 3h10v2H3z" fill="currentColor" opacity=".3" />
    </>
  ),
});

export const SemanticGuideIcon = createCustomIcon({
  name: "Semantic guide",
  category: "Data / Assets",
  path: (
    <>
      <path
        d="M13 2C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3C2 2.44772 2.44772 2 3 2H13ZM3 13H13V6H3V13ZM6.5 11C6.77614 11 7 11.2239 7 11.5C7 11.7761 6.77614 12 6.5 12H4.5C4.22386 12 4 11.7761 4 11.5C4 11.2239 4.22386 11 4.5 11H6.5ZM8.5 9C8.77614 9 9 9.22386 9 9.5C9 9.77614 8.77614 10 8.5 10H4.5C4.22386 10 4 9.77614 4 9.5C4 9.22386 4.22386 9 4.5 9H8.5ZM10.5 7C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H10.5ZM3 5H13V3H3V5Z"
        fill="currentColor"
      />
      <path
        d="M3 3.00018L13 3V4.99988L3 5V3.00018Z"
        fill="currentColor"
        opacity=".3"
      />
    </>
  ),
});

export const ReplaceIcon = createCustomIcon({
  name: "Replace",
  category: "Project / Search",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M10.5 14C10.5 14.2761 10.2761 14.5 10 14.5L4.5 14.5C3.67157 14.5 3 13.8284 3 13L3 4.70711L1.35355 6.35355C1.15829 6.54882 0.841709 6.54882 0.646446 6.35355C0.451184 6.15829 0.451185 5.84171 0.646446 5.64645L3.5 2.79289L6.35355 5.64645C6.54882 5.84171 6.54882 6.15829 6.35355 6.35355C6.15829 6.54882 5.84171 6.54882 5.64645 6.35355L4 4.70711L4 13C4 13.2761 4.22386 13.5 4.5 13.5L10 13.5C10.2761 13.5 10.5 13.7239 10.5 14Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.5 2C5.5 1.72386 5.72386 1.5 6 1.5L11.5 1.5C12.3284 1.5 13 2.17157 13 3L13 11.2929L14.6464 9.64645C14.8417 9.45118 15.1583 9.45118 15.3536 9.64645C15.5488 9.84171 15.5488 10.1583 15.3536 10.3536L12.5 13.2071L9.64645 10.3536C9.45119 10.1583 9.45119 9.84171 9.64645 9.64645C9.84171 9.45118 10.1583 9.45118 10.3536 9.64645L12 11.2929L12 3C12 2.72386 11.7761 2.5 11.5 2.5L6 2.5C5.72386 2.5 5.5 2.27614 5.5 2Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const DollarSignIcon = createCustomIcon({
  name: "Dollar sign",
  category: "Workspace / Billing",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M7.5 2.8V1H8.5V2.8H9.6C10.3826 2.8 11.1243 3.13717 11.6645 3.72238C12.2034 4.30625 12.5 5.09017 12.5 5.9H11.5C11.5 5.3307 11.2909 4.79198 10.9297 4.40066C10.5697 4.01069 10.0904 3.8 9.6 3.8H6.4C5.90959 3.8 5.43032 4.01069 5.07035 4.40066C4.70913 4.79198 4.5 5.3307 4.5 5.9C4.5 6.4693 4.70913 7.00802 5.07035 7.39934C5.43032 7.78931 5.90959 8 6.4 8H9.6C10.3826 8 11.1243 8.33717 11.6645 8.92238C12.2034 9.50625 12.5 10.2902 12.5 11.1C12.5 11.9098 12.2034 12.6938 11.6645 13.2776C11.1243 13.8628 10.3826 14.2 9.6 14.2H8.5V16H7.5V14.2H6.4C5.61737 14.2 4.87574 13.8628 4.33554 13.2776C3.79659 12.6938 3.5 11.9098 3.5 11.1H4.5C4.5 11.6693 4.70913 12.208 5.07035 12.5993C5.43032 12.9893 5.90959 13.2 6.4 13.2H9.6C10.0904 13.2 10.5697 12.9893 10.9297 12.5993C11.2909 12.208 11.5 11.6693 11.5 11.1C11.5 10.5307 11.2909 9.99198 10.9297 9.60066C10.5697 9.21069 10.0904 9 9.6 9H6.4C5.61737 9 4.87574 8.66283 4.33554 8.07762C3.79659 7.49375 3.5 6.70983 3.5 5.9C3.5 5.09017 3.79659 4.30625 4.33554 3.72238C4.87574 3.13717 5.61737 2.8 6.4 2.8H7.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const ModeledDataIcon = createCustomIcon({
  name: "Modeled data",
  category: "Data",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M3 14.5C2.44771 14.5 2 14.0523 2 13.5L2 3.5C2 2.94772 2.44771 2.5 3 2.5L5 2.5L6 2.5L13 2.50001C13.5523 2.50001 14 2.94772 14 3.50001L14 13.5C14 14.0523 13.5523 14.5 13 14.5L6 14.5L5 14.5L3 14.5ZM3 3.5L5 3.5L5 13.5L3 13.5L3 3.5ZM13 9L13 13.5L6 13.5L6 8.99999L13 9ZM13 8.00001L6 8L6 3.5L13 3.50001L13 8.00001ZM7 11C7 10.7239 7.22386 10.5 7.5 10.5L9.5 10.5C9.77614 10.5 10 10.7239 10 11C10 11.2761 9.77614 11.5 9.5 11.5L7.5 11.5C7.22386 11.5 7 11.2761 7 11ZM7.5 5.5C7.22386 5.5 7 5.72386 7 6C7 6.27614 7.22386 6.5 7.5 6.5L9.5 6.5C9.77614 6.5 10 6.27614 10 6C10 5.72386 9.77614 5.5 9.5 5.5L7.5 5.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});

export const DrillDownIcon = createCustomIcon({
  name: "Drill down",
  category: "Explore / Actions",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M8.24 1.061a.5.5 0 0 0-.48 0l-5.5 3a.5.5 0 0 0 0 .878l5.5 3a.5.5 0 0 0 .48 0l5.5-3a.5.5 0 0 0 0-.878l-5.5-3ZM3.543 4.5 8 2.07l4.456 2.43L8 6.93 3.544 4.5Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M5.812 11.97 7.5 13.32V9.36a.5.5 0 1 1 1 0v3.96l1.687-1.35a.5.5 0 0 1 .625.78L8 15l-2.813-2.25a.5.5 0 0 1 .625-.78Z"
        fill="currentColor"
      />
    </>
  ),
});

export const DrillUpIcon = createCustomIcon({
  name: "Drill up",
  category: "Explore / Actions",
  path: (
    <path
      clipRule="evenodd"
      d="M10.89 4.312a.5.5 0 0 1-.702.078L8.5 3.04V8a.5.5 0 1 1-1 0V3.04L5.812 4.39a.5.5 0 1 1-.624-.78L8 1.36l2.812 2.25a.5.5 0 0 1 .078.702ZM5.257 9.929a.5.5 0 0 0-.514-.858l-2.5 1.5a.5.5 0 0 0 .018.868l5.5 3a.5.5 0 0 0 .478 0l5.5-3a.5.5 0 0 0 .018-.868l-2.5-1.5a.5.5 0 1 0-.514.858l1.75 1.05L8 13.43l-4.494-2.45 1.751-1.051Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const GoToNotebookIcon = createCustomIcon({
  name: "Go to notebook",
  category: "Project / Navigation",
  path: (
    <>
      <path
        d="M2.5 3a1 1 0 0 1 1-1H10a.5.5 0 0 1 .38.175l3 3.5A.5.5 0 0 1 13.5 6v1h-1v-.815L9.77 3H3.5v10H7l-1 1H3.5a1 1 0 0 1-1-1V3Z"
        fill="currentColor"
      />
      <path
        d="M5.5 8H9v1H5.5v2H9l-1 1H5.5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1ZM4.5 6.5A.5.5 0 0 1 5 6h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Z"
        fill="currentColor"
      />
      <path
        d="M13.5 12a.5.5 0 0 1-.5-.5V9.707l-4.646 4.647a.5.5 0 0 1-.708-.707L12.293 9H10.5a.5.5 0 1 1 0-1H14v3.5a.5.5 0 0 1-.5.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const SortIcon = createCustomIcon({
  name: "Sort",
  category: "General / Sorting",
  path: (
    <path
      d="M13.5 10.5a.5.5 0 0 1 0 1h-11a.5.5 0 1 1 0-1h11Zm-4-3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h7Zm-4-3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Z"
      fill="currentColor"
    />
  ),
});

export const NewThreadIcon = createCustomIcon({
  name: "New thread",
  category: "Threads / General",
  tags: ["duotone", "create"],
  path: (
    <>
      <path
        d="M10.4999 8.50003C10.4999 9.0523 10.0522 9.5 9.49991 9.5H5.4999H6.49989V12.5C6.49989 13.0523 6.94761 13.5 7.49989 13.5H10.4999L12.4999 15V13.5H13.4999C14.0521 13.5 14.4999 13.0523 14.4999 12.5L14.4999 7.50001C14.4999 6.94772 14.0522 6.5 13.4999 6.5H10.5L10.4999 8.50003Z"
        fill="currentColor"
        fillOpacity="0.3"
      />
      <path
        d="M14 7.27583C14 7.00921 13.7761 6.79308 13.5 6.79307H11V8.24134C11 9.04116 10.3284 9.68958 9.5 9.68961H7V12.1034C7 12.37 7.22386 12.5861 7.5 12.5861H10.5L10.5801 12.5927C10.6593 12.6052 10.7349 12.6354 10.7998 12.6823L12 13.5507V13.0689C12 12.8023 12.2239 12.5861 12.5 12.5861H13.5C13.7761 12.5861 14 12.37 14 12.1034V7.27583ZM10 2.44827C9.99975 2.18157 9.7757 1.96551 9.5 1.96551H2.5C2.22386 1.96551 2 2.18165 2 2.44827V8.24134C2 8.50796 2.22386 8.72409 2.5 8.72409H3.5C3.77611 8.72414 4 8.94026 4 9.20685V9.97247L5.14648 8.86553L5.22266 8.80518C5.2771 8.77015 5.33817 8.74586 5.40234 8.73352L5.5 8.72409H9.5C9.77611 8.72407 9.99999 8.50794 10 8.24134V2.44827ZM11 5.82756H13.5C14.3284 5.82757 15 6.47598 15 7.27583V12.1034C15 12.9032 14.3284 13.5516 13.5 13.5517H13V14.5172C13 14.7 12.893 14.8672 12.7236 14.949C12.5544 15.0307 12.3517 15.0132 12.2002 14.9037L10.333 13.5517H7.5C6.67157 13.5517 6 12.9032 6 12.1034V9.68961H5.70703L3.85352 11.4792C3.71052 11.6173 3.49543 11.6586 3.30859 11.5839C3.12176 11.5091 3 11.3331 3 11.1379V9.68961H2.5C1.67157 9.68961 1 9.0412 1 8.24134V2.44827C1 1.64841 1.67157 1 2.5 1H9.5C10.3286 1 10.9998 1.6489 11 2.44827V5.82756Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ContextStudioIcon = createCustomIcon({
  name: "Context Studio",
  category: "Workspace / Curation",
  path: (
    <>
      <rect
        fill="currentColor"
        height="6"
        opacity="0.3"
        width="5"
        x="3"
        y="5"
      />
      <path
        d="M8.5 2C8.77614 2 9 2.22386 9 2.5V13.5C9 13.7761 8.77614 14 8.5 14C8.22386 14 8 13.7761 8 13.5V12H5L4.8457 11.9961C3.26055 11.9158 2 10.6051 2 9V7C2 5.34315 3.34315 4 5 4H8V2.5C8 2.22386 8.22386 2 8.5 2ZM11 4C12.6569 4 14 5.34315 14 7V9C14 10.6051 12.7394 11.9158 11.1543 11.9961L11 12H10V11H11C12.1046 11 13 10.1046 13 9V7C13 5.89543 12.1046 5 11 5H10V4H11ZM5 5C3.89543 5 3 5.89543 3 7V9C3 10.1046 3.89543 11 5 11H8V5H5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const InspectorIcon = createCustomIcon({
  name: "Inspector",
  category: "Workspace / Curation",
  path: (
    <path
      d="M5.196 2.51a2 2 0 0 1 1.652 1.224q.02.052.037.105a2 2 0 0 1 .35-.187c.242-.1.502-.152.765-.152l.196.01a2 2 0 0 1 .918.329q.022-.064.048-.127a2 2 0 0 1 1.924-1.21l.201.019A2 2 0 0 1 13 4.456l.911 5.89q.022.075.04.15.05.245.05.504a2.5 2.5 0 0 1-5 0v-.5a1 1 0 0 0-.075-.383 1 1 0 0 0-.826-.613L8 9.5a1 1 0 0 0-.195.019 1 1 0 0 0-.512.274l-.066.072A1 1 0 0 0 7 10.5v.5a2.5 2.5 0 1 1-4.89-.735L3.05 4l.014.002a2 2 0 0 1 .172-.445A2 2 0 0 1 5 2.5zM4.5 9.5a1.5 1.5 0 0 0-1.413 1l-.085.562A1.5 1.5 0 1 0 4.5 9.5m7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M4.901 3.504a1 1 0 0 0-.608.289l-.066.072A1 1 0 0 0 4 4.5h-.014l-.642 4.283A2.49 2.49 0 0 1 6 9.003V4.5a1 1 0 0 0-.075-.383 1 1 0 0 0-.826-.613L5 3.5a1 1 0 0 0-.099.004m6.142-.003a1 1 0 0 0-.395.063l-.092.04q-.136.068-.247.173l-.07.074a1 1 0 0 0-.158.255l-.035.095Q10 4.346 10 4.498h-.272l.001.002H10v4.503q.05-.04.102-.076c.4-.27.88-.427 1.398-.427a2.5 2.5 0 0 1 1.157.285l-.65-4.2h-.01q.012-.151-.02-.3l-.027-.098a1 1 0 0 0-.136-.268l-.063-.08a1 1 0 0 0-.23-.193l-.09-.048a1 1 0 0 0-.287-.087zM7.901 4.504a1 1 0 0 0-.608.289l-.066.072A1 1 0 0 0 7 5.5v3.27l.057-.034A2 2 0 0 1 8 8.5l.196.01a2 2 0 0 1 .747.226q.03.016.057.034V5.5a1 1 0 0 0-.075-.383 1 1 0 0 0-.826-.613L8 4.5a1 1 0 0 0-.099.004"
      fill="currentColor"
    />
  ),
});

export const PerformanceIcon = createCustomIcon({
  name: "Performance",
  category: "Project / View",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M9.69955 6.27051C9.86047 6.12756 10.0951 6.10346 10.2816 6.21094C10.4681 6.31864 10.5652 6.53414 10.5218 6.74512C10.5217 6.74578 10.5201 6.74788 10.5199 6.74902C10.5193 6.75153 10.5189 6.75601 10.5179 6.76074C10.5159 6.77019 10.5128 6.78424 10.5091 6.80176C10.5015 6.83761 10.4904 6.88982 10.4759 6.95605C10.4468 7.08944 10.405 7.28113 10.3509 7.51172C10.243 7.97238 10.0887 8.59508 9.90366 9.23926C9.71929 9.88103 9.50031 10.5567 9.26303 11.1182C9.14456 11.3985 9.0168 11.6624 8.88022 11.8828C8.74971 12.0934 8.58355 12.3095 8.37436 12.4482C7.79267 12.8338 7.12534 12.9342 6.58139 12.6201C6.03756 12.306 5.79025 11.678 5.83334 10.9814C5.84892 10.7308 5.95448 10.4791 6.07162 10.2607C6.19422 10.0323 6.3579 9.78955 6.54135 9.54688C6.909 9.06061 7.38533 8.53331 7.84897 8.05273C8.31435 7.57036 8.77647 7.12558 9.12143 6.80176C9.29415 6.63963 9.43844 6.50696 9.5394 6.41504C9.58949 6.36943 9.62933 6.33408 9.65658 6.30957C9.66995 6.29755 9.68064 6.28769 9.68783 6.28125C9.69139 6.27807 9.69472 6.27514 9.69662 6.27344C9.69753 6.27263 9.69905 6.27095 9.69955 6.27051ZM8.56967 8.74707C8.1176 9.21565 7.67266 9.70973 7.34018 10.1494C7.1737 10.3696 7.04177 10.567 6.95248 10.7334C6.85784 10.9098 6.83451 11.0093 6.83237 11.0439C6.805 11.4882 6.96349 11.6857 7.08139 11.7539C7.19931 11.822 7.45028 11.8612 7.82162 11.6152C7.85057 11.596 7.92434 11.5254 8.02963 11.3555C8.12906 11.195 8.2347 10.9827 8.34213 10.7285C8.55672 10.2207 8.7629 9.58884 8.94272 8.96289C9.02276 8.68426 9.09534 8.40868 9.16244 8.14941C8.97164 8.33699 8.77076 8.53864 8.56967 8.74707Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M7.99936 2C9.14963 2.00006 10.2851 2.26468 11.3167 2.77344C12.3483 3.28224 13.2493 4.02203 13.9496 4.93457C14.6497 5.84716 15.1304 6.90897 15.3548 8.03711C15.5792 9.16529 15.5412 10.3303 15.2435 11.4414C15.1719 11.7078 14.8977 11.8661 14.6312 11.7949C14.3647 11.7234 14.2064 11.4492 14.2777 11.1826C14.5357 10.2196 14.5688 9.20925 14.3744 8.23145C14.1798 7.2539 13.7633 6.33375 13.1566 5.54297C12.5497 4.75207 11.7684 4.11089 10.8744 3.66992C9.98029 3.22903 8.99622 3.00006 7.99936 3C7.00248 3 6.01846 3.22907 5.12436 3.66992C4.23023 4.11086 3.44906 4.75207 2.84213 5.54297C2.23536 6.33378 1.8189 7.25385 1.62436 8.23145C1.42985 9.20931 1.46299 10.2196 1.72104 11.1826C1.79218 11.449 1.63379 11.7233 1.36752 11.7949C1.10093 11.8664 0.826864 11.7079 0.755217 11.4414C0.457487 10.3303 0.419499 9.16535 0.643889 8.03711C0.868313 6.90892 1.34894 5.84718 2.04916 4.93457C2.74943 4.02203 3.65035 3.28221 4.68198 2.77344C5.71366 2.26473 6.84907 2 7.99936 2Z"
        fill="currentColor"
      />
    </>
  ),
});

export const EvalsIcon = createCustomIcon({
  name: "Evals",
  category: "Workspace / Curation",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.24963C8.27604 1.24963 8.49984 1.47363 8.5 1.74963V3.41663H13.2119L14.8555 8.11877H15.5C15.4999 9.77555 14.1568 11.4518 12.5 11.4518C10.8432 11.4518 9.50013 9.77555 9.5 8.11877H10.1445L11.4385 4.41663H8.5V13.7496H10.5V14.7496H5.5V13.7496H7.5V4.41663H4.56152L5.85547 8.11877H6.5C6.49987 9.77555 5.15677 11.4518 3.5 11.4518C1.84323 11.4518 0.500132 9.77555 0.5 8.11877H1.14453L2.78809 3.41663H7.5V1.74963C7.50016 1.47363 7.72396 1.24963 8 1.24963ZM10.7305 9.11877C10.8344 9.34553 10.9691 9.5616 11.1338 9.75159C11.5303 10.2089 12.0221 10.4518 12.5 10.4518C12.9779 10.4518 13.4697 10.2089 13.8662 9.75159C14.0309 9.5616 14.1656 9.34553 14.2695 9.11877H10.7305ZM1.73047 9.11877C1.83438 9.34553 1.96914 9.5616 2.13379 9.75159C2.53032 10.2089 3.02211 10.4518 3.5 10.4518C3.97789 10.4518 4.46968 10.2089 4.86621 9.75159C5.03086 9.5616 5.16562 9.34553 5.26953 9.11877H1.73047ZM2.2041 8.1178H4.7959L3.50195 4.41663H3.49805L2.2041 8.1178ZM11.2041 8.1178H13.7959L12.502 4.41663H12.498L11.2041 8.1178Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

export const KnowledgeIcon = createCustomIcon({
  name: "Knowledge",
  category: "Workspace / Curation",
  path: (
    <path
      clipRule="evenodd"
      d="M8 1.5C8.92871 1.50006 9.75833 2.41466 10.3086 3.85059C12.115 3.43618 13.5597 3.6292 14.0625 4.5C14.5557 5.35454 14.0298 6.66773 12.8174 7.99902C14.0305 9.33071 14.5559 10.6452 14.0625 11.5C13.5597 12.3708 12.1151 12.5629 10.3086 12.1484C9.75833 13.5849 8.9289 14.4999 8 14.5C7.07094 14.5 6.23974 13.5852 5.68945 12.1484C3.88385 12.5623 2.44009 12.3705 1.9375 11.5C1.44421 10.6454 1.96893 9.33048 3.18164 7.99902C1.96962 6.66795 1.44441 5.35442 1.9375 4.5C2.44007 3.62952 3.88394 3.43678 5.68945 3.85059C6.23974 2.41427 7.07112 1.5 8 1.5ZM8 11.3623C7.5444 11.5648 7.09555 11.7372 6.66016 11.8789C6.70131 11.982 6.74316 12.0815 6.78711 12.1768C7.29589 13.2791 7.79674 13.5 8 13.5C8.20332 13.4999 8.70418 13.279 9.21289 12.1768C9.25679 12.0816 9.29776 11.9818 9.33887 11.8789C8.90375 11.7373 8.45529 11.5647 8 11.3623ZM3.89355 8.70898C3.73225 8.88795 3.58392 9.06285 3.4541 9.23633C3.0896 9.72354 2.88208 10.144 2.79785 10.4668C2.71544 10.7832 2.76572 10.9342 2.80371 11C2.84171 11.0658 2.94739 11.1846 3.2627 11.2715C3.58439 11.36 4.05207 11.3914 4.65625 11.3193C4.88758 11.2917 5.13087 11.2454 5.38574 11.1895C5.2643 10.7231 5.16914 10.2211 5.10352 9.69238C4.66362 9.37325 4.25868 9.04302 3.89355 8.70898ZM12.1055 8.70898C11.7403 9.04301 11.3354 9.37327 10.8955 9.69238C10.8299 10.2211 10.7347 10.7231 10.6133 11.1895C10.8687 11.2456 11.113 11.2917 11.3447 11.3193C11.9487 11.3913 12.4157 11.3599 12.7373 11.2715C13.0527 11.1846 13.1583 11.0658 13.1963 11C13.2343 10.9342 13.2846 10.7833 13.2021 10.4668C13.1179 10.144 12.9114 9.72354 12.5469 9.23633C12.4169 9.06254 12.2671 8.88828 12.1055 8.70898ZM6.24121 10.4434C6.27529 10.6087 6.31129 10.7694 6.35156 10.9248C6.50005 10.8765 6.65103 10.8251 6.80371 10.7686C6.70259 10.713 6.60112 10.656 6.5 10.5977C6.41258 10.5472 6.32682 10.4949 6.24121 10.4434ZM9.5 10.5977C9.39884 10.6561 9.29745 10.7129 9.19629 10.7686C9.34867 10.825 9.49926 10.8765 9.64746 10.9248C9.68766 10.7697 9.72378 10.6093 9.75781 10.4443C9.67257 10.4956 9.58703 10.5474 9.5 10.5977ZM8 5.74121C7.67048 5.90017 7.33533 6.07398 7 6.26758C6.66685 6.45992 6.35049 6.66172 6.0498 6.86621C6.01776 7.23091 6 7.60983 6 8C6 8.38983 6.01782 8.76841 6.0498 9.13281C6.35061 9.3374 6.6667 9.53999 7 9.73242C7.33507 9.92587 7.67072 10.098 8 10.2568C8.32928 10.098 8.66493 9.92587 9 9.73242C9.33301 9.54016 9.64864 9.33722 9.94922 9.13281C9.98121 8.76839 10 8.38985 10 8C10 7.6098 9.98127 7.23093 9.94922 6.86621C9.64876 6.6619 9.33286 6.45976 9 6.26758C8.66467 6.07398 8.32953 5.90017 8 5.74121ZM8 7C8.55224 7.00005 9 7.44775 9 8C9 8.55225 8.55224 8.99995 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7ZM5.00391 7.65039C4.86437 7.76618 4.73166 7.8837 4.60352 8C4.73151 8.11617 4.86455 8.23297 5.00391 8.34863C5.00109 8.2332 5 8.11696 5 8C5 7.88271 5.00107 7.76615 5.00391 7.65039ZM10.9951 7.65039C10.9979 7.76615 11 7.88271 11 8C11 8.11696 10.9979 8.23319 10.9951 8.34863C11.1347 8.23282 11.2683 8.11633 11.3965 8C11.2682 7.88353 11.1349 7.76634 10.9951 7.65039ZM4.65625 4.68066C4.05207 4.6086 3.58439 4.64004 3.2627 4.72852C2.94741 4.81537 2.84171 4.93419 2.80371 5C2.76572 5.06589 2.71543 5.21686 2.79785 5.5332C2.88208 5.85603 3.0896 6.27646 3.4541 6.76367C3.58379 6.93697 3.73244 7.11126 3.89355 7.29004C4.25868 6.95603 4.66363 6.62574 5.10352 6.30664C5.16918 5.77795 5.26426 5.27586 5.38574 4.80957C5.13094 4.75362 4.88752 4.70827 4.65625 4.68066ZM12.7373 4.72852C12.4157 4.64007 11.9487 4.60867 11.3447 4.68066C11.113 4.7083 10.8686 4.75348 10.6133 4.80957C10.7348 5.27589 10.8298 5.77791 10.8955 6.30664C11.3354 6.62572 11.7403 6.95604 12.1055 7.29004C12.2669 7.11093 12.417 6.93728 12.5469 6.76367C12.9114 6.27646 13.1179 5.85603 13.2021 5.5332C13.2846 5.21673 13.2343 5.06585 13.1963 5C13.1583 4.93418 13.0527 4.81537 12.7373 4.72852ZM6.35156 5.07422C6.31135 5.2293 6.27525 5.38971 6.24121 5.55469C6.32654 5.50334 6.41287 5.45265 6.5 5.40234C6.60125 5.34389 6.70247 5.28612 6.80371 5.23047C6.65104 5.17397 6.50004 5.12256 6.35156 5.07422ZM9.64746 5.07422C9.49927 5.12248 9.34866 5.17408 9.19629 5.23047C9.29757 5.28614 9.39872 5.34387 9.5 5.40234C9.58674 5.45242 9.67285 5.5026 9.75781 5.55371C9.72382 5.38905 9.6876 5.22901 9.64746 5.07422ZM8 2.5C7.79674 2.5 7.29589 2.72091 6.78711 3.82324C6.74328 3.91821 6.7012 4.01737 6.66016 4.12012C7.09553 4.2618 7.54442 4.4342 8 4.63672C8.45527 4.43433 8.90378 4.26175 9.33887 4.12012C9.29786 4.01748 9.25667 3.91811 9.21289 3.82324C8.70418 2.72104 8.20332 2.50007 8 2.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});

// TODO(CUR-1007): decide on icon
export const OrgGuideFileIcon = DocsIcon;

export const BlankIcon = createCustomIcon({
  name: "Blank",
  category: "General / Misc",
  tags: ["blank", "empty"],
  path: <></>,
});

export const GitTagIcon = CategoryTagIcon;
